<template>
  <div class="page-content">

    <!-- model for Liste de garantie -->
    <div class="Modal PropsModal" id="somme_garanties">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <h2>Liste de garantie</h2>

        </div>
        <div class="ExitBtn" @click="openOptionsModal('somme_garanties', false)">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <div class="FormContainer">
          <template v-for="(garantie, index) in DetailsGarantie2">
            <div class="DataFields" :key="index">
              <div class="DataRow">
                <div class="FieldName">
                  <h4>Prêt</h4>
                </div>
                <div class="FieldValue">
                  <p>{{ garantie.pret_name }}</p>
                </div>
              </div>
              <div class="DataRow">
                <div class="FieldName">
                  <h4>Montant à garantir</h4>
                </div>
                <div class="FieldValue">
                  <p>{{ garantie.montant_to_garanti }}</p>
                </div>
              </div>
              <div class="DataRow">
                <div class="FieldName">
                  <h4>Type du garanti</h4>
                </div>
                <div class="FieldValue">
                  <p>{{ garantie.type }}</p>
                </div>
              </div>
              <div class="DataRow">
                <div class="FieldName">
                  <h4>Frais du garanti</h4>
                </div>
                <div class="FieldValue">
                  <p>{{ garantie.frais_garnati }}</p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- model for Taux Fixe -->
    <div class="Modal TauxFixeModal" id="ti">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <h2>Taux fixe</h2>
        </div>
        <div class="ExitBtn" @click="openOptionsModal('ti', false)">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <div class="FormContainer">
          <div class="InputBox">
            <label>Taux prêt principale *</label>
            <input v-if="TauxFixUpdate.ti_relais == 1" type="number" v-model="TauxFixUpdate.ti_relais" step="0.01"
              required />
            <input v-else type="number" v-model="TauxFixUpdate.ti" step="0.01" required />
          </div>
          <div class="ActionBar">
            <button class="Btn" @click="openOptionsModal('ti', false)">Fermer</button>
            <button class="Btn"
              @click="updateTauxProposition(indexForUpdate, idPropositionFoUpdate, TauxFixUpdate); openOptionsModal('ti', false)">Confirmer</button>
          </div>
        </div>
      </div>
    </div>

    <!-- model for Taux Assurance -->
    <div class="Modal TauxAssuranceModal" id="ta">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <h2>Taux Assurance</h2>
        </div>
        <div class="ExitBtn" @click="openOptionsModal('ta', false)">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <div class="FormContainer">
          <div class="InputBox">
            <label>Taux Assurance Emprunteur</label>
            <input type="number" v-model="TauxAssuranceUpdate.ta_emp" step="0.01" required />
          </div>
          <div class="InputBox" v-if="TauxAssuranceUpdate.ta_coemp != null">
            <label>Taux Assurance CoEmprunteur</label>
            <input type="number" v-model="TauxAssuranceUpdate.ta_coemp2" step="0.01" required />
          </div>
          <div class="ActionBar">
            <button class="Btn" @click="openOptionsModal('ta', false)">Fermer</button>
            <button class="Btn"
              @click="updateTauxAssuranceProposition(indexForUpdate, idPropositionFoUpdate, TauxAssuranceUpdate); openOptionsModal('ta', false)">Confirmer</button>
          </div>
        </div>
      </div>
    </div>

    <!-- model for Cout totale -->
    <div class="Modal CoutTotalModal" id="cout_pret">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <h2>Détails coût totale du crédit</h2>
        </div>
        <div class="ExitBtn" @click="openOptionsModal('cout_pret', false)">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <div class="FormContainer">
          <template v-for="(detailsCout, index) in DetailsCoutTotaleProjet2.cout_prets">
            <div class="DataFields" :key="index">
              <div class="DataRow">
                <div class="FieldName">
                  <h4>Nom du Prêt</h4>
                </div>
                <div class="FieldValue">
                  <p>{{ detailsCout.pret_name }}</p>
                </div>
              </div>
              <div class="DataRow">
                <div class="FieldName">
                  <h4>Coût d'intrêt</h4>
                </div>
                <div class="FieldValue">
                  <p>{{ detailsCout.cout_interet.toFixed(2).toLocaleString('fr') }} €</p>
                </div>
              </div>
              <div class="DataRow">
                <div class="FieldName">
                  <h4>Coût d'assurance</h4>
                </div>
                <div class="FieldValue">
                  <p>{{ detailsCout.cout_assurance.toFixed(2).toLocaleString('fr') }} €</p>
                </div>
              </div>
            </div>
          </template>
          <br><br>
          <div class="DataRow">
            <div class="FieldName">
              <h4>Coût garantie</h4>
            </div>
            <div class="FieldValue">
              <p>{{ DetailsCoutTotaleProjet2.cout_supp.cout_garanti.toFixed(2).toLocaleString('fr') }} €</p>
            </div>
          </div>
          <div class="DataRow">
            <div class="FieldName">
              <h4>Coût frais dossier</h4>
            </div>
            <div class="FieldValue">
              <p>{{ DetailsCoutTotaleProjet2.cout_supp.cout_frais_dossier.toFixed(2).toLocaleString('fr') }} €</p>
            </div>
          </div>
          <div class="DataRow">
            <div class="FieldName">
              <h4>Coût courtage</h4>
            </div>
            <div class="FieldValue">
              <p>{{ DetailsCoutTotaleProjet2.cout_supp.cout_courtage.toFixed(2).toLocaleString('fr') }} €</p>
            </div>
          </div>
          <div class="DataRow Somme">
            <div class="FieldName">
              <h4>Coût totale</h4>
            </div>
            <div class="FieldValue">
              <p>{{ DetailsCoutTotaleProjet2.cout_supp.cout_total.toFixed(2).toLocaleString('fr') }} €</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- model for Prime Assurance -->
    <div class="Modal PrimeAssuranceModal" id="PrimeAssurance">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <h2></h2>
        </div>
        <div class="ExitBtn" @click="openOptionsModal('PrimeAssurance', false)">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <div class="FormContainer">
          <h4>Emprunteur</h4>
          <div class="InputBox">
            <label>Quotité %</label>
            <select v-model="assuranceCustomer.quotite">
              <option v-for="taux in tauxRange" :key="taux" :value="taux">{{ taux }}%</option>
            </select>
          </div>
          <template v-if="assuranceCoemp != {}">
            <h4>Co-Emprunteur</h4>
            <div class="InputBox">
              <label>Quotité %</label>
              <select v-model="assuranceCoemp.quotite">
                <option v-for="taux in tauxRange" :key="taux" :value="taux">{{ taux }}%</option>
              </select>
            </div>
          </template>
          <div class="ActionBar">
            <button class="Btn" @click="openOptionsModal('PrimeAssurance', false)">Fermer</button>
            <button class="Btn" @click="updateAssurance(); openOptionsModal('PrimeAssurance', false)">Confirmer</button>
          </div>
        </div>
      </div>
    </div>

    <!-- model for Détails Faisabilite -->
    <div class="Modal FaisabiliteModal" id="FaisabiliteM">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <h2>Détails Faisabilite</h2>
        </div>
        <div class="ExitBtn" @click="openOptionsModal('FaisabiliteM', false)">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <div class="FormContainer">
          <table>
            <thead>
              <tr>
                <th class="vide"></th>
                <th>Critére Banque</th>
                <th>Valeur Simulation</th>
                <th>Critere respecté</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(Details, index) in DetailsFaisabilite" :key="index">
                <template v-if="Details.critere_text !== undefined">
                  <td class="FirstField">{{ Details.critere_text }}</td>
                  <td>{{ Details.cBank }}</td>
                  <td>{{ Details.cSimulation }}</td>
                  <td v-if="Details.is_ignored || Details.critere === 'sautCharge'
                    " class="options-td">
                    <b-badge class="mb-1" pill variant="light"
                      style="background-color: white !important; padding: 5px 10px; color:black; border-radius: 5px;">N/A</b-badge>
                  </td>
                  <td v-else aria-colindex="1" data-label="" role="cell" class="options-td">
                    <b-badge class="mb-1" pill variant="success" v-if="Details.isValid == true"
                      style="background-color: limegreen!important; padding: 5px 10px; border-radius: 5px;">Oui</b-badge>
                    <b-badge class="mb-1 danger" pill variant="danger"
                      style="background-color: red !important; padding: 5px 10px; border-radius: 5px;" v-else>Non</b-badge>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- model for Faisabilite -->
    <div class="Modal AssuranceDelegueeModal" id="AssuranceDelegueeM">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <h2>CIC: Companies assurance déléguée</h2>
        </div>
        <div class="ExitBtn" @click="openOptionsModal('AssuranceDelegueeM', false); closeCollapseSections()">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <div class="FormContainer">

          <b-button v-b-toggle.collapse-1 variant="primary" class="ToggleBtn">
            Type d'opération
            <fa-icon class="icon" :icon="'chevron-down'"></fa-icon>
          </b-button>
          <b-collapse id="collapse-1" class="mt-2">
            <b-card class="CollapseCard">
              <div class="inputBox">
                <label>Choix de l'offre</label>
                <select v-model="typeAssurance">
                  <option v-for="(item, index) in typeAssurancesList" :key="index" :value="item.value">{{ item.text }}</option>
                </select>
              </div>
            </b-card>
          </b-collapse>


          <b-button v-b-toggle.collapse-2 variant="primary" class="ToggleBtn">
            Dmprunteur(s)
            <fa-icon class="icon" :icon="'chevron-down'"></fa-icon>
          </b-button>
          <b-collapse id="collapse-2" class="mt-2">
            <b-card>
              <div class="FormSelection">
                <h4>Emprunteur</h4>
                <div class="checkboxContainer">
                  <input type="checkbox" />
                  <label>Fumeur ou ancien fumeur</label>
                </div>
                <div class="checkboxContainer">
                  <input type="checkbox" />
                  <label>Travail manuel</label>
                </div>
                <div class="checkboxContainer">
                  <input type="checkbox" />
                  <label>Travail en hauteur >= 3 mètres</label>
                </div>
                <div class="checkboxContainer">
                  <input type="checkbox" />
                  <label>Déplacements Profesionnels > 20000 km par an</label>
                </div>
                <div class="checkboxContainer">
                  <input type="checkbox" />
                  <label>Garantie Dos</label>
                </div>
                <div class="checkboxContainer">
                  <input type="checkbox" />
                  <label>Garantie Psy</label>
                </div>
                <div class="checkboxContainer">
                  <input type="checkbox" />
                  <label>Garantie Perte d'emploi</label>
                </div>

                <div class="InputsGrid">
                  <div class="Row">
                    <div class="inputBox">
                      <label>Quotité %</label>
                      <select>
                        <option v-for="(item, index) in tauxRange" :key="index" :value="item">{{ item }}</option>
                      </select>
                    </div>
                    <div class="inputBox">
                      <label>Tarif %</label>
                      <select>
                        <option v-for="(item, index) in Tarifs" :key="index" :value="item.text">{{ item.text }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="Row">
                    <div class="inputBox">
                      <label>Franchise ITT/IPT</label>
                      <select>
                        <option>30 jours</option>
                        <option>60 jours</option>
                        <option>90 jours</option>
                        <option>120 jours</option>
                        <option>180 jours</option>
                      </select>
                    </div>
                    <div class="inputBox">
                      <label>Garantie</label>
                      <select>
                        <option>DC/PTIA</option>
                        <option>DC/PTIA/ITP/ITT/IPT>66%</option>
                        <option>DC/PTIA/ITP/ITT/IPT/IPP>33%</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </b-collapse>


          <!-- <div v-if="!doneAssuranceList">
            <div class="container mb-2">
              <img style="margin-left: 40%" class="img_logo_banque2" :src="loadingAssuranceList.logo" />
            </div>
            <b-progress height="1rem" :value="getValueAssurance(loadingAssuranceList.name)" :max="max" class="mb-3"></b-progress>
          </div> -->

          <button class="updateBtn">
            <fa-icon class="icon" :icon="'arrows-rotate'"></fa-icon>
            Mise à jour
          </button>

          <table>
            <thead>
              <tr>
                <th>Nom de la compagnie</th>
                <th>Montant moyenne d'assurance</th>
                <th>Coût total prime</th>
                <th>Cotisations sur 1ére année</th>
                <th>Cotisations les 7 autres année</th>
                <th>Commission sur 1 année</th>
                <th>Commission sur 8 ans</th>
                <th>Tarif</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>TEST </td>
                <td>TEST e</td>
                <td>TEST </td>
                <td>TEST </td>
                <td>TEST</td>
                <td>TEST </td>
                <td>TES</td>
                <td>TEST</td>
                <td>TEST</td>
              </tr>
              <tr>
                <td colspan="9">aucune assurance générée</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- model for Options input info -->
    <div class="Modal" id="OptionsModal">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <fa-icon class="icon" :icon="'info'"></fa-icon>
          <h2>Liste des options</h2>
        </div>
        <div class="ExitBtn" @click="openOptionsModal('OptionsModal', false)">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <p><strong>Prix modifié :</strong> cette option permet de retourner uniquement les annonces dont le prix a changé
          (augmentation ou baisse).</p>
        <p><strong>Retirées incluses :</strong> cette option permet d'inclure dans la recherche les annonces qui ont été
          retirées du moteur de recherche parce qu'elles ont été supprimées des plateformes.</p>
        <p><strong>Retirées uniquement :</strong> cette option permet de retourner uniquement les annonces qui ont été
          retirées du moteur de recherche parce qu'elles ont été supprimées des plateformes.</p>
        <p><strong>Republiées uniquement :</strong> cette option permet de retourner uniquement les annonces qui ont été
          republiées sur la plateforme immobilière (avec au moins 30 jours d'écart avec la publication précédente).</p>
        <p><strong>Valeurs manquantes incluses : </strong> cette option permet d'inclure dans la recherche les annonces
          dont la valeur filtrée est manquante (exemple : lors d'une recherche avec un prix minimum ou maximum, les
          annonces sans prix renseigné seront aussi retournées).</p>
        <p><strong>Meublé/Non meublé :</strong> cette option est soit spécifiée par l'annonceur, soit déterminée par la
          présence du mot-clé "meublé" dans la description.</p>
        <p><strong>Ancien/Neuf :</strong> cette option n'est pas toujours spécifiée par l'annonceur et est souvent
          inexacte (le bien marqué comme ancien est en fait neuf). Pour rémédier à cela, la lecture de nombreux mots-clés
          dans la description permet de déterminer si le bien est neuf.</p>
        <p><strong>Travaux à prévoir/Sans travaux à prévoir : </strong> cette option est déterminée par la présence des
          mots-clés "travaux à prévoir", "travaux à faire", "travaux à réaliser", "prévoir travaux", "à rénover", etc dans
          la description.</p>
        <p><strong>Constructible/non constructible : </strong> cette option est déterminée par la présence du mot-clé
          "constructible" dans la description.</p>
        <p><strong>Divisible : </strong> cette option est déterminée par la présence du mot-clé "divisible" dans la
          description.</p>
        <p><strong>Vendu loué/Vendu libre :</strong> cette option est déterminée par la présence des mots-clés "vendu
          loué" ou "vendu occupé" dans la description.</p>
        <p><strong>Viager/Sans viager :</strong> cette option est déterminée par la présence du mot-clé "viager" dans la
          description. Les ventes à terme (libres ou occupées) sont aussi concernées par ce filtre.</p>
        <p><strong>Colocation/Sans colocation :</strong> cette option est soit stipulée par l'annonceur, soit déterminée
          par la présence des mots-clés "coloc", "colocation", "colocataire/trice" et "coliving".</p>
        <p><strong>Rés. avec services/Sans rés. avec services :</strong> cette option est déterminée par la présence des
          mots-clés "résidence de/avec services", "résidence séniors", résidence étudiante" ou "résidence de tourisme"
          dans la description.</p>
        <p><strong>Ascenseur/Sans ascenseur :</strong> cette option est déterminée par la présence du mot-clé "avec
          ascenseur" dans la description.</p>
        <p><strong>Jardin :</strong> cette option est déterminée par la présence des mots-clés "jardin", "jardinet",
          "terrain", "parcelle", "espace vert", etc... dans la description.</p>
        <p><strong>Piscine :</strong> cette option est déterminée par la présence du mot-clé "piscine" dans la
          description. Utilisable pour les maisons, appartements et immeubles.</p>
        <p><strong>Terrasse :</strong> cette option est déterminée par la présence du mot-clé "terrasse" dans la
          description.</p>
        <p><strong>Balcon :</strong> cette option est déterminée par la présence du mot-clé "balcon" dans la description.
        </p>
        <p><strong>Terrasse ou balcon :</strong> combinaison des options "Terrasse" et "Balcon", les biens ayant l'une ou
          l'autre sont retournés.</p>
        <p><strong>Garage :</strong> cette option est déterminée par la présence du mot-clé "garage" dans la description.
        </p>
        <p><strong>Parking :</strong> cette option est déterminée par la présence des mot-clés "parking" ou "place de
          stationnement" dans la description.</p>
        <p><strong>Garage ou parking :</strong> combinaison des options "Garage" et "Parking", les biens ayant l'un ou
          l'autre sont retournés.</p>
        <p><strong>Cave/box :</strong> cette option est déterminée par la présence du mot-clé "cave" ou "box" dans la
          description.</p>
        <p><strong>Interphone :</strong> cette option est déterminée par la présence des mots-clés "interphone",
          "visiophone", "videophone" ou "intercom" dans la description.</p>
        <p><strong>Digicode/badge : </strong> cette option est déterminée par la présence des mots-clés "digicode",
          "badge", "vigik" ou "porte codée" dans la description.</p>
        <p><strong>Rez-de-chaussée/Sans rez-de-chaussée :</strong> cette option est déterminée par la présence des
          mots-clés "rdc", "rez-de-chaussée", ou "rez-de-rue" dans la description ou si l'étage du bien est 0.</p>
        <p><strong>Dernier étage :</strong> cette option est déterminée par la présence du mot-clé "dernier étage" dans la
          description ou si l'étage du bien est égal au nombre d'étages du bâtiment.</p>
        <p><strong>Fibre optique :</strong> cette option est déterminée par la présence du mot-clé "fibre optique" dans la
          description.</p>
        <p><strong>Vue sur mer :</strong> cette option est déterminée par la présence du mot-clé "vue sur mer" ou "vue sur
          océan" dans la description.</p>
        <p><strong>Avec photo/Sans photo :</strong> cette option permet de retourner les annonces ayant au moins une
          photo.</p>
        <p><strong>Loc. saisonnière/Sans loc. saisonnière :</strong> cette option est déterminée par la lecture de
          mots-clés dans la description indiquant que l'annonce concerne une location saisonnière.</p>
        <p><strong>Logement social/Sans logement social :</strong> cette option est déterminée par la lecture de mots-clés
          dans la description indiquant que l'annonce concerne un logement social.</p>
        <p><strong>Nue propriété/Sans nue propriété : </strong> cette option est déterminée par la lecture de mots-clés
          dans la description indiquant que l'annonce concerne une nue propriété.</p>
        <p><strong>Sous compromis/Sans compromis :</strong> cette option est déterminée par la lecture de mots-clés au
          début de la description indiquant que le bien de l'annonce est sous compromis de vente.</p>
      </div>
      <div class="ModalFooter" @click="openOptionsModal('OptionsModal', false)">
        <button>Fermer</button>
      </div>
    </div>

    <!-- model for Keywords input info -->
    <div class="Modal" id="KeywordsModal">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <fa-icon class="icon" :icon="'info'"></fa-icon>
          <h2>Mode d'emploi des mots-clés</h2>
        </div>
        <div class="ExitBtn" @click="openOptionsModal('KeywordsModal', false)">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <p>
          Renseigner des mots-clés vous permet de rechercher des termes dans le <strong>titre</strong> ou la
          <strong>description</strong> des annonces. Il n'est pas impossible que le temps d'exécution d'une requête soit
          long si les mots-clés renseignés sont nombreux et complexes. Certains mots-clés fréquents sont déjà
          <strong>pré-sauvegardés</strong> (ils sont suggerés et apparaissent en vert), leur recherche est par conséquent
          plus rapide.
          <br /><br />
          <strong>Recherches multiples</strong><br />
          Pour ajouter un mot-clé à la liste des mots-clés, il suffit de taper le mot puis de presser la touche
          <strong>Entrée</strong>. Un mot-clé peut contenir plusieurs mots. Par exemple :
          <br /><br />
        <ul>
          <li>une recherche avec le mot-clé vue sur mer va retourner toutes les annonces avec les trois mots à la suite.
          </li>
          <li>une recherche avec le mot-clé vue et le mot-clé mer va retourner toutes les annonces qui contiennent les
            deux mots, mais pas forcément consécutifs.</li>
        </ul>
        <strong>Recherches en ET ou en OU</strong><br />
        Une recherche avec plusieurs mots-clés peut être exécutée en ET logique ou OU logique. Par exemple :
        <br /><br />
        <ul>
          <li>une recherche en ET avec les mots-clés piscine jacuzzi va retourner toutes les annonces qui ont une piscine
            ET un jacuzzi.</li>
          <li>une recherche en OU avec les mots-clés garage place de parking va retourner toutes les annonces qui ont un
            garage OU une place de parking.</li>
        </ul>
        <strong>Négation</strong><br />
        La négation permet de filtrer les annonces qui contiennent un certain mot-clé. Pour ce faire, il suffit de
        préfixer le mot par le trait d'union "-". Par exemple :
        <br /><br />
        <ul>
          <li>une recherche avec les mots-clés balcon -cellier va retourner toutes les annonces qui ont un balcon et qui
            n'ont pas de cellier.</li>
        </ul>
        </p>
      </div>
      <div class="ModalFooter" @click="openOptionsModal('KeywordsModal', false)">
        <button>Fermer</button>
      </div>
    </div>


     <!-- model for Prime Assurance -->
     <div class="Modal CoutProjetModal" id="CoutProjet">
      <div class="ModalHeader">
        <div class="ModalTitle">
          <h2>Coût du projet</h2>
        </div>
        <div class="ExitBtn" @click="openOptionsModal('CoutProjet', false)">
          <p>X</p>
        </div>
      </div>
      <div class="ModalBody">
        <div class="FormContainer">
          <div class="FormCol-6">
            <div class="InputBox">
              <label>Votre apport personnel €</label>
              <input type="number" v-model="projectCost.apport" @change="UpdateFrais(projectCost, false)">
            </div>
            <div class="InputBox">
              <label>Mobilier €</label>
              <input type="number" v-model="projectCost.mobilier" @change="UpdateFrais(projectCost, false)">
            </div>
            <div class="InputBox">
              <label>Expertise €</label>
              <input type="number" v-model="projectCost.expertise" @change="UpdateFrais(projectCost, false)">
            </div>
            <div class="InputBox">
              <label>CRD refinancé €</label>
              <input type="number" v-model="projectCost.crd_refinance" @change="UpdateFrais(projectCost, false)">
            </div>
            <div class="InputBox">
              <label>Frais courtage €</label>
              <input type="number" v-model="projectCost.courtage" @change="UpdateFrais(projectCost, false)">
            </div>
          </div>
          <div class="FormCol-6">
            <div class="InputBox">
              <label>Logement €</label>
              <input type="number" v-model="projectCost.logemet" @change="UpdateFrais(projectCost, false)">
            </div>
            <div class="InputBox">
              <label>Frais d'établissement €</label>
              <input type="number" v-model="projectCost.etablissement" @change="UpdateFrais(projectCost, false)">
            </div>
            <div class="InputBox">
              <label>Agence €</label>
              <input type="number" v-model="projectCost.agence" @change="UpdateFrais(projectCost, false)">
            </div>
            <div class="InputBox col-9">
              <label>Frais notaire €</label>
              <input type="number" v-model="projectCost.notaire" @change="UpdateFrais(projectCost, false)">
            </div>
            <div
              class="reload"
              v-if="
                OperationType == 1 ||
                OperationType == 3 ||
                OperationType == 4 ||
                OperationType == 5 ||
                OperationType == 6 ||
                OperationType == 7 ||
                OperationType == 13 ||
                OperationType == 14
              "
            >
            <div class="reloadSingle" @click="UpdateFrais(projectCost, false)"></div>
              <span
                class="simple-icon-reload"
                style="margin-top: 17px;color:#33b4cd"
              >Fixé</span>
            </div>
            <div class="InputBox">
              <label>Coût total €</label>
              <input type="number" v-model="coutDuProjet" disabled>
            </div>
          </div>
          
        </div>
      </div>
      <div class="ModalFooter">
        <div class="ActionBar">
          <button class="Btn" @click="openOptionsModal('CoutProjet', false)">Fermer</button>
          <button class="Btn" @click="UpdateFrais(projectCost, true); openOptionsModal('CoutProjet', false)">Confirmer</button>
        </div>
      </div>
    </div>
    <!-- overlay for modals -->
    <div class="overlay" id="overlay"></div>


    <!-- <div class="content">
    <button class="icon" @click="myFunction()">
      <fa-icon :icon="{ prefix: 'fas', iconName: 'bars' }" />
    </button>
    </div> -->

    <div class="filters-container"></div>

    <div class="FiltersNavbar">
      <div class="DropDownContainer">
        <div @click="resetFiltersStates(1); typeAnnocesState = !typeAnnocesState"
          :class="typeAnnocesState ? 'header selected' : 'header'">
          <fa-icon class="Icon" :icon="'scroll'"></fa-icon>
          <h2>Types d'annonces</h2>
          <fa-icon class="ChevIcon" :icon="'chevron-down'"></fa-icon>
        </div>
        <div :class="typeAnnocesState ? 'body show' : 'body'">
          <multiselect v-model="annonce" label="text" track-by="value" placeholder="Selectionnez un type d'annonce  "
            select-label="✔" deselect-label="✘" :multiple="true" :options="ListeAnnonce" open-direction="bottom"
            :internal-search="false" :searchable="true" :show-no-results="false" :hide-selected="false"
            :close-on-select="true" style="border-color: #1E8A9E; color: black">
          </multiselect>

          <button class="ValideBtn" @click="resetPag(), searchByFilter(); typeAnnocesState = !typeAnnocesState">
            Valider
          </button>
        </div>
      </div>
      <div class="DropDownContainer">
        <div @click="resetFiltersStates(2); typeVendeurState = !typeVendeurState"
          :class="typeVendeurState ? 'header selected' : 'header'">
          <fa-icon class="Icon" :icon="'user'"></fa-icon>
          <h2>Types de vendeurs</h2>
          <fa-icon class="ChevIcon" :icon="'chevron-down'"></fa-icon>
        </div>
        <div :class="typeVendeurState ? 'body show' : 'body'">
          <multiselect v-model="type_vendeur" label="text" track-by="value"
            placeholder="Selectionnez un type de vendeur  " select-label="✔" deselect-label="✘" :multiple="true"
            :options="ListeTypeVendeur" open-direction="bottom" :internal-search="false" :searchable="true"
            :show-no-results="false" :hide-selected="false" :close-on-select="true"
            style="border-color: #1E8A9E; color: black">
          </multiselect>
          <button class="ValideBtn" @click="resetPag(), searchByFilter(); typeVendeurState = !typeVendeurState">
            Valider
          </button>
        </div>
      </div>
      <div class="DropDownContainer">
        <div @click="resetFiltersStates(3); typeBienState = !typeBienState"
          :class="typeBienState ? 'header selected' : 'header'">
          <fa-icon class="Icon" :icon="'building'"></fa-icon>
          <h2>Types de biens</h2>
          <fa-icon class="ChevIcon" :icon="'chevron-down'"></fa-icon>
        </div>
        <div :class="typeBienState ? 'body show' : 'body'">
          <multiselect v-model="categorie" label="text" track-by="value" placeholder="Selectionnez un type de bien  "
            select-label="✔" deselect-label="✘" :multiple="true" :options="ListeCategorie" open-direction="bottom"
            :internal-search="false" :searchable="true" :show-no-results="false" :hide-selected="false"
            :close-on-select="true" style="border-color: #1E8A9E; color: black">
          </multiselect>

          <button class="ValideBtn" @click="resetPag(), searchByFilter(); typeBienState = !typeBienState">
            Valider
          </button>
        </div>
      </div>
      <div class="DropDownContainer">
        <div @click="resetFiltersStates(4); LocationState = !LocationState"
          :class="LocationState ? 'header selected' : 'header'">
          <fa-icon class="Icon" :icon="'map-pin'"></fa-icon>
          <h2>Localisation</h2>
          <fa-icon class="ChevIcon" :icon="'chevron-down'"></fa-icon>
        </div>
        <div :class="LocationState ? 'body show' : 'body'">
          <label class="description">
            Localisations
            <div class="InfoBtn" @mouseover="toggleInfo('LocalisationPopup', true)"
              @mouseleave="toggleInfo('LocalisationPopup', false)">
              <fa-icon class="icon" :icon="'question'"></fa-icon>
              <span class="popuptext" id="LocalisationPopup">Choix possibles : villes, code, postaux, départments ou
                régions</span>
            </div>
          </label>
          <multiselect v-model="location" label="text" track-by="value" placeholder="Localisation" select-label="✔"
            deselect-label="✘" :multiple="true" :options="LocationProjet" open-direction="bottom" :internal-search="false"
            :searchable="true" :show-no-results="false" :hide-selected="false" :close-on-select="true"
            :clear-on-select="true" @search-change="searchVille">
          </multiselect>
          <label class="description">
            Rayon
            <div class="InfoBtn" @mouseover="toggleInfo('RayonPopup', true)"
              @mouseleave="toggleInfo('RayonPopup', false)">
              <fa-icon class="icon" :icon="'question'"></fa-icon>
              <span class="popuptext" id="RayonPopup">Recherche de biens présents dans un rayon autour d'une ville ou d'un
                code postal</span>
            </div>
          </label>
          <b-input class="input" v-model="radius" type="number" min="1" max="100" @keydown="testRaduis()"
            style="padding: 9px 15px; border-color: #22abc5" />
          <button class="ValideBtn" @click="resetPag(), searchByFilter(); LocationState = !LocationState">
            Valider
          </button>
        </div>
      </div>
      <div class="DropDownContainer">
        <div @click="resetFiltersStates(5); PriceState = !PriceState" :class="PriceState ? 'header selected' : 'header'">
          <fa-icon class="Icon" :icon="'euro-sign'"></fa-icon>
          <h2>Prix Total</h2>
          <fa-icon class="ChevIcon" :icon="'chevron-down'"></fa-icon>
        </div>
        <div :class="PriceState ? 'body show' : 'body'">
          <label for="fname">Prix min</label>
          <b-input class="input" v-model="priceMin" type="number" style="padding: 9px 15px; border-color: #22abc5" />
          <label for="fname">Prix max</label>
          <b-input class="input" v-model="priceMax" type="number" style="padding: 9px 15px; border-color: #22abc5" />

          <button class="ValideBtn" @click="resetPag(), searchByFilter(); PriceState = !PriceState">
            Valider
          </button>
        </div>
      </div>
      <div class="DropDownContainer">
        <div @click="resetFiltersStates(6); SurfaceState = !SurfaceState"
          :class="SurfaceState ? 'header selected' : 'header'">
          <fa-icon class="Icon" :icon="'ruler'"></fa-icon>
          <h2>Surface Total</h2>
          <fa-icon class="ChevIcon" :icon="'chevron-down'"></fa-icon>
        </div>
        <div :class="SurfaceState ? 'body show' : 'body'">
          <label class="description">Surface min</label>
          <b-input class="input" v-model="surfaceMin" type="number" style="padding: 9px 15px; border-color: #22abc5" />
          <label class="description">Surface max</label>
          <b-input class="input" v-model="surfaceMax" type="number" style="padding: 9px 15px; border-color: #22abc5" />

          <button class="ValideBtn" @click="resetPag(), searchByFilter(); SurfaceState = !SurfaceState">
            Valider
          </button>
        </div>
      </div>
      <div class="DropDownContainer">
        <div @click="resetFiltersStates(7); NbrPiecesState = !NbrPiecesState"
          :class="NbrPiecesState ? 'header selected' : 'header'">
          <fa-icon class="Icon" :icon="'home'"></fa-icon>
          <h2>Nombres des pièces</h2>
          <fa-icon class="ChevIcon" :icon="'chevron-down'"></fa-icon>
        </div>
        <div :class="NbrPiecesState ? 'body show' : 'body'">
          <label class="description">Pièces min</label>
          <b-input class="input" v-model="roomsMin" type="number" style="padding: 9px 15px; border-color: #1E8A9E" />
          <label class="description">Pièces max</label>
          <b-input class="input" v-model="roomsMax" type="number" style="padding: 9px 15px; border-color: #1E8A9E" />
          <label class="description">Chambres min</label>
          <b-input class="input" v-model="bedroomsMin" type="number" style="padding: 9px 15px; border-color: #1E8A9E" />
          <label class="description">Chambres max</label>
          <b-input class="input" v-model="bedroomsMax" type="number" style="padding: 9px 15px; border-color: #1E8A9E" />
          <button class="ValideBtn" @click="resetPag(), searchByFilter(); NbrPiecesState = !NbrPiecesState">
            Valider
          </button>
        </div>
      </div>
      <div class="DropDownContainer">
        <div @click="resetFiltersStates(9); sortByState = !sortByState"
          :class="sortByState ? 'header selected' : 'header'">
          <fa-icon class="Icon" :icon="'sort'"></fa-icon>
          <h2>Trier par</h2>
          <fa-icon class="ChevIcon" :icon="'chevron-down'"></fa-icon>
        </div>
        <div :class="sortByState ? 'body show' : 'body'">
          <select v-model="sortby">
            <option v-for="(item, index) in ListeSortBy" :value="item.value" :key="index">{{ item.text }}</option>
          </select>
          <button class="ValideBtn" @click="resetPag(), searchByFilter(); sortByState = !sortByState">
            Valider
          </button>
        </div>
      </div>
      <div class="DropDownContainer">
        <div @click="resetFiltersStates(8); PlusCritereState = !PlusCritereState"
          :class="PlusCritereState ? 'header selected' : 'header'">
          <fa-icon class="Icon" :icon="'plus'"></fa-icon>
          <h2>Plus de critères</h2>
          <fa-icon class="ChevIcon" :icon="'chevron-down'"></fa-icon>
        </div>
      </div>
    </div>
    <div :class="PlusCritereState ? 'PlusCritere show' : 'PlusCritere hide'">
      <div class="filtersList">
        <div class="FilterBox">
          <label class="description">Etage min</label>
          <b-input class="input" v-model="floorMin" type="number" style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Etage max</label>
          <b-input class="input" v-model="floorMax" type="number" style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Terrain min</label>
          <b-input class="input" v-model="landSurfaceMin" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Terrain max</label>
          <b-input class="input" v-model="landSurfaceMax" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Prix m² min</label>
          <b-input class="input" v-model="pricePerSquareMeterMin" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Prix m² max</label>
          <b-input class="input" v-model="pricePerSquareMeterMax" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox" style="z-index:100 !important;">
          <label class="description" style="margin-top:10px;">
            Options
            <div class="InfoBtn" @click="openOptionsModal('OptionsModal', true)">
              <fa-icon class="icon" :icon="'info'"></fa-icon>
            </div>
          </label>
          <multiselect class="multiselect" v-model="optionsfilter" label="text" track-by="value"
            placeholder="Selectionnez les options " select-label="✔" deselect-label="✘" :multiple="true"
            :options="ListeOptions" open-direction="bottom" :internal-search="true" :searchable="true"
            :show-no-results="false" :hide-selected="false" :close-on-select="true"
            style="border-color: #22b5d5; color: black; width:200px;">
          </multiselect>
        </div>
        <div class="FilterBox" style="z-index:100 !important;">
          <label class="description" style="margin-top:10px;">
            Plateformes immobilières
            <div class="InfoBtn" @click="openOptionsModal('OptionsModal', true)">
              <fa-icon class="icon" :icon="'info'"></fa-icon>
            </div>
          </label>
          <multiselect class="multiselect" v-model="PlatformesImmo" label="text" track-by="value"
            placeholder="Selectionnez les options " select-label="✔" deselect-label="✘" :multiple="true"
            :options="PlateformesImmoListe" open-direction="bottom" :internal-search="true" :searchable="true"
            :show-no-results="false" :hide-selected="false" :close-on-select="true"
            style="border-color: #22b5d5; color: black; width:200px;">
          </multiselect>
        </div>
        <div class="FilterBox">
          <label class="description">Charges/mois min €</label>
          <b-input class="input" v-model="propertyChargesMin" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Charges/mois max €</label>
          <b-input class="input" v-model="propertyChargesMax" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Taxe foncière min €</label>
          <b-input class="input" v-model="propertyTaxMin" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Taxe foncière max €</label>
          <b-input class="input" v-model="propertyTaxMax" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <!-- <div class="FilterBox">
          <label class="description">Rayon</label>
            <b-input
              class="input"
              v-model="radius"
              type="number"
              min="1"
              max="100"
              @keydown="testRaduis()"
              style="padding: 9px 15px; border-color: #22abc5"
            />
        </div> -->
        <div class="FilterBox">
          <label class="description">Loyer min</label>
          <b-input class="input" v-model="rentMin" type="number" style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Loyer max</label>
          <b-input class="input" v-model="rentMax" type="number" style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox" style="z-index:100 !important;">
          <label class="description" style="margin-top:10px;">
            Annonceurs
          </label>
          <multiselect class="multiselect" v-model="annonceursFilter" label="text" track-by="value"
            placeholder="Selectionnez les options " select-label="✔" deselect-label="✘" :multiple="true"
            :options="AnnonceursSelectedList" open-direction="bottom" :internal-search="true" :searchable="true"
            :show-no-results="false" :hide-selected="false" :close-on-select="true"
            style="border-color: #22b5d5; color: black; width:200px;">
          </multiselect>
        </div>
        <div class="FilterBox" style="z-index:100 !important;">
          <label class="description" style="margin-top:10px;">
            Vente en partage
          </label>
          <multiselect class="multiselect" v-model="ventePartageFilter" label="text" track-by="value"
            placeholder="Selectionnez les options " select-label="✔" deselect-label="✘" :multiple="true"
            :options="ventePartageOptions" open-direction="bottom" :internal-search="true" :searchable="true"
            :show-no-results="false" :hide-selected="false" :close-on-select="true"
            style="border-color: #22b5d5; color: black; width:200px;">
          </multiselect>
        </div>
        <div class="FilterBox">
          <label class="description">Année min</label>
          <b-input class="input" v-model="constructionYearMin" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">Année max</label>
          <b-input class="input" v-model="constructionYearMax" type="number"
            style="padding: 9px 15px; border-color: #22abc5" />
        </div>
        <div class="FilterBox">
          <label class="description">DPE min</label>
          <select v-model="energyGradeMin">
            <option></option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
            <option value="E">E</option>
            <option value="F">F</option>
            <option value="G">G</option>
          </select>
        </div>
        <div class="FilterBox">
          <label class="description">DPE max</label>
          <select v-model="energyGradeMax">
            <option></option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
            <option value="E">E</option>
            <option value="F">F</option>
            <option value="G">G</option>
          </select>
        </div>
        <div class="FilterBox">
          <label class="description">GES min</label>
          <select v-model="gasGradeMin">
            <option></option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
            <option value="E">E</option>
            <option value="F">F</option>
            <option value="G">G</option>
          </select>
        </div>
        <div class="FilterBox">
          <label class="description">GES max</label>
          <select v-model="gasGradeMax">
            <option></option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
            <option value="E">E</option>
            <option value="F">F</option>
            <option value="G">G</option>
          </select>
        </div>
        
        <div class="FilterBox">
          <div class="keywordsOperator" style="margin-top:-10px;">
            <input type="radio" id="ET" name="keywordsOperator" value="and" v-model="keywordsOperator">
            <label for="ET">ET</label><br>
            <input type="radio" id="OU" name="keywordsOperator" value="or" v-model="keywordsOperator">
            <label for="OU">OU</label><br>
            <div class="InfoBtn" @click="openOptionsModal('KeywordsModal', true)">
              <fa-icon class="icon" :icon="'info'"></fa-icon>
            </div>
          </div>
          <div class="input" style="padding: 9px 15px; border-color: #22abc5; position:relative;">
            <div v-for="(keyword, index) in keywords" :key="index" class="keyword-box">
              <span class="keyword-text">{{ keyword }}</span>
              <button class="delete-button" @click="deleteKeyword(index)">X</button>
            </div>
            <input v-model="newKeyword" @keyup.enter="addKeyword" placeholder="Mots-clés" @input="updateAutocomplete"
              type="text" style="background-color: transparent; border: none; outline: none; width: 100%;" />
          </div>
          <div v-if="showAutocomplete" class="autocomplete">
            <div v-for="option in autocompleteOptions" :key="option" @click="addAutocompleteOption(option)">
              {{ option }}
            </div>
          </div>
        </div>
      </div>
      
      <button class="ValideBtn" @click="resetPag(), searchByFilter(); PlusCritereState = !PlusCritereState">
        Valider
      </button>
    </div>

    <div class="MoreFilters">

    </div>

    <div class="container">
      <!-- <div class="content">
        <div class="col2"></div>
      </div>
      <div class="content row" style="align-items: top">
        <div class="col2 width1" style="width: 20%">
          <multiselect
            v-model="annonce"
            label="text"
            track-by="value"
            placeholder="Selectionnez un type d'annonce  "
            select-label="✔"
            deselect-label="✘"
            :multiple="true"
            :options="ListeAnnonce"
            open-direction="bottom"
            :internal-search="false"
            :searchable="true"
            :show-no-results="false"
            :hide-selected="false"
            :close-on-select="true"
            style="border-color: #22b5d5; color: black"
          >
          </multiselect>
        </div>
        <div class="col2 width1" style="width: 20%">
          <multiselect
            v-model="type_vendeur"
            label="text"
            track-by="value"
            placeholder="Selectionnez un type de vendeur  "
            select-label="✔"
            deselect-label="✘"
            :multiple="true"
            :options="ListeTypeVendeur"
            open-direction="bottom"
            :internal-search="false"
            :searchable="true"
            :show-no-results="false"
            :hide-selected="false"
            :close-on-select="true"
            style="border-color: #22b5d5; color: black"
          >
          </multiselect>
        </div>
        <div class="col2 width1" style="width: 20%">
          <div class="row3">
            <multiselect
              v-model="categorie"
              label="text"
              track-by="value"
              placeholder="Selectionnez un type de bien  "
              select-label="✔"
              deselect-label="✘"
              :multiple="true"
              :options="ListeCategorie"
              open-direction="bottom"
              :internal-search="false"
              :searchable="true"
              :show-no-results="false"
              :hide-selected="false"
              :close-on-select="true"
              style="border-color: #22b5d5; color: black"
            >
            </multiselect>
          </div>
        </div>
        <div class="col2 width1" style="width: 20%; margin-left: -20px">
          <multiselect
            v-model="location"
            label="text"
            track-by="value"
            placeholder="Localisation"
            select-label="✔"
            deselect-label="✘"
            :multiple="true"
            :options="LocationProjet"
            open-direction="bottom"
            :internal-search="false"
            :searchable="true"
            :show-no-results="false"
            :hide-selected="false"
            :close-on-select="true"
            :clear-on-select="true"
            @search-change="searchVille"
          >
          </multiselect>
        </div>
        <div class="col2 width1" style="width: 20%">
          <button
            @click="resetPag(), searchByFilter()"
            style="
              width: 300px;
              background-color: #22abc5;
              padding: 10px;
              border-color: transparent;
              color: white !important;
            "
          >
            Lancer la recherche
          </button>
        </div>
      </div>
      <div class="content row" style="align-items: center; margin-top: -25px">
        <div class="col2 width1" style="margin-right: 30px">
          <label for="fname">Prix min</label>
          <b-input
            class="input"
            v-model="priceMin"
            type="number"
            style="padding: 9px 15px; border-color: #22abc5"
          />
        </div>
        <div class="col2 width1" style="margin-right: 30px">
          <label for="fname">Prix max</label>
          <b-input
            class="input"
            v-model="priceMax"
            type="number"
            style="padding: 9px 15px; border-color: #22abc5"
          />
        </div>
        <div class="col2 width1" style="margin-right: 30px">
          <label class="description">Surface min</label>
          <b-input
            class="input"
            v-model="surfaceMin"
            type="number"
            style="padding: 9px 15px; border-color: #22abc5"
          />
        </div>
        <div class="col2 width1" style="margin-right: 30px">
          <label class="description">Surface max</label>
          <b-input
            class="input"
            v-model="surfaceMax"
            type="number"
            style="padding: 9px 15px; border-color: #22abc5"
          />
        </div>
        <div class="col2 width1" style="margin-right: 30px">
          <label class="description">Pièces min</label>
          <b-input
            class="input"
            v-model="roomsMin"
            type="number"
            style="padding: 9px 15px; border-color: #22abc5"
          />
        </div>
      </div>

      <div class="content row" style="align-items: center">
        <div class="col2 width1" style="margin-right: 30px">
          <label class="description">Pièces max</label>
          <b-input
            class="input"
            v-model="roomsMax"
            type="number"
            style="padding: 9px 15px; border-color: #22abc5"
          />
        </div>
        <div class="col2 width1" style="margin-right: 30px">
          <label class="description">Chambres min</label>
          <b-input
            class="input"
            v-model="bedroomsMin"
            type="number"
            style="padding: 9px 15px; border-color: #22abc5"
          />
        </div>
        <div class="col2 width1" style="margin-right: 30px">
          <label class="description">Chambres max</label>
          <b-input
            class="input"
            v-model="bedroomsMax"
            type="number"
            style="padding: 9px 15px; border-color: #22abc5"
          />
        </div>
      </div>

      <div
        class="content row"
        style="align-items: center; text-align: center; display: block"
      >
        <button
          @click="plus_critere = !plus_critere"
          v-if="plus_critere == false"
          style="
            background-color: #22abc5;
            padding: 10px;
            border-color: transparent;
            color: white !important;
          "
        >
          Plus de critères
        </button>
        <button
          @click="plus_critere = !plus_critere"
          v-else
          style="
            background-color: #22abc5;
            padding: 10px;
            border-color: transparent;
            color: white !important;
          "
        >
          Moins de critères
        </button>
      </div>
      <div class="plus_crite" v-if="plus_critere == true">
        <div class="content row" style="align-items: center">
          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Etage min</label>
            <b-input
              class="input"
              v-model="floorMin"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>
          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Etage max</label>
            <b-input
              class="input"
              v-model="floorMax"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>
          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Terrain min</label>
            <b-input
              class="input"
              v-model="landSurfaceMin"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>
          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Terrain max</label>
            <b-input
              class="input"
              v-model="landSurfaceMax"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>
          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Prix m² min</label>
            <b-input
              class="input"
              v-model="pricePerSquareMeterMin"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>
        </div>
        <div class="content row" style="align-items: center">
          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Prix m² max</label>
            <b-input
              class="input"
              v-model="pricePerSquareMeterMax"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>

          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Charges/mois min €</label>
            <b-input
              class="input"
              v-model="propertyChargesMin"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>
          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Charges/mois max €</label>
            <b-input
              class="input"
              v-model="propertyChargesMax"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>

          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Taxe foncière min €</label>
            <b-input
              class="input"
              v-model="propertyTaxMin"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>
          <div class="col2 width1" style="margin-right: 30px">
            <label class="description">Taxe foncière max €</label>
            <b-input
              class="input"
              v-model="propertyTaxMax"
              type="number"
              style="padding: 9px 15px; border-color: #22abc5"
            />
          </div>
        </div>
      </div> -->



      <div class="Container">
        <div v-for="(item, Allindex) in ListeBienAncien" :key="Allindex" style="min-width: 100%;">
          <div class="Card">
            <div class="left">
              <div class="Top">
                <div class="ImageCarousel">
                  <div class="nbJours">
                    <p>{{ calculateTimeDifference(item.publicationDate) }}</p>
                  </div>
                  <div class="nbImages">
                    <p>{{ item.pictureUrls.length }}</p>
                    <fa-icon class="icon" :icon="'images'"></fa-icon>
                  </div>
                  <vueper-slides class="Slider" fixed-height="250px">
                    <vueper-slide v-for="(slide, i) in item.pictureUrls" :key="i" :image="slide" />
                  </vueper-slides>
                </div>
                <div class="Infos">
                  <div class="Title">
                    <fa-icon :icon="'home'" class="homeIcon"></fa-icon>
                    <h2>{{ item.title }}</h2>
                    <p class="TitleDesc">
                      référencée le {{ distanceFromNow(item.publicationDate) }}
                      {{
                        item.lastPriceChangeDate != null
                        ? `(prix modifié le ${distanceFromNow(
                          item.lastPriceChangeDate
                        )})`
                        : ""
                      }}
                    </p>
                  </div>
                  <div :class="checkIfAnnonceurYes(item.publisher.name) ? 'TypePublish GreenStyle' : 'TypePublish XXX'">
                    <div class="publisherInfoBox" v-if="item.publisher.type != null">
                      <fa-icon :icon="'user'"></fa-icon>
                      <p>Type d'annonceur : {{ item.publisher.type == 'individual' ? 'Particulier' : 'profesionnel' }} </p>
                    </div>
                    <div class="publisherInfoBox" v-if="item.publisher.name != null">
                      <fa-icon :icon="'user'"></fa-icon>
                      <p>Nom : {{ item.publisher.name }} </p>
                    </div>
                    <div class="publisherInfoBox" v-if="item.publisher.email != null">
                      <fa-icon :icon="'envelope'"></fa-icon>
                      <p>Email : {{ item.publisher.email }}</p>
                    </div>
                    <div class="publisherInfoBox" v-if="item.publisher.phone != null">
                      <fa-icon :icon="'phone'"></fa-icon>
                      <p>Tél : {{ item.publisher.phone }}</p>
                    </div>
                    <div class="publisherInfoBox" v-if="item.publisher.address != null">
                      <fa-icon :icon="'map-marked-alt'"></fa-icon>
                      <p>Address : {{ item.publisher.address }}</p>
                    </div>
                    <div class="publisherInfoBox YesNoBox" v-if="item.publisher.name != null">
                      <span>Vente en partage: </span>
                      <input
                        type="checkbox"
                        @change="yesclickHandler(item.publisher)"
                        :checked="checkIfAnnonceurYes(item.publisher.name)"
                      />
                      <label :for="'yesRadio'+ item.publisher.phone">Oui</label>
                      <!-- <input type="radio" value="no" @input="nonclickHandler(item.publisher);" :checked="checkIfAnnonceurNon(item.publisher.name)"/>
                      <label :for="'noRadio'+ item.publisher.phone">non</label> -->
                    </div>
                  </div>
                  <div class="DescContainer">
                    <p class="Desc" v-text="truncateDescription(item.description, 600)"></p>
                  </div>
                  <div class="BadgesList">
                    <div class="badge" v-if="item.buildingFloors != null">
                      <fa-icon :icon="'building'"></fa-icon>
                      <p>étages <span>{{ item.buildingFloors }}</span></p>
                    </div>
                    <div class="badge" v-if="item.options.includes('hasTerrace')">
                      <fa-icon :icon="'sun'"></fa-icon>
                      <p>Terrasse</p>
                    </div>
                    <div class="badge" v-if="item.landSurface != null">
                      <fa-icon :icon="'calculator'"></fa-icon>
                      <p>Surface <span>{{ item.landSurface }}m²</span></p>
                    </div>
                    <!-- <div class="badge" v-if="item.options.includes('isNew')">
                      <fa-icon :icon="'star'"></fa-icon>
                      <p>Nouvelle</p>
                    </div> -->
                    <div class="badge" v-if="item.options.includes('hasGarage')">
                      <fa-icon :icon="'car'"></fa-icon>
                      <p>Garage</p>
                    </div>
                    <div class="badge" v-if="item.options.includes('hasGarden')">
                      <fa-icon :icon="'tree'"></fa-icon>
                      <p>Jardin</p>
                    </div>
                    <div class="badge" v-if="item.options.includes('hasParking')">
                      <fa-icon :icon="'parking'"></fa-icon>
                      <p>Parking</p>
                    </div>
                    <div class="badge" v-if="item.options.includes('hasSwimmingPool')">
                      <fa-icon :icon="'water'"></fa-icon>
                      <p>Piscine</p>
                    </div>
                    <div class="badge" v-if="item.options.includes('hasCave')">
                      <fa-icon :icon="'closed-captioning'"></fa-icon>
                      <p>Cave</p>
                    </div>
                    <div class="badge" v-if="item.options.includes('isBuildable')">
                      <fa-icon :icon="'hammer'"></fa-icon>
                      <p>Constructible</p>
                    </div>
                    <div class="badge" v-if="item.energyGrade != null">
                      <fa-icon :icon="'lightbulb'"></fa-icon>
                      <p>DPE <span>{{ item.energyGrade }}</span></p>
                    </div>
                    <div class="badge" v-if="item.gasGrade != null">
                      <fa-icon :icon="'leaf'"></fa-icon>
                      <p>GES <span>{{ item.gasGrade }}</span></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="Bottom">
                <!-- <div class="Row">
                <div class="BoxContainer">
                  <div class="Box PlaceBox">
                    <fa-icon class="icon" :icon="'map-marker'"></fa-icon>
                    <h2>{{ item.location.city }} ({{ item.location.postalCode }})</h2>
                    <p v-if="item.location.population != null"><strong>{{ item.location.population }}</strong> hab.</p>
                    <p v-if="item.location.propertyTaxRate != null">Taxe foncière: {{ item.location.propertyTaxRate }} %</p>
                    <button @click="openNewTab(item)" v-if="
                            item.position != null &&
                            item.position != undefined &&
                            item.position.length > 0
                          ">
                      <fa-icon :icon="'info'"></fa-icon>
                      Position
                    </button>
                  </div>
                  <div class="Box">
                    <fa-icon  class="icon" :icon="'euro-sign'"></fa-icon>
                    <p class="OldPrice" v-if="item.priceDrop != null">{{ parseFloat(item.originalPrice).toLocaleString("fr") }} €</p>
                    <p class="NewPrice" v-if="item.priceDrop != null">{{ parseFloat(item.price).toLocaleString("fr") }} € <span>( {{PriceDropRounded(item.priceDrop)}} )</span></p>
                    <p class="NewPrice" v-if="item.price != null && item.priceDrop == null">{{ parseFloat(item.price).toLocaleString("fr") }} €</p> 
                    <p v-if="item.priceStats">
                        Loyer estimé :
                          {{
                            parseFloat(item.priceStats.rent).toLocaleString("fr")
                          }}
                          €
                    </p>
                    <p v-if="item.priceStats">
                        Rentabilité brute :
                          {{
                            parseFloat(
                              item.priceStats.profitability * 100
                            ).toLocaleString("fr")
                          }}
                          %
                    </p>
                  </div>
                  <div class="Box">
                    <fa-icon  class="icon" :icon="'ruler'"></fa-icon>
                    <p>{{ item.surface }} m2 (
                        {{
                          parseFloat(item.pricePerSquareMeter).toLocaleString("fr")
                        }}
                        €/ m² 
                        <span
                          v-if="item.priceStats"
                          :style="
                            item.priceStats.priceGap < 0
                              ? 'color:#23b523'
                              : 'color:red'
                          "
                        >
                          {{
                            Math.round(parseFloat(item.priceStats.priceGap * 100))
                          }}
                          %
                        </span>
                        )</p>
                    <div class="ListPrice" v-if="item.priceStats">
                      <p>Prix bas: {{
                            parseFloat(item.priceStats.lowPrice).toLocaleString(
                              "fr"
                            )
                          }} €/m</p>
                      <p>Prix médian: {{
                            parseFloat(item.priceStats.medianPrice).toLocaleString(
                              "fr"
                            )
                          }} €/m</p>
                      <p>Prix haut: {{
                            parseFloat(item.priceStats.highPrice).toLocaleString(
                              "fr"
                            )
                          }} €/m</p>
                    </div>
                  </div>
                  <div class="Box" v-if="item.rooms != null ||  item.bedrooms != null">
                    <fa-icon class="icon" :icon="'bed'"></fa-icon>
                    <p v-if="item.rooms != null">{{ item.rooms }} piéces</p>
                    <p v-if="item.bedrooms != null">{{ item.bedrooms }} chambres</p>
                  </div>
                  <div class="Box">
                    <div class="LogoIcons">
                        <template v-for="(dupl, index) in item.duplicates">
                        <template v-if="dupl.origin == 'etreproprio'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/etreproprio.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 25px"
                            />
                          </a>
                          <br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'properstar'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/properstar.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 50px"
                            />
                          </a>
                          <br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'leboncoin'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/boncoin.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 25px"
                          /></a>
                          <br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'seloger'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/se_loger.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 25px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>

                        <template v-else-if="dupl.origin == 'foncia'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/foncia.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 40px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'ouestfrance'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/ouestfrance.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 25px"
                          /></a>
                          <br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'avendrealouer'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/avendre_alouer.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 25px"
                          /></a>
                          <br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'bienici'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/bien_ici.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 25px"
                          /></a>
                          <br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'greenacres'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/greenacres.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 25px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'proprietesfigaro'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/proprietesfigaro.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 25px"
                          /></a>
                          <br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'paruvendu'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/paruvendu.jpg"
                              :key="index + 'img'"
                              style="width: 80px; height: 50px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'notaires'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/notaires.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 50px"
                          /></a>
                          <br :key="index + 'br'" />
                        </template>
                        <template
                          v-else-if="dupl.origin == 'maisonsetappartements'"
                        >
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/maison_appartement.jpg"
                              :key="index + 'img'"
                              style="width: 80px; height: 50px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'bellesdemeures'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/belledemeure.jpg"
                              :key="index + 'img'"
                              style="width: 80px; height: 60px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>

                        <template v-else-if="dupl.origin == 'figaro'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/figaro.png"
                              :key="index + 'img'"
                              style="width: 101px; height: 30px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'megagence'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/megaagence.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 60px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'stephaneplaza'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/stephaneplaza.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 60px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>
                        <template v-else-if="dupl.origin == 'nestenn'">
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                          >
                            <img
                              src="/img/nestenn.png"
                              :key="index + 'img'"
                              style="width: 80px; height: 60px"
                            /> </a
                          ><br :key="index + 'br'" />
                        </template>
                        <template v-else>
                          <br :key="index + 'duplicate_br'" />
                          <a
                            :key="index + 'duplicate'"
                            target="_blank"
                            :href="dupl.url"
                            style="color: #22abc5; font-size: 18px"
                            >{{ dupl.origin }}</a
                          >
                          <br :key="index + 'duplicate_br'" />
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div> -->
                <div class="Bottom-left">
                  <div class="LogoIcons">
                    <div v-for="(dupl, index) in item.duplicates" v-show="index < item.nbrShow" :key="index">
                      <template v-if="dupl.origin == 'etreproprio'">
                        <a :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/etreproprio.png" :key="index + 'img'" style="width: 80px; height: 25px" />
                        </a>
                        <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                          <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                        </div>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'properstar'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/properstar.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>
                              {{ parseFloat(dupl.price).toLocaleString("fr") }} €
                            </p>
                          </div>
                        </a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'leboncoin'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/boncoin.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>

                        </a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'seloger'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/seloger.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>

                      <template v-else-if="dupl.origin == 'foncia'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/img/foncia.png" :key="index + 'img'" style="width: 80px; height: 40px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'ouestfrance'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/img/ouestfrance.png" :key="index + 'img'" style="width: 80px; height: 25px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'avendrealouer'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/avendrealouer.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'bienici'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/bienici.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'greenacres'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/green-acres.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'proprietesfigaro'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/proprietesfigaro.png" :key="index + 'img'"
                            style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'paruvendu'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/paruvendu.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />

                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>

                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'notaires'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/notaires.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'surfaceprivee'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/surfaceprivee.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'vivastreet'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/vivastreet.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'adaptimmobilier'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/adaptimmobilie.jpg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'aucoeurdelimmo'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/aucoeurdelimmo.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'citya'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/citya.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'immoregion'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/immoregion.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'maisonsetappartements'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/maison_appartement.jpg" :key="index + 'img'"
                            style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'bellesdemeures'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/bellesdemeures.png" :key="index + 'img'"
                            style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>

                      <template v-else-if="dupl.origin == 'figaro'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/figaroimmo.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'megagence'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/megaagence.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'stephaneplaza'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/stephaneplaza.jpeg" :key="index + 'img'"
                            style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'nestenn'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/nestenn.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'logicimmo'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/logicimmo.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'bsk'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/bskimmobilier.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'luxuryestate'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/luxuryestate.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'pap'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/pap.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'lesiteimmo'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/lesiteimmo.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'laforet'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/laforet.svg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'residencesimmobilier'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/residencesimmobilier.jpeg" :key="index + 'img'"
                            style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'luxresidence'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/luxresidence.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'orpi'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/orpi.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'century21'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/century21.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'iad'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/iad.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'topannonces'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/topannonces.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>

                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'ladresse'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/ladresse.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'ornox'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/ornoximmo.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'fnaim'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/fnaim.png" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'repimmo'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/repimmo.jpg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'lesterrains'">
                        <a class="LogoShop" :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">
                          <img src="/logoImmo/lesterrains.jpeg" :key="index + 'img'" style="width: 60px; height: 60px" />
                          <div class="LogoPrice" v-if="dupl.price != null && dupl.price != item.price">
                            <p>{{ parseFloat(dupl.price).toLocaleString("fr") }} €</p>
                          </div>
                        </a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else>
                        <br :key="index + 'duplicate_br'" />
                        <a :key="index + 'duplicate'" target="_blank" :href="dupl.url"
                          style="color: #22abc5; font-size: 18px">{{ dupl.origin }}</a>
                        <br :key="index + 'duplicate_br'" />
                      </template>
                    </div>
                    <div v-show="item.duplicates.length > 4" id="showMoreDiv">
                      <button class="ShowMoreLessBtn" v-if="item.nbrShow == 4"
                        @click="item.nbrShow = item.duplicates.length">
                        <!-- <fa-icon :icon="'plus'"></fa-icon> -->
                        Voir plus
                      </button>
                      <button class="ShowMoreLessBtn" v-else @click="item.nbrShow = 4;">
                        <!-- <fa-icon :icon="'minus'"></fa-icon> -->
                        Voir moins
                      </button>
                    </div>
                  </div>
                </div>
                <div class="Bottom-right">
                  <div class="BoxContainer">
                    <div class="Box PlaceBox">
                      <fa-icon class="icon" :icon="'map-marker'"></fa-icon>
                      <h2>
                        {{ item.location.city }} ({{ item.location.postalCode }})
                      </h2>
                      <p v-if="item.location.population != null">
                        <strong>{{ item.location.population }}</strong> hab.
                      </p>
                      <p v-if="item.location.propertyTaxRate != null">
                        Taxe foncière: {{ item.location.propertyTaxRate }} %
                      </p>
                      <button @click="openNewTab(item)" v-if="item.position != null &&
                        item.position != undefined &&
                        item.position.length > 0
                        ">
                        <fa-icon :icon="'info'"></fa-icon>
                        Position
                      </button>
                    </div>
                    <div class="Box">
                      <fa-icon class="icon" :icon="'euro-sign'"></fa-icon>
                      <p class="OldPrice" v-if="item.priceDrop != null">
                        {{
                          parseFloat(item.originalPrice).toLocaleString("fr")
                        }}
                        €
                      </p>
                      <p class="NewPrice" v-if="item.priceDrop != null">
                        {{ parseFloat(item.price).toLocaleString("fr") }} €
                        <span>(
                          {{
                            ' - ' + PriceDropRounded(item.originalPrice, item.price)
                          }}
                          )</span>
                      </p>
                      <p class="NewPrice" v-if="item.price != null && item.priceDrop == null">
                        {{ parseFloat(item.price).toLocaleString("fr") }} €
                      </p>
                      <p v-if="item.priceStats && item.priceStats.rent != null">
                        Loyer estimé :
                        {{
                          parseFloat(item.priceStats.rent).toLocaleString("fr")
                        }}
                        €
                      </p>
                      <p v-if="item.priceStats">
                        Rentabilité brute :
                        {{
                          parseFloat(
                            item.priceStats.profitability * 100
                          ).toLocaleString("fr")
                        }}
                        %
                      </p>
                      <button v-b-toggle="'collapse-propositions-' + item.uniqueId"
                        @click="showPropositions(item.price, item.uniqueId);" v-if="project_id != null &&
                            project_id != undefined && project_id != -1
                            " class="btn-propositions">
                        <fa-icon :icon="'info'"></fa-icon>
                        Propositions
                      </button>
                    </div>
                    <div class="Box" v-if="item.surface != null">
                      <fa-icon class="icon" :icon="'ruler'"></fa-icon>
                      <p>
                        {{ item.surface }} m2 (
                        {{
                          parseFloat(item.pricePerSquareMeter).toLocaleString(
                            "fr"
                          )
                        }}
                        €/ m²
                        <span v-if="item.priceStats && item.priceStats.priceGap < 0" :style="item.priceStats.priceGap < 0
                          ? 'color:#23b523'
                          : 'color:red'
                          ">
                          {{
                            Math.round(parseFloat(item.priceStats.priceGap * 100))
                          }}
                          %
                        </span>
                        <span v-if="item.priceStats && item.priceStats.priceGap > 0" :style="item.priceStats.priceGap < 0
                          ? 'color:#23b523'
                          : 'color:red'
                          ">
                          {{
                            "+" +
                            Math.round(parseFloat(item.priceStats.priceGap * 100))
                          }}
                          %
                        </span>

                        )
                      </p>
                      <div class="ListPrice" v-if="item.priceStats">
                        <p>
                          Prix bas:
                          {{
                            parseFloat(item.priceStats.lowPrice).toLocaleString(
                              "fr"
                            )
                          }}
                          €/m
                        </p>
                        <p>
                          Prix médian:
                          {{
                            parseFloat(
                              item.priceStats.medianPrice
                            ).toLocaleString("fr")
                          }}
                          €/m
                        </p>
                        <p>
                          Prix haut:
                          {{
                            parseFloat(item.priceStats.highPrice).toLocaleString(
                              "fr"
                            )
                          }}
                          €/m
                        </p>
                      </div>
                    </div>
                    <div class="Box" v-if="item.rooms != null || item.bedrooms != null">
                      <fa-icon class="icon" :icon="'bed'"></fa-icon>
                      <p v-if="item.rooms != null">{{ item.rooms }} piéces</p>
                      <p v-if="item.bedrooms != null">
                        {{ item.bedrooms }} chambres
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="right">
              <h2>{{ parseFloat(item.price).toLocaleString("fr") }} €</h2>
              <p>{{ item.location.city }} ({{ item.location.postalCode }})</p>
              <p>Surface pondérée : {{ item.surface }} m²</p>
              <router-link :to="'Comparateur-ancien/details/' + item.uniqueId">
                <button class="PlusInfo">
                  Voir détails
                  <fa-icon :icon="'chevron-right'"></fa-icon>
                </button>
              </router-link>
              <div class="CheckboxContainer">
                <input class="Checkbox" :checked="checkedItems.includes(item.uniqueId)" type="checkbox"
                  @change="selectItemAvisValeur(item.uniqueId)" />
                <label for="">Avis valeur</label>
              </div>
            </div>
          </div>

          <div class="PropisitionSection">
            <b-collapse :id="'collapse-propositions-' + item.uniqueId" class="PropositionsContainer">
              <!-- <SkeletonLoading v-if="isLoading" /> -->
              <!-- Show the skeleton when data is loading -->


              <b-tabs nav-class="nav nav-pills" card no-fad>

                <div class="Loader" v-if="doneBasic === false">
                  <img class="img_logo_banque" :src="loadingbankBasic.bankPath" />
                  <div class="progressBar">
                    <div class="progressBarValue" :style="`width: ${getValue(loadingbankBasic.ident)}%;`"></div>
                  </div>
                </div>

                <b-tab title="Faisabilité validées">
                  <div class="TabHeader">
                    <div class="inputBox"
                      v-if="type != 'contre_ptz' && type != 'contre' && type != 'pinel' && type != 'pinel_neuf'">
                      <span class="clickable" @click="openOptionsModal('CoutProjet', true)">Coût du projet €</span>
                      <b-form-input type="number" class="inputField" v-model="coutDuProjet"
                        disabled></b-form-input>
                    </div>
                    <div class="inputBox" v-if="type != 'basic'">
                      <span>Apport</span>
                      <b-form-input type="number" class="inputField" v-model="projectCost.apport"
                        @change="fastUpdate(item.price)"></b-form-input>
                    </div>
                    <div class="inputBox" v-if="type != 'contre_ptz' && type != 'contre'">
                      <span>Durée</span>
                      <b-form-input type="number" class="inputField" v-model="duree_modificationRapide"
                        @change="fastUpdate(item.price)" :disabled="MensualiteToggle == true"></b-form-input>
                    </div>
                    <div class="inputBox "
                      v-if="type != 'contre_ptz' && type != 'contre' && type != 'pinel' && type != 'pinel_neuf'">
                      <span>Mensualité souhaitée</span>
                      <label :class="MensualiteToggle == true ? 'switchCtrl rounded lab toggleLabel' : 'switchCtrl rounded lab'">
                        <input id="check_client" name="check_client" type="checkbox" v-model="checkboxMensualite"  @change="resetMens(); MensualiteToggle = !MensualiteToggle"/>
                        <span class="toggle"></span>
                      </label>
                      <b-form-input type="number" class="inputField" id="Mens_modificationID" v-model="Mens_modificationRapide"
                        @change="fastUpdate(item.price)" :disabled="!MensualiteToggle"></b-form-input>
                      </div>
                    <div class="inputBox" v-if="checkboxMensualite">
                      <span>Taux d'interêt souhaité</span>
                      <b-form-input type="number" class="inputField" v-model="tiSouhaite_modificationRapide"
                        @change="testWrongInput(); fastUpdate(item.price);" ></b-form-input>
                    </div>
                    <div class="inputBox" v-if="checkboxMensualite">
                      <span>Taux d'assurance souhaité</span>
                      <b-form-input type="number" class="inputField" v-model="taSouhaite_modificationRapide"
                        @change="testWrongInput(); fastUpdate(item.price);"></b-form-input>
                    </div>
                    <div class="inputBox" v-if="type != 'contre_ptz' && type != 'contre'">
                      <button :disabled="!doneBasic" type="submit" class="btn CustomFusionner customBtn"
                        @click="genererPropositions(item.price)">
                        <i class="simple-icon-refresh CustomIcone mr-2 mt-1"></i> Générer propositions
                      </button>
                    </div>
                  </div>

                  <div class="TableContainer">
                    <table class="Tab1Table">
                      <thead>
                        <tr>
                          <th v-for="(item, index) in fields" :key="index">
                            <p v-if="item.label == `Prime d'assurance mensuelle`"
                              @click="openOptionsModal('PrimeAssurance', true)" class="clickable">{{ item.label }} {{
                                assuranceCustomer.quotite}} % <span v-if="assuranceCoemp != {}">{{ assuranceCoemp.quotite }} %</span></p>
                            <p v-else>{{ item.label }}</p>
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="loadingData">
                        <tr>
                          <td :colspan="fields.length">
                            <div class="Spinner"></div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr v-for="(item, index) in propostionsValidesBasic" :key="index">
                          <td class="FirstChild">
                            <input type="checkbox" :checked="item.negocier == 1" v-model="item.negocier" />
                          </td>
                          <td>
                            <img class="img_logo_banque" :src="item.bank.data.bankPath" />
                          </td>
                          <template v-if="item.has_error != 1">
                            <td>
                              <template v-if="item.isPtz == 1 || item.isRelais == 1">
                                <div
                                  class="cursor-pointer"
                                  v-on:click="afficheMontantEmprunte(item)"
                                >
                                  {{ item.value }}   
                                    <b-badge
                                      variant="info"
                                      v-if="item.isPtz == 1"
                                      style="background-color: #33b4cd;"
                                      >Ptz</b-badge
                                    >
                                    <b-badge
                                    variant="info"
                                    v-if="item.isRelais == 1"
                                    style="background-color: #33b4cd;"
                                    >Rélais 
                                    </b-badge >

                                    <b-badge
                                    variant="info"
                                    v-if="item.isRelais == 1 && item.mode_calcul_relais=='crd_refinance' && (item.type=='basic' || item.type=='contre')"
                                    style="background-color: #33b4cd;"
                                    > rachat 
                                    </b-badge >

                                    <b-badge
                                    variant="info"
                                    v-if="item.isRelais == 1 && item.mode_calcul_relais=='crd_rembourser' && (item.type=='basic' || item.type=='contre')"
                                    style="background-color: #33b4cd;"
                                    > Classique
                                    </b-badge >

                                    <b-badge
                                    variant="info"
                                    v-if="item.isRelais == 1 && item.mode_calcul_relais=='crd_refinance_sg' && (item.type=='basic' || item.type=='contre') "
                                    style="background-color: #33b4cd;"
                                    >Rachat
                                    </b-badge >
                                </div>
                              </template>
                              <template v-else>
                                {{ item.montant_emprunt }}
                              </template>
                            </td>
                            <td>{{ item.montant_project }}</td>
                            <td>{{ item.duration }}</td>
                            <td class="clickable"
                              @click="FillDetailsGarantieProposition(item.garantiList); openOptionsModal('somme_garanties', true)">{{
                                item.somme_garanties
                              }}</td>
                            <td>{{ item.frais_dossier }}</td>
                            <td class="clickable"
                              @click="afficheTauxFixe(index, item.id, item, item.bank.data.bankId); openOptionsModal('ti', true)">
                              {{ item.ti }}</td>
                            <td>{{ item.ti_recommended }}</td>
                            <td class="clickable"
                              @click="afficheTauxAssurance(index, item.id, item, item.bank.data.bankId); openOptionsModal('ta', true)">
                              {{ item.ta }}</td>
                            <td>{{ item.mensualite }}</td>
                            <td>{{ item.montant_assurance }}</td>
                            <!-- <td class="TogglingPrime">
                              <input type="checkbox" :checked="item.is_feasibility_validated == 1" />
                              <div class="BarsIcon">
                                <fa-icon :icon="'bars'" @click="openOptionsModal('AssuranceDelegueeM', true)"></fa-icon>
                              </div>
                            </td> -->
                            <td>{{ item.mensualite_with_assurance }}</td>
                            <td class="clickable" @click="afficheCoutTotal(item.coutProjet); openOptionsModal('cout_pret', true)">{{
                              item.cout_pret }}</td>
                            <td class="clickable" @click="afficheFaisabilite(item); openOptionsModal('FaisabiliteM', true)">
                              <fa-icon :icon="'info'"></fa-icon>
                            </td>
                          </template>
                          <template v-else>
                            <td :colspan="fields.length" style="text-align: left;">{{ item.item.error_msg }}</td>
                          </template>
                          <!-- <td>{{ item.eco_realise == null ? '-' : item.eco_realise }}</td> -->
                        </tr>
                        <tr class="Empty" v-if="propostionsValidesBasic.length == 0">
                          <td :colspan="fields.length"> Aucune donnée à afficher</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-tab>
                <b-tab title="Faisabilité non validées">
                  <div class="TabHeader">
                    <div class="inputBox"
                      v-if="type != 'contre_ptz' && type != 'contre' && type != 'pinel' && type != 'pinel_neuf'">
                      <span class="clickable" @click="openOptionsModal('CoutProjet', true)">Coût du projet €</span>
                      <b-form-input type="number" class="inputField" v-model="coutDuProjet"
                        disabled></b-form-input>
                    </div>
                    <div class="inputBox" v-if="type != 'basic'">
                      <span>Apport</span>
                      <b-form-input type="number" class="inputField" v-model="duree_modificationRapide"
                        @change="fastUpdate(item.price)"></b-form-input>
                    </div>
                    <div class="inputBox" v-if="type != 'contre_ptz' && type != 'contre'">
                      <span>Durée</span>
                      <b-form-input type="number" class="inputField" v-model="duree_modificationRapide"
                        @change="fastUpdate(item.price)" :disabled="MensualiteToggle == true"></b-form-input>
                    </div>
                    <div class="inputBox "
                      v-if="type != 'contre_ptz' && type != 'contre' && type != 'pinel' && type != 'pinel_neuf'">
                      <span>Mensualité souhaitée</span>
                      <label :class="MensualiteToggle == true ? 'switchCtrl rounded lab toggleLabel' : 'switchCtrl rounded lab'">
                        <input id="check_client" name="check_client" type="checkbox" v-model="checkboxMensualite"  @change="resetMens(); MensualiteToggle = !MensualiteToggle"/>
                        <span class="toggle"></span>
                      </label>
                      <b-form-input type="number" class="inputField" id="Mens_modificationID" v-model="Mens_modificationRapide"
                        @change="fastUpdate(item.price)" :disabled="!MensualiteToggle"></b-form-input>
                      </div>
                    <div class="inputBox" v-if="checkboxMensualite">
                      <span>Taux d'interêt souhaité</span>
                      <b-form-input type="number" class="inputField" v-model="tiSouhaite_modificationRapide"
                        @change="testWrongInput(); fastUpdate(item.price);"></b-form-input>
                    </div>
                    <div class="inputBox" v-if="checkboxMensualite">
                      <span>Taux d'assurance souhaité</span>
                      <b-form-input type="number" class="inputField" v-model="taSouhaite_modificationRapide"
                        @change="testWrongInput(); fastUpdate(item.price);"></b-form-input>
                    </div>
                    <div class="inputBox" v-if="type != 'contre_ptz' && type != 'contre'">
                      <button :disabled="!doneBasic" type="submit" class="btn CustomFusionner customBtn"
                        @click="genererPropositions(item.price)">
                        <i class="simple-icon-refresh CustomIcone mr-2 mt-1"></i> Générer propositions
                      </button>
                    </div>
                  </div>

                  <div class="TableContainer">
                    <table class="Tab1Table">
                      <thead>
                        <tr>
                          <th v-for="(item, index) in fields" :key="index">
                            <p v-if="item.label == `Prime d'assurance mensuelle`"
                              @click="openOptionsModal('PrimeAssurance', true)" class="clickable">{{ item.label }} {{
                                assuranceCustomer.quotite}} % <span v-if="assuranceCoemp != {}">{{ assuranceCoemp.quotite }} %</span></p>
                            <p v-else>{{ item.label }}</p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in propositionsInvalidesBasic" :key="index">
                          <td class="FirstChild">
                            <input type="checkbox" :checked="item.negocier == 1" v-model="item.negocier" />
                          </td>
                          <td>
                            <img class="img_logo_banque" :src="item.bank.data.bankPath" />
                          </td>
                          <template v-if="item.has_error != 1">
                            <td>
                              <template v-if="item.isPtz == 1 || item.isRelais == 1">
                                <div
                                  class="cursor-pointer"
                                  v-on:click="afficheMontantEmprunte(item)"
                                >
                                  {{ item.montant_emprunt }}   
                                    <b-badge
                                      variant="info"
                                      v-if="item.isPtz == 1"
                                      style="background-color: #33b4cd;"
                                      >Ptz</b-badge
                                    >
                                    <b-badge
                                    variant="info"
                                    v-if="item.isRelais == 1"
                                    style="background-color: #33b4cd;"
                                    >Rélais 
                                    </b-badge >

                                    <b-badge
                                    variant="info"
                                    v-if="item.isRelais == 1 && item.mode_calcul_relais=='crd_refinance' && (item.type=='basic' || item.type=='contre')"
                                    style="background-color: #33b4cd;"
                                    > rachat 
                                    </b-badge >

                                    <b-badge
                                    variant="info"
                                    v-if="item.isRelais == 1 && item.mode_calcul_relais=='crd_rembourser' && (item.type=='basic' || item.type=='contre')"
                                    style="background-color: #33b4cd;"
                                    > Classique
                                    </b-badge >

                                    <b-badge
                                    variant="info"
                                    v-if="item.isRelais == 1 && item.mode_calcul_relais=='crd_refinance_sg' && (item.type=='basic' || item.type=='contre') "
                                    style="background-color: #33b4cd;"
                                    >Rachat
                                    </b-badge >
                                </div>
                              </template>
                              <template v-else>
                                {{ item.montant_emprunt }}
                              </template>
                            </td>
                            <td>{{ item.montant_project }}</td>
                            <td>{{ item.duration }}</td>
                            <td class="clickable"
                              @click="FillDetailsGarantieProposition(item.garantiList); openOptionsModal('somme_garanties', true)">{{
                                item.somme_garanties
                              }}</td>
                            <td>{{ item.frais_dossier }}</td>
                            <td class="clickable"
                              @click="afficheTauxFixe(index, item.id, item, item.bank.data.bankId); openOptionsModal('ti', true)">
                              {{ item.ti }}</td>
                            <td>{{ item.ti_recommended }}</td>
                            <td class="clickable"
                              @click="afficheTauxAssurance(index, item.id, item, item.bank.data.bankId); openOptionsModal('ta', true)">
                              {{ item.ta }}</td>
                            <td>{{ item.mensualite }}</td>
                            <td>{{ item.montant_assurance }}</td>
                            <!-- <td class="TogglingPrime">
                              <input type="checkbox" :checked="item.is_feasibility_validated == 1" />
                              <div class="BarsIcon">
                                <fa-icon :icon="'bars'" @click="openOptionsModal('AssuranceDelegueeM', true)"></fa-icon>
                              </div>
                            </td> -->
                            <td>{{ item.mensualite_with_assurance }}</td>
                            <td class="clickable" @click="afficheCoutTotal(item.coutProjet); openOptionsModal('cout_pret', true)">{{
                              item.cout_pret }}</td>
                            <td class="clickable" @click="afficheFaisabilite(item); openOptionsModal('FaisabiliteM', true)">
                              <fa-icon :icon="'info'"></fa-icon>
                            </td>
                          </template>
                          <template v-else>
                            <td :colspan="fields.length" style="text-align: left;">{{ item.error_msg }}</td>
                          </template>
                          <!-- <td>{{ item.eco_realise == null ? '-' : item.eco_realise }}</td> -->
                        </tr>
                        <tr class="Empty" v-if="propositionsInvalidesBasic.length == 0">
                          <td :colspan="fields.length"> Aucune donnée à afficher</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-tab>
              </b-tabs>

            </b-collapse>
          </div>

        </div>
      </div>

      <!-- <div class="content">
          <div class="Card_content">
            <div
              class="card content-card"
              style="
                display: inline-table;
                background-color: white;
                margin-bottom: 20px;
              "
              v-for="(item, index) in ListeBienAncien"
              :key="index"
            >
              <div class="content-card-details">
                <div class=" ">
                  <div class=" " style="width: 450px; padding: 9px">
                    <vueper-slides fixed-height="265px">
                      <vueper-slide
                        v-for="(slide, i) in item.pictureUrls"
                        :key="i"
                        :image="slide"
                      />
                    </vueper-slides>
                  </div>
                </div>
                <div class=" ">
                  <div style="background: #fbfbfb; padding: 5px 0px 5px">
                    <fa-icon
                      :icon="'home'"
                      style="
                        font-weight: lighter;
                        font-size: 20px;
                        color: #22abc5;
                        margin-right: 4px;
                      "
                    />
                    <span
                      style="
                        font-size: 20px;
                        margin-top: 0px;
                        color: #22abc5;
                        font-weight: 700;
                      "
                      >{{ item.title }}
                      <span style="font-size: 13px"
                        >référencée le {{ distanceFromNow(item.publicationDate) }}
                      </span></span
                    >
                  </div>
                  <p
                    class="content-type mt-5"
                    style="margin-top: 10px; width: 25%; color: #111212"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 33.899 35.835"
                      style="color: #111212"
                    >
                      <g
                        id="user-symbol-of-thin-outline"
                        transform="translate(-20.85 0.5)"
                      >
                        <g
                          id="Groupe_3"
                          data-name="Groupe 3"
                          transform="translate(21.35)"
                        >
                          <g
                            id="Groupe_1"
                            data-name="Groupe 1"
                            transform="translate(7.382)"
                          >
                            <path
                              id="Tracé_1"
                              data-name="Tracé 1"
                              d="M193.219,18.138a9.069,9.069,0,1,1,9.074-9.069A9.078,9.078,0,0,1,193.219,18.138Zm0-17.24a8.174,8.174,0,1,0,8.171,8.171A8.182,8.182,0,0,0,193.219.9Z"
                              transform="translate(-184.15)"
                              fill="#111212"
                              stroke="#111212"
                              stroke-width="1"
                            />
                          </g>
                          <g
                            id="Groupe_2"
                            data-name="Groupe 2"
                            transform="translate(0 21.127)"
                          >
                            <path
                              id="Tracé_2"
                              data-name="Tracé 2"
                              d="M54.248,479.608H21.377l-.027-5.514a8.257,8.257,0,0,1,1.823-5.21,8.431,8.431,0,0,1,4.571-2.916l.05-.014h.054l19.975-.054.059.018a8.784,8.784,0,0,1,4.507,3,8.351,8.351,0,0,1,1.855,5.174l0,5.519Zm-31.978-.893h31.08v-4.621a7.453,7.453,0,0,0-1.66-4.616A7.917,7.917,0,0,0,47.7,466.8l-19.8.054a7.515,7.515,0,0,0-4.031,2.589,7.365,7.365,0,0,0-1.628,4.648Z"
                              transform="translate(-21.35 -465.9)"
                              fill="#111212"
                              stroke="#111212"
                              stroke-width="1"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                    Type d'annonceur : {{ item.publisher.type }}
                  </p>
                  <p
                    style="
                      min-height: 100px;
                      max-height: 100px;
                      width: 1000px;
                      margin-right: 50px;
                      color: #333;
                      text-transform: lowercase;
                      text-align: justify;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 9;
                      -webkit-box-orient: vertical;
                    "
                  >
                    {{ item.description }}
                  </p>
                  <b-badge
                    v-if="item.buildingFloors != null"
                    style="
                      margin-right: 5px;
                      background-color: #e8e8e8;
                      padding: 7px;
                      color: #111212;
                    "
                    ><i class="far fa-building"></i>
                    {{ item.buildingFloors }} étages</b-badge
                  >
                  <b-badge
                    v-if="item.landSurface != null"
                    style="
                      margin-right: 5px;
                      background-color: #e8e8e8;
                      padding: 7px;
                      color: #111212;
                    "
                  >
                    <i class="fas fa-ruler-vertical"></i>
                    {{ item.landSurface }} m²</b-badge
                  >

                  <b-badge
                    v-if="item.options.includes('hasGarage')"
                    style="
                      margin-right: 5px;
                      background-color: #e8e8e8;
                      padding: 7px;
                      color: #111212;
                    "
                  >
                    <i class="fas fa-car"></i> Garage</b-badge
                  >
                  <b-badge
                    v-if="item.options.includes('hasParking')"
                    style="
                      margin-right: 5px;
                      background-color: #e8e8e8;
                      padding: 7px;
                      color: #111212;
                    "
                  >
                    <i class="fas fa-parking"></i> Parking</b-badge
                  >
                  <b-badge
                    v-if="item.options.includes('hasGarden')"
                    style="
                      margin-right: 5px;
                      background-color: #e8e8e8;
                      padding: 7px;
                      color: #111212;
                    "
                  >
                    <i class="fas fa-tree"></i> Jardin</b-badge
                  >
                  <b-badge
                    v-if="item.options.includes('hasCave')"
                    style="
                      margin-right: 5px;
                      background-color: #e8e8e8;
                      padding: 7px;
                      color: #111212;
                    "
                  >
                    <i class="fas fa-closed-captioning"></i> Cave</b-badge
                  >
                  <b-badge
                    v-if="item.energyGrade != null"
                    style="
                      margin-right: 5px;
                      background-color: #e8e8e8;
                      padding: 7px;
                      color: #111212;
                    "
                  >
                    <i class="fas fa-fire"></i> DPE : {{ item.energyGrade }}
                  </b-badge>
                  <b-badge
                    v-if="item.gasGrade != null"
                    style="
                      margin-right: 5px;
                      background-color: #e8e8e8;
                      padding: 7px;
                      color: #111212;
                    "
                  >
                    <i class="fas fa-fire"></i> GES : {{ item.gasGrade }}
                  </b-badge>
                  <div
                    class="content-card-details"
                    style="justify-content: center"
                  >
                    <div
                      style="
                        display: flex;
                        text-align: center;
                        width: 25%;
                        display: block !important;
                        padding: 5px;
                        color: #22abc5;
                        font-weight: 700;
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.5"
                        height="18"
                        viewBox="0 0 16.5 22"
                        style="margin-bottom: 10px"
                      >
                        <path
                          id="Icon_awesome-map-marker-alt"
                          data-name="Icon awesome-map-marker-alt"
                          d="M7.4,21.556C1.159,12.505,0,11.576,0,8.25a8.25,8.25,0,0,1,16.5,0c0,3.326-1.159,4.255-7.4,13.306a1.032,1.032,0,0,1-1.7,0Zm.848-9.869A3.438,3.438,0,1,0,4.813,8.25,3.437,3.437,0,0,0,8.25,11.688Z"
                          fill="#ff8c00"
                        />
                      </svg>
                      <br />

                      {{ item.location.city }} ({{ item.location.postalCode }})
                      <br />
                      {{ item.location.population }} hab
                      <br />
                      Taxe foncière : {{ item.location.propertyTaxRate }} %
                      <br /><br />
                      <button
                        class="alert btn_details"
                        @click="openNewTab(item)"
                        v-if="
                          item.location != null &&
                          item.location != undefined &&
                          item.location.coordinates != null &&
                          item.location.coordinates != undefined &&
                          item.location.coordinates.length > 0
                        "
                      >
                        <fa-icon :icon="{ prefix: 'fas', iconName: 'info' }" />
                        Position
                      </button>
                    </div>
                    <div
                      style="
                        display: flex;
                        text-align: center;
                        width: 25%;
                        display: block !important;
                        padding: 5px;
                        color: #22abc5;
                        font-weight: 700;
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="18"
                        viewBox="0 0 22 22"
                        style="
                          margin-right: 15px;
                          vertical-align: bottom;
                          margin-bottom: 10px;
                        "
                      >
                        <path
                          id="Icon_material-euro-symbol"
                          data-name="Icon material-euro-symbol"
                          d="M19.167,23.444a7.92,7.92,0,0,1-7.04-4.278h7.04V16.722H11.32a7.688,7.688,0,0,1,0-2.444h7.847V11.833h-7.04a7.929,7.929,0,0,1,12.21-2.359L26.5,7.311A10.984,10.984,0,0,0,8.8,11.833H4.5v2.444H8.24a10.222,10.222,0,0,0,0,2.444H4.5v2.444H8.8a10.984,10.984,0,0,0,17.7,4.522l-2.176-2.163a7.829,7.829,0,0,1-5.158,1.919Z"
                          transform="translate(-4.5 -4.5)"
                          fill="#ff8c00"
                        />
                      </svg>
                      <br />
                      {{ parseFloat(item.price).toLocaleString("fr") }} €
                      <br />
                      <template v-if="item.priceStats">
                        Loyer estimé :
                        {{
                          parseFloat(item.priceStats.rent).toLocaleString("fr")
                        }}
                        €
                        <br />
                        Rentabilité brute :
                        {{
                          parseFloat(
                            item.priceStats.profitability * 100
                          ).toLocaleString("fr")
                        }}
                        %
                      </template>
                    </div>
                    <div
                      style="
                        display: flex;
                        text-align: center;
                        width: 25%;
                        display: block !important;
                        padding: 5px;
                        color: #22abc5;
                        font-weight: 700;
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="18"
                        viewBox="0 0 24 24"
                        style="
                          margin-right: 15px;
                          vertical-align: bottom;
                          margin-bottom: 10px;
                        "
                      >
                        <path
                          id="Icon_awesome-ruler-combined"
                          data-name="Icon awesome-ruler-combined"
                          d="M7.5,13.5H4.875a.375.375,0,0,1-.375-.375v-.75A.375.375,0,0,1,4.875,12H7.5V9H4.875A.375.375,0,0,1,4.5,8.625v-.75A.375.375,0,0,1,4.875,7.5H7.5v-3H4.875A.375.375,0,0,1,4.5,4.125v-.75A.375.375,0,0,1,4.875,3H7.5V1.5A1.5,1.5,0,0,0,6,0H1.5A1.5,1.5,0,0,0,0,1.5v21a1.443,1.443,0,0,0,.074.366L7.5,15.44Zm15,3H21v2.625a.375.375,0,0,1-.375.375h-.75a.375.375,0,0,1-.375-.375V16.5h-3v2.625a.375.375,0,0,1-.375.375h-.75A.375.375,0,0,1,15,19.125V16.5H12v2.625a.375.375,0,0,1-.375.375h-.75a.375.375,0,0,1-.375-.375V16.5H8.561L1.134,23.926A1.447,1.447,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V18A1.5,1.5,0,0,0,22.5,16.5Z"
                          fill="#ff8c00"
                        />
                      </svg>
                      <br />

                      {{ item.surface }} m2 (
                      {{
                        parseFloat(item.pricePerSquareMeter).toLocaleString("fr")
                      }}
                      €/ m²
                      <span
                        v-if="item.priceStats"
                        :style="
                          item.priceStats.priceGap < 0
                            ? 'color:#23b523'
                            : 'color:red'
                        "
                      >
                        {{
                          Math.round(parseFloat(item.priceStats.priceGap * 100))
                        }}
                        %
                      </span>
                      )
                      <br />
                      <template v-if="item.priceStats">
                        Prix bas :
                        {{
                          parseFloat(item.priceStats.lowPrice).toLocaleString(
                            "fr"
                          )
                        }}
                        € / m²
                        <br />
                        Prix médian :
                        {{
                          parseFloat(item.priceStats.medianPrice).toLocaleString(
                            "fr"
                          )
                        }}
                        € / m²
                        <br />
                        Prix haut :
                        {{
                          parseFloat(item.priceStats.highPrice).toLocaleString(
                            "fr"
                          )
                        }}
                        € / m²
                      </template>
                    </div>
                    <div
                      style="
                        display: flex;
                        text-align: center;
                        width: 25%;
                        display: block !important;
                        padding: 5px;
                        color: #22abc5;
                        font-weight: 700;
                      "
                    >
                      <svg
                        fill="rgb(255, 140, 0)"
                        height="25"
                        width="30"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 511.998 511.998"
                        xml:space="preserve"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <g>
                            <g>
                              <path
                                d="M235.561,335.822c-15.536,0-28.138-12.183-28.746-27.641c-0.253-6.419-0.302-12.887-0.119-19.576h-81.239 c3.829-4.03,6.193-9.464,6.193-15.461c0-12.409-10.059-22.468-22.468-22.468h-0.313c15.053-3.356,26.432-16.645,26.728-32.747 c0.347-18.884-14.682-34.475-33.567-34.821c-18.884-0.347-34.475,14.682-34.821,33.566c-0.303,16.526,11.168,30.529,26.694,34.002 H52.657V136.21c0-6.283-5.093-11.376-11.376-11.376H11.376C5.093,124.834,0,129.927,0,136.21l0.199,219.577 c0,7.755,6.288,14.043,14.043,14.043h24.474v8.229c0,5.028,4.076,9.104,9.104,9.104h45.669c5.028,0,9.104-4.076,9.104-9.104 v-8.229H408.25v8.229c0,5.028,4.076,9.104,9.104,9.104h45.669c5.028,0,9.104-4.076,9.104-9.104v-8.229h21.509 c7.755,0,14.043-6.288,14.043-14.043v-20.156C458.447,335.663,252.037,335.822,235.561,335.822z"
                              ></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M320.098,214.364c-0.001-0.001-0.002-0.003-0.003-0.004c-4.804-7.754-15.006-10.108-22.711-5.337 c-0.001,0-0.002,0.001-0.003,0.002l-48.526,30.055l-57.053-26.148l26.78,4.723c4.175-12.724,8.895-23.192,13.237-31.378 l-62.089-1.14c-12.892-0.236-23.294,10.163-23.523,22.674l-0.756,41.192c-0.231,12.712,10.003,23.292,22.677,23.524l39.412,0.723 c0.212-2.548,0.457-5.052,0.732-7.511l-28.126-21.845c0.247,0.114,63.004,28.875,63.004,28.875 c4.798,2.198,10.74,2.012,15.561-0.974l56.047-34.714C322.536,232.265,324.881,222.086,320.098,214.364z"
                              ></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M463.476,208.226c-62.726-18.113-164.001-31.505-201.971-30.431c0,0-12.598,14.513-22.559,43.451l6.706,1.182 l43.387-26.873c14.998-9.289,34.99-4.931,44.525,10.466c9.365,15.118,4.772,35.091-10.466,44.526l-56.047,34.714 c-13.218,8.188-27.946,4.425-33.623,0.017l-5.883-4.569c-0.503,8.387-0.643,17.255-0.272,26.666 c0.175,4.45,3.831,7.971,8.285,7.971H497.76c4.068,0,7.537-2.95,8.189-6.965l5.294-32.56 C516.415,244.021,494.427,217.163,463.476,208.226z"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <br />
                      {{ item.rooms }} pièces
                      <br />
                      <br />
                      {{ item.bedrooms }} chambres
                      <br />
                    </div>
                  </div>
                </div>
                <div class=" ">
                  <div class="card-blocData" style="width: 100%">
                    <div
                      class="titlecolor price"
                      style="
                        margin-top: 0px;
                        background: rgb(251, 251, 251);
                        padding: 5px 0px;
                      "
                    >
                      {{ parseFloat(item.price).toLocaleString("fr") }} €
                    </div>

                    <template v-if="item.origin == 'etreproprio'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/etreproprio.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 25px"
                        />
                      </a>
                      <br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'properstar'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/properstar.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 50px"
                        />
                      </a>
                      <br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'leboncoin'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/boncoin.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 25px"
                      /></a>
                      <br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'seloger'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/se_loger.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 25px"
                        /> </a
                      ><br :key="index + 'br'" />
                    </template>

                    <template v-else-if="item.origin == 'foncia'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/foncia.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 40px"
                        /> </a
                      ><br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'ouestfrance'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/ouestfrance.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 25px"
                      /></a>
                      <br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'avendrealouer'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/avendre_alouer.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 25px"
                      /></a>
                      <br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'bienici'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/bien_ici.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 25px"
                      /></a>
                      <br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'greenacres'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/greenacres.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 25px"
                        /> </a
                      ><br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'proprietesfigaro'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/proprietesfigaro.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 25px"
                      /></a>
                      <br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'paruvendu'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/paruvendu.jpg"
                          :key="index + 'img'"
                          style="width: 80px; height: 50px"
                        /> </a
                      ><br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'notaires'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/notaires.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 50px"
                      /></a>
                      <br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'maisonsetappartements'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/maison_appartement.jpg"
                          :key="index + 'img'"
                          style="width: 80px; height: 50px"
                        /> </a
                      ><br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'bellesdemeures'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/belledemeure.jpg"
                          :key="index + 'img'"
                          style="width: 80px; height: 60px"
                        /> </a
                      ><br :key="index + 'br'" />
                    </template>

                    <template v-else-if="item.origin == 'figaro'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/figaro.png"
                          :key="index + 'img'"
                          style="width: 101px; height: 30px"
                        /> </a
                      ><br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'megagence'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/megaagence.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 60px"
                        /> </a
                      ><br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'stephaneplaza'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/stephaneplaza.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 60px"
                        /> </a
                      ><br :key="index + 'br'" />
                    </template>
                    <template v-else-if="item.origin == 'nestenn'">
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                      >
                        <img
                          src="/img/nestenn.png"
                          :key="index + 'img'"
                          style="width: 80px; height: 60px"
                        />
                      </a>
                      <br :key="index + 'br'" />
                    </template>
                    <template v-else>
                      <br :key="index + 'duplicate_br'" />
                      <a
                        :key="index + 'duplicate'"
                        target="_blank"
                        :href="item.url"
                        style="color: #22abc5; font-size: 18px"
                        >{{ item.origin }}</a
                      >
                      <br :key="index + 'duplicate_br'" />
                    </template>

                    <br />
                    <template v-for="(dupl, index) in item.duplicates">
                      <template v-if="dupl.origin == 'etreproprio'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/etreproprio.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 25px"
                          />
                        </a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'properstar'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/properstar.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 50px"
                          />
                        </a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'leboncoin'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/boncoin.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 25px"
                        /></a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'seloger'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/se_loger.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 25px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>

                      <template v-else-if="dupl.origin == 'foncia'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/foncia.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 40px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'ouestfrance'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/ouestfrance.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 25px"
                        /></a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'avendrealouer'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/avendre_alouer.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 25px"
                        /></a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'bienici'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/bien_ici.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 25px"
                        /></a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'greenacres'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/greenacres.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 25px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'proprietesfigaro'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/proprietesfigaro.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 25px"
                        /></a>
                        <br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'paruvendu'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/paruvendu.jpg"
                            :key="index + 'img'"
                            style="width: 80px; height: 50px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'notaires'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/notaires.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 50px"
                        /></a>
                        <br :key="index + 'br'" />
                      </template>
                      <template
                        v-else-if="dupl.origin == 'maisonsetappartements'"
                      >
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/maison_appartement.jpg"
                            :key="index + 'img'"
                            style="width: 80px; height: 50px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'bellesdemeures'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/belledemeure.jpg"
                            :key="index + 'img'"
                            style="width: 80px; height: 60px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>

                      <template v-else-if="dupl.origin == 'figaro'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/figaro.png"
                            :key="index + 'img'"
                            style="width: 101px; height: 30px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'megagence'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/megaagence.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 60px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'stephaneplaza'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/stephaneplaza.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 60px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>
                      <template v-else-if="dupl.origin == 'nestenn'">
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                        >
                          <img
                            src="/img/nestenn.png"
                            :key="index + 'img'"
                            style="width: 80px; height: 60px"
                          /> </a
                        ><br :key="index + 'br'" />
                      </template>
                      <template v-else>
                        <br :key="index + 'duplicate_br'" />
                        <a
                          :key="index + 'duplicate'"
                          target="_blank"
                          :href="dupl.url"
                          style="color: #22abc5; font-size: 18px"
                          >{{ dupl.origin }}</a
                        >
                        <br :key="index + 'duplicate_br'" />
                      </template>
                    </template>

                    <div v-if="item.location">
                      {{ item.location.city }} ({{ item.location.postalCode }})
                    </div>
                    <div>Surface pondérée : {{ item.surface }} m2</div>
                  </div>
                  <router-link
                    :to="'Comparateur-ancien/details/' + item.uniqueId"
                    style="float: right"
                  >
                    <button class="alert btn_details">
                      Voir détails
                      <fa-icon
                        :icon="{ prefix: 'fas', iconName: 'chevron-right' }"
                      />
                    </button>
                  </router-link>
                  <br />

                  <div style="float: right; margin-top: 15px">
                    <input
                      :checked="checkedItems.includes(item.uniqueId)"
                      type="checkbox"
                      @change="selectItemAvisValeur(item.uniqueId)"
                    />
                    Avis valeur
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

      <div class="col-lg-10 col-md-9 col-xs-7">
        <b-pagination v-model="page" :total-rows="totalAncien" :per-page="perPage" class="my-0"></b-pagination>
      </div>
    </div>

    <ModalCoutProjet :OperationType="OperationType" :data="projectCost" :modalTitle="'Coût du projet'"
      :showModal="modalCoutProjetVisible" @close-modal="closeModal" />



  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Input from "./Input";
import ClickOutside from "vue-click-outside";
import { mixin as clickaway } from "vue-clickaway";
import ModalCoutProjet from "./ModalCoutProjet.vue";
//  import ModelLocation from "./ModelLocation";
// import ModelBudget from "./ModelBudget";
// import ModelType from "./ModelType";
// import ModelSurface from "./ModelSurface";
// import ModelNotation from "./ModelNotation";
// import ModelCritere from "./ModelCritere";
// import ModelAlert from "./ModelAlert";
// import Select from "./Select";
import Star from "./Star";
// import slider from "./Slide";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import Multiselect from "vue-multiselect";
import moment from "moment";


export default {
  mixins: [clickaway],

  data() {
    return {
      AnnonceursSelectedNoList: [],
      radioAnnocObj: {
        id:'',
        status: '',
      },
      typeAssurance: 19,
      typeAssurancesList:[
        { value: 19, text: 'Nouveaux financement' },
        { value: 20, text: 'Reprise d\'assurance Hamon (-1 an)' },
        { value: 21, text: 'Reprise d\'assurance Bourquin (+1 an)' },
        { value: 22, text: 'Complément de quotité à un contrat ADE' }
      ],
      assuranceCustomer: {
        quotite: null
      },
      assuranceCoemp: {
        quotite: null
      },
      loadingData: false,
      indexForUpdate: null,
      idPropositionFoUpdate: null,
      TauxFixUpdate: {
        ti: null,
        ti_relais: null,
        isRelais: false,
      },
      TauxAssuranceUpdate: {
        ta_emp: null,
        ta_coemp2: null,
      },
      TemptauxState: null,
      propositionisLoading: false,
      progresstionBar: 0,
      currentBankImage: "",
      checkedItems: [],
      moment: moment,
      maxLength: 10,
      url: null,
      perPage: 9,
      page: 1,
      categorie: [{ value: "house", text: "Maison" }],
      type_vendeur: [
        { value: "professional", text: "Pro" },
        { value: "individual", text: "Particulier" },
      ],
      LocationProjet: [],
      ModelLocation: false,
      location: null,
      annonce: null,
      priceMin: null,
      priceMax: null,
      roomsMax: null,
      roomsMin: null,
      bedroomsMin: null,
      bedroomsMax: null,
      surfaceMin: null,
      surfaceMax: null,
      sortby: 'creationDate-desc',
      radius: null,
      rentMin: null,
      rentMax: null,
      constructionYearMin: null,
      constructionYearMax: null,
      buildingsFloorMin: null,
      buildingsFloorMax: null,
      energyGradeMin: null,
      energyGradeMax: null,
      gasGradeMin: null,
      gasGradeMax: null,
      optionsfilter: [
        { value: "isOld", text: "Ancien" },
      ],
      annonceursFilter:[],
      keywords: [],
      keywordsOperator: 'and',
      newKeyword: "",
      autocompleteOptions: [], // List of predefined keywords for autocomplete
      showAutocomplete: false,

      floorMin: null,
      floorMax: null,
      landSurfaceMin: null,
      landSurfaceMax: null,
      pricePerSquareMeterMin: null,
      pricePerSquareMeterMax: null,
      propertyChargesMin: null,
      propertyChargesMax: null,
      propertyTaxMin: null,
      propertyTaxMax: null,
      PlatformesImmo: [],
      plus_critere: false,
      selectedIndex: -1,

      ListeCategorie: [
        { value: "house", text: "Maison" },
        { value: "flat", text: "Appart" },
        { value: "bloc", text: "Immeuble" },
        { value: "land", text: "Terrain" },
        { value: "parking", text: "Parking/Garage" },
        { value: "office", text: "Bureau" },
        { value: "premises", text: "Local" },
        { value: "shop", text: "Commerce" },
        { value: "misc", text: "Autres" },
      ],
      ListeSortBy: [
        { value: "creationDate-asc", text: "Date de création croissante" },
        { value: "creationDate-desc", text: "Date de création décroissante" },
        { value: "price-asc", text: "Prix croissant" },
        { value: "price-desc", text: "Prix décroissant" },
        { value: "pricePerSquareMeter-asc", text: "Prix m² croissant" },
        { value: "pricePerSquareMeter-desc", text: "Prix m² décroissant" },
        { value: "lastPriceChangeDate-asc", text: "Date de dernière modification de prix croissante" },
        { value: "lastPriceChangeDate-desc", text: "Date de dernière modification de prix décroissante" },
        { value: "lastPublicationDate-asc", text: "Date de dernière publication croissante" },
        { value: "lastPublicationDate-desc", text: "Date de dernière publication décroissante" },
      ],
      PlateformesImmoListe: [
        { value: "avendrealouer", text: "Avendre a louer" },
        { value: "leboncoin", text: "le Boncoin" },
        { value: "logicimmo", text: "logicimmo" },
        { value: "pap", text: "pap" },
        { value: "seloger", text: "seloger" },
        { value: "bienici", text: "bien ici" },
        { value: "figaro", text: "figaro" },
        { value: "paruvendu", text: "paruvendu" },
        { value: "lesiteimmo", text: "le site immo" },
        { value: "vivastreet", text: "vivastreet" },
        { value: "etreproprio", text: "etreproprio" },
        { value: "immonot", text: "immonot" },
        { value: "immoregion", text: "immoregion" },
        { value: "ouestfrance", text: "ouestfrance" },
        { value: "maisonsetappartements", text: "maisonsetappartements" },
        { value: "notaires", text: "notaires" },
        { value: "greenacres", text: "greenacres" },
        { value: "aucoeurdelimmo", text: "aucoeurdelimmo" },
        { value: "domimmo", text: "domimmo" },
        { value: "bellesdemeures", text: "bellesdemeures" },
        { value: "gensdeconfiance", text: "gensdeconfiance" },
        { value: "proprietesfigaro", text: "proprietesfigaro" },
        { value: "bureauxlocaux", text: "bureauxlocaux" },
        { value: "luxresidence", text: "luxresidence" },
        { value: "labonnepierre", text: "labonnepierre" },
        { value: "surfaceprivee", text: "surfaceprivee" },
        { value: "bellespierres", text: "bellespierres" },
        { value: "residencesimmobilier", text: "residencesimmobilier" },
        { value: "adaptimmobilier", text: "adaptimmobilier" },
        { value: "laforet", text: "laforet" },
        { value: "safti", text: "safti" },
        { value: "orpi", text: "orpi" },
        { value: "capifrance", text: "capifrance" },
        { value: "guyhoquet", text: "guyhoquet" },
        { value: "iad", text: "iad" },
        { value: "century21", text: "century21" },
        { value: "foncia", text: "foncia" },
        { value: "repimmo", text: "repimmo" },
        { value: "era", text: "era" },
        { value: "citya", text: "citya" },
        { value: "human", text: "human" },
        { value: "era", text: "era" },
        { value: "nestenn", text: "nestenn" },
        { value: "topannonces", text: "topannonces" },
        { value: "optimhome", text: "optimhome" },
        { value: "nexity", text: "nexity" },
        { value: "cessionpme", text: "cessionpme" },
        { value: "efficity", text: "efficity" },
        { value: "ornox", text: "ornox" },
        { value: "lesterrains", text: "lesterrains" },
        { value: "proprietesprivees", text: "proprietesprivees" },
        { value: "bsk", text: "bsk" },
        { value: "ladresse", text: "ladresse" },
        { value: "arthurimmo", text: "arthurimmo" },
        { value: "megagence", text: "megagence" },
        { value: "properstar", text: "properstar" },
        { value: "luxuryestate", text: "luxuryestate" },
      ],
      ListeOptions: [
        { value: "isFurnished", text: "Meublé" },
        { value: "isNotFurnished", text: "Non Meublé" },
        { value: "isNew", text: "Neuf" },
        { value: "isOld", text: "Ancien" },
        { value: "isSoldRented", text: "Vendu loué" },
        { value: "isNotSoldRented", text: "Vendu libre" },
        { value: "isFlatshare", text: "Colocation" },
        { value: "isNotFlatshare", text: "Sans colocation" },
        { value: "isLifeAnnuity", text: "Viager" },
        { value: "isNotLifeAnnuity", text: "Sans viager" },
        { value: "hasLift", text: "Ascenseur" },
        { value: "hasNoLift", text: "Sans ascenseur" },
        { value: "hasGarden", text: "Jardin" },
        { value: "hasGarage", text: "Garage" },
        { value: "hasParking", text: "Parking" },
        { value: "hasGarageOrParking", text: "Garage ou parking" },
        { value: "hasCave", text: "Cave/box" },
        { value: "isBuildable", text: "Constructible" },
        { value: "isBuildable", text: "Non constructible" },
        { value: "inServicedResidence", text: "Rés. avec services" },
        { value: "notInServicedResidence", text: "Sans rés. avec services" },
        { value: "hasSwimmingPool", text: "Piscine" },
        { value: "hasTerrace", text: "Terrasse" },
        { value: "hasBalcony", text: "Balcon" },
        { value: "hasTerraceOrBalcony", text: "Terrasse ou Balcon" },
        { value: "hasIntercom", text: "Interphone" },
        { value: "hasDigicode", text: "Digicode/badge" },
        { value: "hasWorksRequired", text: "Travaux à prévoir" },
        { value: "hasNoWorksRequired", text: "Sans travaux à prévoir" },
        { value: "isGroundFloor", text: "rez-de-chaussée" },
        { value: "isNotGroundFloor", text: "Sans rez-de-chaussée" },
        { value: "hasOpticFiber", text: "Fibre optique" },
        { value: "hasSeaView", text: "Vue sur mer" },
        { value: "hasPicture", text: "Avec photo" },
        { value: "hasNoPicture", text: "Sans photo" },
        { value: "isSeasonalRental", text: "Location saisonnière" },
        { value: "isNotSeasonalRental", text: "Sans location saisonnière" },
        { value: "isSocialHousing", text: "Logement social" },
        { value: "isNotSocialHousing", text: "Sans logement social" },
        { value: "isBareOwnership", text: "Nue propriété" },
        { value: "isNotBareOwnership", text: "Sans nue propriété" },
        { value: "isUnderCompromise", text: "Sous compromis" },
        { value: "isNotUnderCompromise", text: "Sans compromis" },
      ],
      ListeAnnonce: [
        { value: "sale", text: "Vente" },
        { value: "rental", text: "Location" },
      ],
      ListeTypeVendeur: [
        { value: "professional", text: "Pro" },
        { value: "individual", text: "Particulier" },
      ],
      Tarifs: [
        {
          text: "T0"
        },
        {
          text: "T05"
        },
        {
          text: "T10"
        },
        {
          text: "T15"
        },
        {
          text: "T20"
        },
        {
          text: "T25"
        },
        {
          text: "T30"
        },
        {
          text: "T35"
        },
        {
          text: "T40"
        },
        {
          text: "P05"
        },
        {
          text: "P10"
        },
        {
          text: "P15"
        },
        {
          text: "P20"
        },
        {
          text: "P25"
        },
        {
          text: "P30"
        },
        {
          text: "P35"
        },
        {
          text: "P40"
        },
        {
          text: "T40/10"
        },
        {
          text: "P40/10"
        },
        {
          text: "P50/20"
        },
        {
          text: "P65/15"
        },

      ],
      typeAnnocesState: false,
      typeVendeurState: false,
      typeBienState: false,
      LocationState: false,
      PriceState: false,
      SurfaceState: false,
      NbrPiecesState: false,
      sortByState: false,
      PlusCritereState: false,
      PlatformesImmoState: false,
      isLoading: true,
      propositions: [],
      fields: [
        { key: "negociee", label: "Négociée", sortable: true, tdClass: 'table-col1' },
        { key: "bank", label: "Simulation Banque", sortable: true, tdClass: 'table-col1' },
        { key: "montant_emprunt", label: "Montant d'emprunt", sortable: true, tdClass: 'table-col1' },
        { key: "montant_project", label: "Montant du projet", sortable: true, tdClass: 'table-col1', thClass: "d-none" },
        { key: "duration", label: "Durée", sortable: true, tdClass: 'table-col1' },
        { key: "somme_garanties", label: "Frais garantie", sortable: true, tdClass: 'table-col1', thStyle: { width: "8% !important" }, trStyle: { color: "#234363" }, },
        { key: "frais_dossier", label: "Frais dossier", sortable: true, tdClass: 'table-col1' },
        { key: "ti", label: "Taux fixe", sortable: true, tdClass: 'table-col1' },
        { key: "ti_recommended", label: "Taux recommandé", sortable: true, tdClass: 'table-col1', thClass: "d-none" },
        { key: "ta", label: "Tarif assurance fixe", sortable: true, tdClass: 'table-col1' },
        { key: "mensualite", label: "Mens. lissée (HA)", sortable: true, tdClass: 'table-col1' },
        { key: "montant_assurance", label: "Prime d'assurance mensuelle", sortable: true, tdClass: 'table-col1', thStyle: { width: "10% !important" } },
        // { key: "montant_assurance_delegue", label: "Prime assurance mensuelle délégué", sortable: true, tdClass: 'table-col1', thStyle: { width: "10% !important" }, },
        { key: "mensualite_with_assurance", label: "Mens. lissée", sortable: true, tdClass: 'table-col1' },
        { key: "cout_pret", label: "Coût total du crédit", sortable: true, tdClass: 'table-col1' },
        { key: "Faisabilite", label: "Faisabilité", sortable: true, tdClass: 'table-col1' },
        // { key: "eco_realise", label: "Economie réalisée", sortable: true, tdClass: 'table-col1' },
      ],
      type: 'basic',
      Mens_modificationRapide: "",
      checkboxMensualite: false,
      tiSouhaite_modificationRapide: "",
      taSouhaite_modificationRapide: "",
      duree_modificationRapide: "",
      dureePret: 0,
      OperationType: 0,
      ModalCoutProjet: false,
      modalCoutProjetVisible: false,
      DetailsGarantie2: [],
      DetailsCoutTotaleProjet2: {
        cout_supp: {
          cout_courtage: 0,
          cout_frais_dossier: 0,
          cout_garanti: 0,
          cout_total: 0,
        }
      },
      DetailsFaisabilite: [],
      propositionNegocieeValide: {},
      propositionNegocieeInvalide: {},
      ventePartageOptions: [
        {value: 'oui', text: 'Oui'},
        {value: 'non', text: 'Non'},
      ],
      ventePartageFilter: [],
      AnnonceursSelectedList: [],
    };
  },

  created() { },
  mounted() {

    this.project_id = JSON.parse(localStorage.getItem("project_id"));

    if(this.project_id == -1) {
      this.getProjectFilters({ project_id: this.project_id }).then(() => {
        let filter = typeof this.projectFilters.body === 'string' ? JSON.parse(this.projectFilters.body) : null;

        (this.location =
          filter != null && filter.location != undefined
            ? filter.location
            : null),
          (this.annonce =
            filter != null && filter.types_select != undefined
              ? filter.types_select
              : null),
          (this.priceMin =
            filter != null && filter.priceMin != undefined
              ? filter.priceMin
              : null),
          (this.priceMax =
            filter != null && filter.priceMax != undefined
              ? filter.priceMax
              : null),
          (this.roomsMax =
            filter != null && filter.roomsMax != undefined
              ? filter.roomsMax
              : null),
          (this.roomsMin =
            filter != null && filter.roomsMin != undefined
              ? filter.roomsMin
              : null),
          (this.bedroomsMin =
            filter != null && filter.bedroomsMin != undefined
              ? filter.bedroomsMin
              : null),
          (this.bedroomsMax =
            filter != null && filter.bedroomsMax != undefined
              ? filter.bedroomsMax
              : null),
          (this.surfaceMin =
            filter != null && filter.surfaceMin != undefined
              ? filter.surfaceMin
              : null),
          (this.surfaceMax =
            filter != null && filter.surfaceMax != undefined
              ? filter.surfaceMax
              : null),
          (this.type_vendeur =
            filter != null && filter.type_vendeur != undefined
              ? filter.type_vendeur
              : null),
          (this.categorie =
            filter != null && filter.categorie != undefined
              ? filter.categorie
              : null),
          (this.floorMin =
            filter != null && filter.floorMin != undefined
              ? filter.floorMin
              : null),
          (this.floorMax =
            filter != null && filter.floorMax != undefined
              ? filter.floorMax
              : null),
          (this.landSurfaceMin =
            filter != null && filter.landSurfaceMin != undefined
              ? filter.landSurfaceMin
              : null),
          (this.landSurfaceMax =
            filter != null && filter.landSurfaceMax != undefined
              ? filter.landSurfaceMax
              : null),
          (this.pricePerSquareMeterMin =
            filter != null && filter.pricePerSquareMeterMin != undefined
              ? filter.pricePerSquareMeterMin
              : null),
          (this.pricePerSquareMeterMax =
            filter != null && filter.pricePerSquareMeterMax != undefined
              ? filter.pricePerSquareMeterMax
              : null),
          (this.propertyChargesMin =
            filter != null && filter.propertyChargesMin != undefined
              ? filter.propertyChargesMin
              : null),
          (this.propertyChargesMax =
            filter != null && filter.propertyChargesMax != undefined
              ? filter.propertyChargesMax
              : null),
          (this.propertyTaxMin =
            filter != null && filter.propertyTaxMin != undefined
              ? filter.propertyTaxMin
              : null),
          (this.propertyTaxMax =
            filter != null && filter.propertyTaxMax != undefined
              ? filter.propertyTaxMax
              : null);

          let vm = this;
          vm.annonceursFilter = [];
          if(filter != null && filter.annonceurs != undefined) {
            filter.annonceurs.forEach(function(item) {
              vm.annonceursFilter.push({text: item, value: item});
            })
          }
          vm.AnnonceursSelectedList = [];
          if(filter != null && filter.annonceursSelectedList != undefined) {
            filter.annonceursSelectedList.forEach(function(item) {
              vm.AnnonceursSelectedList.push({text: item, value: item});
            })
          }
          vm.searchByFilter();
      });

      // this.getListAnnonceurs();

      this.getBienToAvisValeur({ project_id: this.project_id }).then(() => {
        this.checkedItems = this.liste_avis_valeur;
      });
    }else {
      this.getInformationClientForCurrentProjet({
        idPorjet: localStorage.getItem("project_id"),
      }).then(() => {
        
          this.getCurrentProject().then(()=>{
            if (this.ListeAllProjet.length != 0) {
              this.OperationType = this.ListeAllProjet[0].type;
              localStorage.setItem("typeOperation",this.OperationType)
              this.getFrais({idSimulation: localStorage.getItem("project_id"), type: this.OperationType }).then(() => {})
            }
          })
          this.fetchAssurance();
          // this.getListAnnonceurs();
      });

      
      let categorie = ["house"];
      this.$loading(true);

      let newtoSend = {
        page: this.page,
        maxLength: this.maxLength,
        // 'token':"1ae596a4577c393f6acd6e9c0050c8654dabc54fc9f98d7317093bb1ee62113c",
        categorie: ["house"],
      };

      this.getDetailsSim().then((res) => {
        this.Mens_modificationRapide = this.simulationsDetails.mensualite_souhaite;
        this.tiSouhaite_modificationRapide = this.simulationsDetails.ti_souhaite;
        this.taSouhaite_modificationRapide = this.simulationsDetails.ta_souhaite;
        this.duree_modificationRapide = this.simulationsDetails.duration;

        if (this.simulationsDetails.data && this.simulationsDetails.data.type === 16) {
          this.fields.eco_realise.tdClass = "";
          this.fields.eco_realise.thClass = "";
        }
        if (this.Mens_modificationRapide == null) {
          this.checkboxMensualite = false;
        } else {
          this.checkboxMensualite = true;
        }
      });

      this.getBankIdents().then(() => {
        this.getProjectFilters({ project_id: this.project_id }).then(() => {
          let filter = typeof this.projectFilters.body === 'string' ? JSON.parse(this.projectFilters.body) : null;

          (this.location =
            filter != null && filter.location != undefined
              ? filter.location
              : null),
            (this.annonce =
              filter != null && filter.types_select != undefined
                ? filter.types_select
                : null),
            (this.priceMin =
              filter != null && filter.priceMin != undefined
                ? filter.priceMin
                : null),
            (this.priceMax =
              filter != null && filter.priceMax != undefined
                ? filter.priceMax
                : null),
            (this.roomsMax =
              filter != null && filter.roomsMax != undefined
                ? filter.roomsMax
                : null),
            (this.roomsMin =
              filter != null && filter.roomsMin != undefined
                ? filter.roomsMin
                : null),
            (this.bedroomsMin =
              filter != null && filter.bedroomsMin != undefined
                ? filter.bedroomsMin
                : null),
            (this.bedroomsMax =
              filter != null && filter.bedroomsMax != undefined
                ? filter.bedroomsMax
                : null),
            (this.surfaceMin =
              filter != null && filter.surfaceMin != undefined
                ? filter.surfaceMin
                : null),
            (this.surfaceMax =
              filter != null && filter.surfaceMax != undefined
                ? filter.surfaceMax
                : null),
            (this.type_vendeur =
              filter != null && filter.type_vendeur != undefined
                ? filter.type_vendeur
                : null),
            (this.categorie =
              filter != null && filter.categorie != undefined
                ? filter.categorie
                : null),
            (this.floorMin =
              filter != null && filter.floorMin != undefined
                ? filter.floorMin
                : null),
            (this.floorMax =
              filter != null && filter.floorMax != undefined
                ? filter.floorMax
                : null),
            (this.landSurfaceMin =
              filter != null && filter.landSurfaceMin != undefined
                ? filter.landSurfaceMin
                : null),
            (this.landSurfaceMax =
              filter != null && filter.landSurfaceMax != undefined
                ? filter.landSurfaceMax
                : null),
            (this.pricePerSquareMeterMin =
              filter != null && filter.pricePerSquareMeterMin != undefined
                ? filter.pricePerSquareMeterMin
                : null),
            (this.pricePerSquareMeterMax =
              filter != null && filter.pricePerSquareMeterMax != undefined
                ? filter.pricePerSquareMeterMax
                : null),
            (this.propertyChargesMin =
              filter != null && filter.propertyChargesMin != undefined
                ? filter.propertyChargesMin
                : null),
            (this.propertyChargesMax =
              filter != null && filter.propertyChargesMax != undefined
                ? filter.propertyChargesMax
                : null),
            (this.propertyTaxMin =
              filter != null && filter.propertyTaxMin != undefined
                ? filter.propertyTaxMin
                : null),
            (this.propertyTaxMax =
              filter != null && filter.propertyTaxMax != undefined
                ? filter.propertyTaxMax
                : null);

            let vm = this;
            vm.annonceursFilter = [];
            if(filter != null && filter.annonceurs != undefined) {
              filter.annonceurs.forEach(function(item) {
                vm.annonceursFilter.push({text: item, value: item});
              })
            }
            vm.AnnonceursSelectedList = [];
            if(filter != null && filter.annonceursSelectedList != undefined) {
              filter.annonceursSelectedList.forEach(function(item) {
                vm.AnnonceursSelectedList.push({text: item, value: item});
              })
            }
            this.searchByFilter();
        });

        this.getBienToAvisValeur({ project_id: this.project_id }).then(() => {
          this.checkedItems = this.liste_avis_valeur;
        });
      })
    }
    // if (this.ListeAllProjet.length == 0) {
    //   this.getCurrentProject().then(() => {
    //     this.getFrais({ idSimulation: localStorage.getItem("CurrentProjet") });

    //     if (this.ListeAllProjet.length != 0) {
    //       this.OperationType = this.ListeAllProjet[0].type;
    //       this.typeAssurance = this.ListeAllProjet[0].type_operation_assurance;
    //     }
    //   });
    // } else {
    //   if (this.ListeAllProjet.length != 0) {
    //     if (this.ListeAllProjet.length == 1) {
    //       this.OperationType = this.ListeAllProjet[0].type;
    //       this.typeAssurance = this.ListeAllProjet[0].type_operation_assurance;
    //     } else {
    //       this.OperationType = this.ListeAllProjet[
    //         localStorage.getItem("CurrentIndexProjet")
    //       ].type;
    //       this.typeAssurance = this.ListeAllProjet[localStorage.getItem("CurrentIndexProjet")].type_operation_assurance;
    //     }
    //   }
    // }

    
  },

  computed: {

    coutDuProjet() {
      return parseFloat(this.projectCost.logemet) + parseFloat(this.projectCost.notaire) + parseFloat(this.projectCost.courtage)
      + parseFloat(this.projectCost.crd_refinance) + parseFloat(this.projectCost.etablissement) + parseFloat(this.projectCost.expertise)
      + parseFloat(this.projectCost.mobilier) + parseFloat(this.projectCost.agence)
    },

    ...mapGetters([
      "IdClientProjet",
      "DetailsCoutTotale",
      "coemprunteur",
      "DetailsGarantie",
      "simulationsDetails",
      "ListeFrais",
      "liste_avis_valeur",
      "ListeBienAncien",
      "ListeResultRechBienNeuf",
      "totalRowRechBienNeuf",
      "totalBiens",
      "totalProgrammes",
      "ListeProgramsBienNeuf",
      "Location",
      "Localisation",
      "projectFilters",
      "RolesCurrentUser",
      "locationProject",
      "CurrentUser",
      "totalAncien",
      "bankIdents",
      "propositionsInvalidesBasic",
      "propostionsValidesBasic",
      "loadingbankBasic",
      "doneBasic",
      // "DetailsFaisabilite",
      "projectCost",
      "ListeAllProjet",
      "AnnonceursList"
    ]),
    tauxRange() {
      const range = [];
      for (let taux = 5; taux <= 100; taux += 5) {
        range.push(taux);
      }
      return range;
    },
    predefinedKeywords() {
      // Replace this with your list of predefined keywords for autocomplete.
      return [
        "immobilier",
        "bien immobilier",
        "appartement",
        "maison",
        "villa",
        "terrain",
        "propriété commerciale",
        "à louer",
        "à vendre",
        "hypothèque",
        "investissement",
        "agent immobilier",
        "inspection immobilière",
        "déménagement",
        "design intérieur",
        "rénovation",
        "gestion immobilière",
        "quartier",
        "ville",
        "région",
        "pays",
        "marché immobilier",
        "actualités immobilières",
        "annonces immobilières",
        "propriétés de luxe",
        "logements abordables",
        "immobilier résidentiel",
        "immobilier commercial",
        "agence immobilière",
        "portes ouvertes",
        "investissement immobilier",
        "appartement à louer",
        "maison à vendre",
        "tendances immobilières",
        "taux hypothécaires",
        "premier acheteur",
        "conseils immobiliers",
        "taxes foncières",
        "valorisation immobilière",
        "marché locatif",
        "conseils d'agent immobilier",
        "financement immobilier",
        "location de vacances",
        "propriété en bord de mer",
        "maisons de retraite",
        "événements immobiliers",
        "amélioration de l'habitat",
        "marché immobilier",
        "assurance immobilière",
        "réglementations immobilières",
        "programmes d'acheteur",
        "carrière immobilière",
        "technologie immobilière",
        "marketing immobilier",
        "site web immobilier",
        "recherche de propriété",
        "services de déménagement",
        "maisons écologiques",
        "habitat durable",
        "statistiques immobilières",
        "décoration intérieure",
        "stratégie d'investissement immobilier",
        "conférences immobilières",
        "formation immobilière",
        "tendances immobilières",
        "logiciels immobiliers",
        "analyse immobilière",
        "consultation immobilière",
        "financement immobilier",
      ];
    },

    Localisation() {
      var text = "";
      if (this.locationProjet == null || this.locationProjet.length == 0) {
        return "Localisation";
      } else {
        for (var i = 0; i < this.locationProjet.length; i++) {
          text += this.locationProjet[i].text + "  ";
        }
        return text;
      }
    },
    BudgetBien() {
      if (this.minBudgetPT > 0 && this.maxBudgetPT > 0) {
        return (
          "Prix Total: min = " +
          this.minBudgetPT +
          " € | max = " +
          this.maxBudgetPT +
          " €"
        );
      } else if (this.minBudgetPM > 0 && this.maxBudgetPM > 0) {
        return (
          "Prix/m² : min = " +
          this.minBudgetPM +
          " € | max = " +
          this.maxBudgetPM +
          " €"
        );
      } else if (this.minBudgetPT <= 10 && this.maxBudgetPT <= 10) {
        return "Budget";
      } else if (
        this.minBudgetPT > 10 &&
        this.maxBudgetPT > 0 &&
        this.minBudgetPM > 10 &&
        this.maxBudgetPM > 0
      ) {
        return (
          "Prix Total: min = " +
          this.minBudgetPT +
          " € | max = " +
          this.maxBudgetPT +
          " € / Prix/m²: min = " +
          this.minBudgetPM +
          " m²|max = " +
          this.maxBudgetPM +
          " m²"
        );
      } else if (this.minBudgetPT > 10) {
        return "Prix Total: min = " + this.minBudgetPT + " €";
      } else if (this.maxBudgetPT > 10) {
        return "Prix Total: max = " + this.maxBudgetPT + " €";
      } else {
        return "Budget";
      }
    },
    ProjectBien() {
      if (this.Habiter == true || this.Habiter == "Habiter") {
        return "Habiter";
      }
      if (this.Ancien == true || this.Habiter == "Ancien") {
        return "Ancien";
      }
      if (this.Pinel == true || this.Pinel == "Pinel") {
        if (this.Lmnp == true || this.Lmnp == "LMNP") {
          if (this.LmnpAmort == true || this.LmnpAmort == "LMNP Amort")
            return "LMNP Amortissement";
          else if (this.LmnpCensi == true || this.LmnpCensi == "LMNP Censi")
            return "LMNP Censi-Bouvard";
        } else return "Pinel";
      }
      if (this.Lmnp == true || this.Lmnp == "LMNP") {
        if (this.LmnpAmort == true || this.LmnpAmort == "LMNP Amort")
          return "LMNP Amortissement";
        else if (this.LmnpCensi == true || this.LmnpCensi == "LMNP Censi")
          return "LMNP Censi-Bouvard";
      }
      // this.page = 1
      return this.Project;
    },
    TypeBien() {
      var text = "";
      if (this.valueType.text == "Tous") {
        if (this.valueTypologie != null) {
          for (var i = 0; i < this.valueTypologie.length; i++) {
            text += this.valueTypologie[i].text + ",";
          }

          return "Type : (tous) / Typologie : " + text;
        } else {
          return "Type : (tous)";
        }
      } else {
        if (this.valueTypologie != null && this.valueTypologie.length > 0) {
          for (var j = 0; j < this.valueTypologie.length; j++) {
            text += this.valueTypologie[j].text + ",";
          }
          return "Type : (" + this.valueType.text + ") / Typologie : " + text;
        } else {
          return "Type : (" + this.valueType.text + ")";
        }
      }
    },
    surfaceBien() {
      if (
        (this.minSurfaceHab != null && this.maxSurfaceHab != null) ||
        (this.minSurfaceHab > 0 && this.maxSurfaceHab > 0)
      ) {
        return (
          "min= " +
          this.minSurfaceHab +
          " m² | max= " +
          this.maxSurfaceHab +
          " m²"
        );
      } else if (
        (this.minSurfaceHab == null && this.maxSurfaceHab == null) ||
        (this.minSurfaceHab == "" && this.maxSurfaceHab == "") ||
        (this.minSurfaceHab == 0 && this.maxSurfaceHab == 0)
      ) {
        return "Surface";
      } else {
        if (this.minSurfaceHab > 0 && this.maxSurfaceHab == null) {
          return "min= " + this.minSurfaceHab + " m²";
        } else if (this.maxSurfaceHab > 0 && this.minSurfaceHab == null) {
          return "max= " + this.maxSurfaceHab + " m²";
        } else if (
          (this.minSurfaceHab == null && this.maxSurfaceHab == null) ||
          (this.minSurfaceHab == 0 && this.maxSurfaceHab == 0)
        ) {
          return "Surface";
        } else {
          return "Surface";
        }
      }
    },
    promoteurText() {
      var text = "";
      if (this.promoteur != null) {
        var separation = this.promoteur.length == 1 ? " " : " / ";
      }
      if (this.promoteur == null || this.promoteur.length == 0) {
        return "";
      } else {
        for (var i = 0; i < this.promoteur.length; i++) {
          text += this.promoteur[i].text + "" + separation;
        }
        return text;
      }
    },
    programmeText() {
      var text = "";
      if (this.programme != null) {
        var separation = this.programme.length == 1 ? " " : " / ";
      }
      if (this.programme == null || this.programme.length == 0) {
        return "";
      } else {
        for (var i = 0; i < this.programme.length; i++) {
          text += this.programme[i].text + "" + separation;
        }
        return text;
      }
    },
    etageText() {
      switch (this.etage) {
        case 1:
          return "Pas de RDC";
        case 2:
          return "2ème étage et plus";
        default:
          return "";
      }
    },
    expositionText() {
      var text = "";
      if (this.exposition != null) {
        var separation = this.exposition.length == 1 ? " " : " / ";
      }
      if (this.exposition == null || this.exposition.length == 0) {
        return "";
      } else {
        for (var i = 0; i < this.exposition.length; i++) {
          text += this.exposition[i].text + "" + separation;
        }
        return text;
      }
    },
    livraisonText() {
      switch (this.Livraison) {
        case 1:
          return "Déjà livré";
        case 2:
          return "Cette Année";
        case 3:
          return "D'ici fin " + parseInt(new Date().getFullYear() + 1);
        case 4:
          return "D'ici fin " + parseInt(new Date().getFullYear() + 2);
        default:
          return "";
      }
    },
    commissionText() {
      if (this.commission != null) {
        return this.commission;
      } else {
        return "";
      }
    },
    zonefiscaleText() {
      switch (this.zFiscale) {
        case 1:
          return "A";
        case 2:
          return "Abis";
        case 3:
          return "B1";
        case 4:
          return "B1 Outre-Mer (DOM)";
        case 5:
          return "B1 Outre-Mer (TOM)";
        case 6:
          return "B2";
        case 7:
          return "C";
        default:
          return "";
      }
    },
    disponibiliteText() {
      switch (this.valueDisponibiliteLots) {
        case 1:
          return "Disponibles";
        case 2:
          return "Optionnés";
        default:
          return "";
      }
    },
  },
  components: {
    ModalCoutProjet,
    // ModelLocation,
    // ModelBudget,
    // ModelType,
    // ModelSurface,
    // ModelNotation,
    // ModelCritere,
    // ModelAlert,
    // Select,
    //Star,
    VueperSlides,
    VueperSlide,
    Multiselect,
  },
  methods: {
    ...mapActions([
      "getCurrentProject",
      "getInformationClientForCurrentProjet",
      "DetailsCoutTotaleProjet",
      "UpdateFraisProjet",
      "DetailsGarantieProposition",
      "getDetailsSim",
      "fastUpdateSimulation",
      "getBienToAvisValeur",
      "setBienToAvisValeur",
      "setProjectFiltersAncien",
      "getBienAncienFromMoteurImmo",
      "rechBienNeufWithFilter",
      "rechBienAncienWithFilter",
      "searchVilleByCP",
      "searchVilleByName",
      "getProjectFilters",
      "setProjectFilters",
      "whoami",
      "updateProject",
      "generatePropositionsBasicWithLoader",
      "getBankIdents",
      "DetailsFaisabiliteProposition",
      "getProjectCosts",
      "updateProject",
      "generatePropositionsPersoWithLoader",
      "generatePropositionsAssurancePersoWithLoader",
      'getListeAllAssurance',
      'UpdateAssuranceEmpruteur',
      "resetAssuranceQuotite",
      "getFrais",
      "getListAnnonceurs",
    ]),
    yesclickHandler(item){
      const isChecked = event.target.checked;

      if(isChecked) {
        let newAnnonceur = {
          value: item.name,
          text: item.name,
        }
        this.AnnonceursSelectedList.push(newAnnonceur);
        this.projectFilters.body.annonceursSelectedList.push(item.name)
      }else {
        this.AnnonceursSelectedList = this.AnnonceursSelectedList.filter((elem) => elem.value != item.name);
        

        if (this.AnnonceursSelectedList != []) {
          let tempArray = [];
          this.AnnonceursSelectedList.forEach((element) => {
            tempArray.push(element.value);
          });
          this.projectFilters.body.annonceursSelectedList = tempArray;
        }else {
          this.projectFilters.body.annonceursSelectedList = []
        }
      }

      this.setProjectFiltersAncien({data:this.projectFilters.body, project_id: this.project_id})
      // this.AnnonceursSelectedNoList = this.AnnonceursSelectedNoList.filter((elem) => elem.value != item.name);
      // if (this.checkIfAnnonceurYes(item.name)) {
      //   // Checkbox was unchecked, perform the necessary actions
      //   console.log('Checkbox unchecked for publisher:', item.name);
      //   // You can add your custom logic here
      // } else {
      //   // Checkbox was checked, perform the necessary actions
      //   console.log('Checkbox checked for publisher:', item.name);
      //   // You can add your custom logic here
      // }
      
    },
    nonclickHandler(item){
      this.AnnonceursSelectedList = this.AnnonceursSelectedList.filter((elem) => elem.value != item.name);
      let newAnnonceur = {
        value: item.name,
        text: item.name,
      }
      this.AnnonceursSelectedNoList.push(newAnnonceur);
      this.projectFilters.body.annonceursSelectedList = this.projectFilters.body.annonceursSelectedList.filter((elem) => elem.value !== item.name)
      this.setProjectFiltersAncien({data:this.projectFilters.body, project_id: this.project_id})
    },
    checkIfAnnonceurYes(name) {
      return this.AnnonceursSelectedList.some((elem) => elem.value === name);
    },
    checkIfAnnonceurNon(name) {
      return this.AnnonceursSelectedNoList.some((elem) => elem.value === name);
    },
    getValueAssurance(loadingAssurance) {
      let pasTopush = 100 / this.apiList.length;
      for (var i = 0; i < this.apiList.length; i++) {
        let identifiant = loadingAssurance;
        if (identifiant.includes(this.apiList[i].name)) {
          return (i) * pasTopush;
        }
      }
    },
    updateAssurance() {
      this.loadingData = true;
      this.UpdateAssuranceEmpruteur({
        data: this.assuranceCustomer,
        idClient: localStorage.getItem("CurrentEmprunteurProjet"),
      }).then((response) => {
        this.resetAssuranceQuotite({ id: localStorage.getItem("project_id") })
        this.assuranceCustomer = {}
        this.getListeAllAssurance({
          idClient: localStorage.getItem("CurrentEmprunteurProjet"),
        }).then((response) => {
          this.assuranceCustomer = response;
        }).finally(() => {
          this.loadingData = false;
        });
        this.$store.commit('setUpdatedAssuranceActionKey');
        this.$store.dispatch('getCurrentProject');
      }).finally(() => {
        this.loadingData = false;
      });
      if(this.assuranceCoemp != {}) {
        this.UpdateAssuranceEmpruteur({
          data: this.assuranceCoemp,
          idClient: localStorage.getItem("CurrentCoEmprunteurProjet"),
        }).then((response) => {
          this.resetAssuranceQuotite({ id: localStorage.getItem("project_id") })
          this.assuranceCoemp = {}
          this.getListeAllAssurance({
            idClient: localStorage.getItem("CurrentCoEmprunteurProjet"),
          }).then((response) => {
            this.assuranceCoemp = response;
          }).finally(() => {
            this.loadingData = false;
          });
          this.$store.commit('setUpdatedAssuranceActionKey');
          this.$store.dispatch('getCurrentProject');
        }).finally(() => {
          this.loadingData = false;
        });
      }
    },
    fetchAssurance(playAnim = false) {
      if (playAnim) {
        this.loadingData = true;
      }
      this.assuranceCustomer = {}
      this.getListeAllAssurance({
        idClient: localStorage.getItem("CurrentEmprunteurProjet"),
      }).then((response) => {
        this.assuranceCustomer = response;
      }).finally(() => {
        this.loadingData = false;
      });
      if(localStorage.getItem('CurrentCoEmprunteurProjet') !== null) {
        this.assuranceCoemp = {}
        this.getListeAllAssurance({
        idClient: localStorage.getItem('CurrentCoEmprunteurProjet'),
        }).then((response) => {
          this.assuranceCoemp = response;
        }).finally(() => {
          this.loadingData = false;
        });
      }
    },
    afficheFaisabilite(data) {
      this.DetailsFaisabilite = data.fesabilities
      // this.DetailsFaisabiliteProposition({ data: data });
    },
    afficheCoutTotal(data) {
      this.DetailsCoutTotaleProjet2 = data
      // this.DetailsCoutTotaleProjet({ data: data });
    },

    convertStringToFloat(inputString) {
      let cleanedString = inputString.replace(/\s/g, '').replace('€', '').replace(',', '.');
      let floatValue = parseFloat(cleanedString);
      return floatValue;
    },

    updateTauxAssuranceProposition(index, idProp, data) {
      this.loadingData = true;
      this.$loading(true)
      this.generatePropositionsAssurancePersoWithLoader({
        index: index,
        type: this.type,
        bank_ident: this.idBankForUpdate,
        ta: data.ta_emp,
        ta_coemp: data.ta_coemp2,
        ti: data.ti,
        ti_relais: data.ti_relais,
        isRelais: data.isRelais,
      }).then(() => {
        this.$loading(false)
        this.loadingData = false;
      });
    },
    updateTauxProposition(index, idProp, data) {
      this.loadingData = true;
      this.$loading(true)
      this.generatePropositionsPersoWithLoader({
        index: index,
        type: this.type,
        bank_ident: this.idBankForUpdate,
        ta: data.ta_emp,
        ta_coemp: data.ta_coemp2,
        ti: data.ti,
        ti_relais: data.ti_relais,
        isRelais: data.isRelais,
      }).then(() => {
        this.$loading(false)
        this.loadingData = false;
      });
    },
    afficheTauxAssurance(index, id, data, bank) {
      for (var i = 0; i < this.bankIdents[0].length; i++) {
        if (bank == this.bankIdents[0][i].bankId) {
          this.idBankForUpdate = this.bankIdents[0][i].ident;
        }
      }

      let CopiData = {};
      Object.assign(CopiData, data);
      this.idPropositionFoUpdate = id;
      this.TauxAssuranceUpdate = CopiData;
      this.indexForUpdate = index;
    },
    afficheTauxFixe(index, id, data, bank) {
      for (var i = 0; i < this.bankIdents[0].length; i++) {
        if (bank == this.bankIdents[0][i].bankId) {
          this.idBankForUpdate = this.bankIdents[0][i].ident;
        }
      }
      let CopiData = {};
      Object.assign(CopiData, data);
      console.log(CopiData);
      this.idPropositionFoUpdate = id;
      this.TauxFixUpdate = CopiData;
      this.indexForUpdate = index;
    },
    FillDetailsGarantieProposition(data) {
      this.DetailsGarantie2 = []
      this.DetailsGarantie2 = data
      // this.DetailsGarantieProposition({ "data": data });
    },
    closeCollapseSections() {
      const collapse1 = document.getElementById('collapse-1');
      const collapse2 = document.getElementById('collapse-2');
      // Add more collapses as needed

      if (collapse1 && collapse2) {
        collapse1.classList.remove('show');
        collapse2.classList.remove('show');
        // Add more collapse toggling as needed
      }
    },
    testEmpty(val) {
      if (val == null || val == "" || val == 0) return true;
      else return false;
    },
    fastUpdate(itemPrice) {
      console.log('fastUpdate');
      var cond1 =
        this.Mens_modificationRapide == null &&
        this.tiSouhaite_modificationRapide == null &&
        this.taSouhaite_modificationRapide == null;
      if (cond1) {
        // this.fastUpdateSimulation({
        //   duration: this.duree_modificationRapide,
        //   mensualite_souhaite: this.Mens_modificationRapide,
        //   ti_souhaite: this.tiSouhaite_modificationRapide,
        //   ta_souhaite: this.taSouhaite_modificationRapide,
        // })
        //   .then((res) => {
            this.genererPropositions(itemPrice).then((res) => {
              this.dureePret = 0;
            });
          // })
          // .catch((e) => { });
      } else if (!this.testEmpty(this.Mens_modificationRapide)) {
        if (
          this.testEmpty(this.tiSouhaite_modificationRapide) ||
          this.testEmpty(this.taSouhaite_modificationRapide)
        ) {
          if (this.testEmpty(this.tiSouhaite_modificationRapide))
            this.wrongInput = true;
          if (this.testEmpty(this.taSouhaite_modificationRapide))
            this.wrongInput1 = true;
        } else {
          this.wrongInput = false;
          this.wrongInput1 = false;
          // this.fastUpdateSimulation({
          //   duration: this.duree_modificationRapide,
          //   mensualite_souhaite: this.Mens_modificationRapide,
          //   ti_souhaite: this.tiSouhaite_modificationRapide,
          //   ta_souhaite: this.taSouhaite_modificationRapide,
          // })
          //   .then((res) => {
              this.genererPropositions(itemPrice).then((res) => {
                this.dureePret = 0;
              });
            // })
            // .catch((e) => {
            // });
        }
      } else {
        this.wrongInput = false;
        this.wrongInput1 = false;
        // this.fastUpdateSimulation({
        //   duration: this.duree_modificationRapide,
        //   mensualite_souhaite: this.Mens_modificationRapide,
        //   ti_souhaite: this.tiSouhaite_modificationRapide,
        //   ta_souhaite: this.taSouhaite_modificationRapide,
        // })
        //   .then((res) => {
            this.genererPropositions(itemPrice).then((res) => {
              this.dureePret = 0;
            });
          // })
          // .catch((e) => {
          // });
      }
    },
    openModal(ModalRef) {
      this.$refs[ModalRef].show();
    },
    closeModal(ModalRef) {
      this.$refs[ModalRef].hide();
    },
    genererPropositions(itemPrice) {
      this.propositionisLoading = true;
      this.propositionNegocieeValide = this.propostionsValidesBasic.filter(item => item.negocier === true);
      this.propositionNegocieeInvalide = this.propositionsInvalidesBasic.filter(item => item.negocier === true);

      console.log('propositionNegocieeInvalide: ', this.propositionNegocieeInvalide)
      console.log('this.propositionsInvalidesBasic: ', this.propositionsInvalidesBasic)
      this.updateProject({ amount: itemPrice, project_id: localStorage.getItem('project_id') }).then(() => {
        let payload = {}
        if (this.type == "contre_ptz") {
          if (this.dureePret == 0)
            this.generatePropositionsContrePtz({
              type: "contre_ptz",
              bank_ident: this.bankIdents[0],
              duration: this.duree_modificationRapide,
              mensualite_souhaite: this.Mens_modificationRapide,
              ti_souhaite: this.tiSouhaite_modificationRapide,
              ta_souhaite: this.taSouhaite_modificationRapide,
            }).then((res) => {
              this.getCurrentTacheBySimulation({
                idPorjet: localStorage.getItem("CurrentProjet"),
              }).then(() => {
                this.$loading(false);
              });
            });
          else if (this.dureePret == 1)
            this.generatePropositionsContrePtz({
              type: "contre_ptz_15",
              bank_ident: this.bankIdents[0],
              duration: this.duree_modificationRapide,
              mensualite_souhaite: this.Mens_modificationRapide,
              ti_souhaite: this.tiSouhaite_modificationRapide,
              ta_souhaite: this.taSouhaite_modificationRapide,
            }).then((res) => {
              this.getCurrentTacheBySimulation({
                idPorjet: localStorage.getItem("CurrentProjet"),
              }).then(() => {
                this.$loading(false);
              });
              this.$loading(false);
            });
          else if (this.dureePret == 2)
            this.generatePropositionsContrePtz({
              type: "contre_ptz_20",
              bank_ident: this.bankIdents[0],
              duration: this.duree_modificationRapide,
              mensualite_souhaite: this.Mens_modificationRapide,
              ti_souhaite: this.tiSouhaite_modificationRapide,
              ta_souhaite: this.taSouhaite_modificationRapide,
            }).then((res) => {
              this.getCurrentTacheBySimulation({
                idPorjet: localStorage.getItem("CurrentProjet"),
              }).then(() => {
                this.$loading(false);
              });
              this.$loading(false);
            });
          else if (this.dureePret == 3)
            this.generatePropositionsContrePtz({
              type: "contre_ptz_25",
              bank_ident: this.bankIdents[0],
              duration: this.duree_modificationRapide,
              mensualite_souhaite: this.Mens_modificationRapide,
              ti_souhaite: this.tiSouhaite_modificationRapide,
              ta_souhaite: this.taSouhaite_modificationRapide,
            }).then((res) => {
              this.getCurrentTacheBySimulation({
                idPorjet: localStorage.getItem("CurrentProjet"),
              }).then(() => {
                this.$loading(false);
              });
              this.$loading(false);
            });
        } else {
          if (this.type == "basic") {
            this.generatePropositionsBasicWithLoader({
              type: this.type,
              bank_ident: this.bankIdents[0],
              duration: this.duree_modificationRapide,
              mensualite_souhaite: this.Mens_modificationRapide,
              ti_souhaite: this.tiSouhaite_modificationRapide,
              ta_souhaite: this.taSouhaite_modificationRapide,
            }).then(() => {
              this.$loading(false);
            });
          } else if (this.type == "pinel") {
            this.generatePropositionsPinelWithLoader({
              type: this.type,
              bank_ident: this.bankIdents[0],
              duration: this.duree_modificationRapide,
              mensualite_souhaite: this.Mens_modificationRapide,
              ti_souhaite: this.tiSouhaite_modificationRapide,
              ta_souhaite: this.taSouhaite_modificationRapide,
            }).then(() => {
              this.$loading(false);
            });
          } else if (this.type == "pinel_neuf") {
            this.generatePropositionsPinelNeufWithLoader({
              type: this.type,
              bank_ident: this.bankIdents[0],
              duration: this.duree_modificationRapide,
              mensualite_souhaite: this.Mens_modificationRapide,
              ti_souhaite: this.tiSouhaite_modificationRapide,
              ta_souhaite: this.taSouhaite_modificationRapide,
            }).then(() => {
              this.$loading(false);
            });
          } else {
            this.generatePropositionsContreWithLoader({
              type: this.type,
              bank_ident: this.bankIdents[0],
              duration: this.duree_modificationRapide,
              mensualite_souhaite: this.Mens_modificationRapide,
              ti_souhaite: this.tiSouhaite_modificationRapide,
              ta_souhaite: this.taSouhaite_modificationRapide,
            }).then((res) => {
              setTimeout(() => {
                this.$loading(false);
              }, 900);
            });
            // this.generatePropositions({type:this.type}).then(res=>{
            //     this.getCurrentTacheBySimulation({idPorjet:localStorage.getItem('CurrentProjet')}).then(()=> {
            //         setTimeout(()=>{ this.$vs.loading.close();},900)
            //     });
            // });
            // this.$vs.loading.close()
          }
        }

      });

    },
    // openModal() {
    //   this.modalCoutProjetVisible = true;
    // },
    // closeModal() {
    //   this.modalCoutProjetVisible = false;
    // },

    awayModalCoutProjet() {
      this.ModalCoutProjet = false
    },

    outsideModalCoutProjet() {
      this.ModalCoutProjet = false
    },

    openOptionsModal(id, status) {
      let modal = document.getElementById(id);
      let overlay = document.getElementById("overlay");

      if (status) {
        modal.classList.add("show");
        overlay.classList.add("show");
      } else {
        modal.classList.remove("show");
        overlay.classList.remove("show");
      }
    },
    toggleInfo(id, status) {
      let popup = document.getElementById(id);
      if (status) {
        popup.classList.add("show");
      } else {
        popup.classList.remove("show");
      }
    },
    addKeyword() {
      if (this.newKeyword.trim() !== "") {
        this.keywords.push(this.newKeyword);
        this.newKeyword = "";
      }
    },
    deleteKeyword(index) {
      this.keywords.splice(index, 1);
    },
    updateAutocomplete() {
      if (this.newKeyword.trim() !== "") {
        this.showAutocomplete = true;
        this.autocompleteOptions = this.getAutocompleteOptions();
      } else {
        this.showAutocomplete = false;
      }
    },
    getAutocompleteOptions() {
      // Implement your logic to get autocomplete options here.
      // For example, you can filter predefined keywords based on the user's input.
      const searchTerm = this.newKeyword.toLowerCase();
      return this.predefinedKeywords.filter(keyword =>
        keyword.toLowerCase().startsWith(searchTerm)
      );
    },
    addAutocompleteOption(option) {
      this.keywords.push(option);
      this.newKeyword = "";
      this.showAutocomplete = false;
    },
    testRaduis(event) {
      if (this.raduis < 1) {
        return this.raduis = 1;
      } else if (this.raduis > 100) {
        return this.raduis = 100;
      } else {
        return this.raduis;
      }
    },
    resetFiltersStates(index) {
      if (index == 1) {
        this.typeVendeurState = false;
        this.typeBienState = false;
        this.LocationState = false;
        this.PriceState = false;
        this.SurfaceState = false;
        this.NbrPiecesState = false;
        this.PlusCritereState = false;
        this.sortByState = false
      } else if (index == 2) {
        this.typeAnnocesState = false;
        this.typeBienState = false;
        this.LocationState = false;
        this.PriceState = false;
        this.SurfaceState = false;
        this.NbrPiecesState = false;
        this.PlusCritereState = false;
        this.sortByState = false
      } else if (index == 3) {
        this.typeAnnocesState = false;
        this.typeVendeurState = false;
        this.LocationState = false;
        this.PriceState = false;
        this.SurfaceState = false;
        this.NbrPiecesState = false;
        this.PlusCritereState = false;
        this.sortByState = false
      } else if (index == 4) {
        this.typeAnnocesState = false;
        this.typeVendeurState = false;
        this.typeBienState = false;
        this.PriceState = false;
        this.SurfaceState = false;
        this.NbrPiecesState = false;
        this.PlusCritereState = false;
        this.sortByState = false
      } else if (index == 5) {
        this.typeAnnocesState = false;
        this.typeVendeurState = false;
        this.typeBienState = false;
        this.LocationState = false;
        this.SurfaceState = false;
        this.NbrPiecesState = false;
        this.PlusCritereState = false;
        this.sortByState = false
      } else if (index == 6) {
        this.typeAnnocesState = false;
        this.typeVendeurState = false;
        this.typeBienState = false;
        this.LocationState = false;
        this.PriceState = false;
        this.NbrPiecesState = false;
        this.PlusCritereState = false;
        this.sortByState = false
      } else if (index == 7) {
        this.typeAnnocesState = false;
        this.typeVendeurState = false;
        this.typeBienState = false;
        this.LocationState = false;
        this.PriceState = false;
        this.SurfaceState = false;
        this.PlusCritereState = false;
        this.sortByState = false
      } else if (index == 8) {
        this.typeAnnocesState = false;
        this.typeVendeurState = false;
        this.typeBienState = false;
        this.LocationState = false;
        this.PriceState = false;
        this.SurfaceState = false;
        this.NbrPiecesState = false;
        this.sortByState = false
      } else if (index == 9) {
        this.typeAnnocesState = false;
        this.typeVendeurState = false;
        this.typeBienState = false;
        this.LocationState = false;
        this.PriceState = false;
        this.SurfaceState = false;
        this.NbrPiecesState = false;
        this.PlusCritereState = false;
      }
    },
    truncateDescription(description, maxLength) {
      if (description.length <= maxLength) {
        return description;
      } else {
        return description.substring(0, maxLength) + '...';
      }
    },
    PriceDropRounded(oldPrice, newPrice) {
      if (oldPrice !== null && newPrice !== null) {
        let diff = oldPrice - newPrice;
        let percent = (diff / oldPrice) * 100;
        return percent.toFixed(2) + " %";
      } else {
        return null;
      }
    },
    calculateTimeDifference(pubDate) {
      var date1 = new Date();
      var date2 = new Date(pubDate);
      var diff = Math.abs(date1.getTime() - date2.getTime());
      var diffSeconds = Math.floor(diff / 1000);
      var diffMinutes = Math.floor(diffSeconds / 60);
      var diffHours = Math.floor(diffMinutes / 60);
      var diffDays = Math.floor(diffHours / 24);

      if (diffDays > 0) {
        return diffDays + "j";
      } else if (diffHours > 0) {
        return diffHours + "h";
      } else if (diffMinutes > 0) {
        return diffMinutes + "m";
      } else {
        return diffSeconds + "s";
      }
    },
    selectItemAvisValeur(item) {
      const found = this.checkedItems.findIndex((m) => m === item);

      if (found == -1) {
        this.checkedItems.push(item);
      } else {
        this.checkedItems.splice(found, 1);
      }

      this.setBienToAvisValeur({
        data: this.checkedItems,
        project_id: this.project_id,
      });
    },

    openNewTab(item) {
      let latitude = item.position[1];
      let longitude = item.position[0];
      const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
      window.open(url, "_blank");
    },

    distanceFromNow(data) {
      if (data != null) {
        return moment(data).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    resetPag() {
      this.page = 1;
    },
    searchByFilter() {
      this.$loading(true);
      this.url = "";
      let locations = [];
      let types = [];
      let sellerTypes = [];
      let globalParams = {
        page: this.page,
        maxLength: this.maxLength,
        // 'token':"1ae596a4577c393f6acd6e9c0050c8654dabc54fc9f98d7317093bb1ee62113c",
        // "withCount" : true
      };
      let categorie = [];
      if (this.location != null) {
        this.location.forEach((element) => {
          let select = element.codePostal;
          locations.push(select);
        });

        globalParams["locations"] = locations;
        globalParams["location"] = this.location;
      }

      if (this.annonce != null) {
        this.annonce.forEach((element) => {
          types.push(element.value);
        });
        globalParams["types"] = types;
        globalParams["types_select"] = this.annonce;
      }

      if (this.type_vendeur != null) {
        this.type_vendeur.forEach((element) => {
          sellerTypes.push(element.value);
        });
        globalParams["publisherTypes"] = sellerTypes;
        globalParams["type_vendeur"] = this.type_vendeur;
      }

      if (this.categorie != null) {
        console.log("this.categorie", this.categorie);
        this.categorie.forEach((element) => {
          categorie.push(element.value);
        });
        globalParams["categories"] = categorie;
        globalParams["categorie"] = this.categorie;
      }

      if (this.priceMin != null) {
        globalParams["priceMin"] = this.priceMin;
      }

      if (this.priceMax != null) {
        globalParams["priceMax"] = this.priceMax;
      }

      if (this.surfaceMin != null) {
        globalParams["surfaceMin"] = this.surfaceMin;
      }

      if (this.surfaceMax != null) {
        globalParams["surfaceMax"] = this.surfaceMax;
      }

      if (this.roomsMin != null) {
        globalParams["roomsMin"] = this.roomsMin;
      }

      if (this.roomsMax != null) {
        globalParams["roomsMax"] = this.roomsMax;
      }

      if (this.bedroomsMin != null) {
        globalParams["bedroomsMin"] = this.bedroomsMin;
      }

      if (this.bedroomsMax != null) {
        globalParams["bedroomsMax"] = this.bedroomsMax;
      }

      if (this.floorMin != null) {
        globalParams["floorMin"] = this.floorMin;
      }

      if (this.floorMax != null) {
        globalParams["floorMax"] = this.floorMax;
      }

      if (this.landSurfaceMin != null) {
        globalParams["landSurfaceMin"] = this.landSurfaceMin;
      }

      if (this.landSurfaceMax != null) {
        globalParams["landSurfaceMax"] = this.landSurfaceMax;
      }
      if (this.pricePerSquareMeterMin != null) {
        globalParams["pricePerSquareMeterMin"] = this.pricePerSquareMeterMin;
      }

      if (this.pricePerSquareMeterMax != null) {
        globalParams["pricePerSquareMeterMax"] = this.pricePerSquareMeterMax;
      }

      if (this.propertyChargesMin != null) {
        globalParams["propertyChargesMin"] = this.propertyChargesMin;
      }

      if (this.propertyChargesMax != null) {
        globalParams["propertyChargesMax"] = this.propertyChargesMax;
      }
      if (this.propertyTaxMin != null) {
        globalParams["propertyTaxMin"] = this.propertyTaxMin;
      }

      if (this.propertyTaxMax != null) {
        globalParams["propertyTaxMax"] = this.propertyTaxMax;
      }

      if (this.sortby != null) {
        globalParams["sortBy"] = this.sortby;
      }

      if (this.raduis != null) {
        globalParams["raduis"] = this.raduis;
      }

      if (this.rentMin != null) {
        globalParams["rentMin"] = this.rentMin;
      }

      if (this.rentMax != null) {
        globalParams["rentMax"] = this.rentMax;
      }

      if (this.constructionYearMin != null) {
        globalParams["constructionYearMin"] = this.constructionYearMin;
      }

      if (this.constructionYearMax != null) {
        globalParams["constructionYearMax"] = this.constructionYearMax;
      }

      if (this.buildingsFloorMin != null) {
        globalParams["buildingsFloorMin"] = this.buildingsFloorMin;
      }

      if (this.buildingsFloorMax != null) {
        globalParams["buildingsFloorMax"] = this.buildingsFloorMax;
      }

      if (this.energyGradeMin != null) {
        globalParams["energyGradeMin"] = this.energyGradeMin;
      }

      if (this.energyGradeMax != null) {
        globalParams["energyGradeMax"] = this.energyGradeMax;
      }

      if (this.gasGradeMin != null) {
        globalParams["gasGradeMin"] = this.gasGradeMin;
      }

      if (this.gasGradeMax != null) {
        globalParams["gasGradeMax"] = this.gasGradeMax;
      }

      if (this.PlatformesImmo.length != 0) {
        let tempArray = [];
        let exclutempArray = [];


        this.PlatformesImmo.forEach((element) => {
          tempArray.push(element.value);
        });

        this.PlateformesImmoListe.forEach((elem) => {
          if (!tempArray.includes(elem.value)) {
            exclutempArray.push(elem.value);
          }
        });

        globalParams["origins"] = tempArray;
        globalParams["excludedOrigins"] = exclutempArray;

      }else {
        let tempArray = [];
        let exclutempArray = [];
        this.PlateformesImmoListe.forEach((elem) => {
          tempArray.push(elem.value);
        });
        
        this.PlateformesImmoListe.forEach((elem) => {
          if (!tempArray.includes(elem.value)) {
            exclutempArray.push(elem.value);
          }
        });
        
        globalParams["origins"] = tempArray;
        globalParams["excludedOrigins"] = exclutempArray;
      }

      if (this.optionsfilter != []) {
        let tempArray = [];
        this.optionsfilter.forEach((element) => {
          tempArray.push(element.value);
        });
        globalParams["options"] = tempArray;
      }

      if (this.keywords != [] && this.keywordsOperator != null) {
        globalParams["keywords"] = this.keywords;
        globalParams["keywordsOperator"] = this.keywordsOperator;
      }

      if (this.annonceursFilter != []) {
        let tempArray = [];
        this.annonceursFilter.forEach((element) => {
          tempArray.push(element.value);
        });
        globalParams["annonceurs"] = tempArray;
      }

      if (this.AnnonceursSelectedList != []) {
        let tempArray = [];
        this.AnnonceursSelectedList.forEach((element) => {
          tempArray.push(element.value);
        });
        globalParams["annonceursSelectedList"] = tempArray;
      }

      // Count Elements for pagination
      globalParams["withCount"] = false;

      this.setProjectFiltersAncien({
        data: globalParams,
        project_id: this.project_id,
      });
      this.getBienAncienFromMoteurImmo({ data: globalParams }).then(() => {
        this.$loading(false);
      });
    },

    searchVille(query) {
      this.disableLocation = false;
      this.disableDepartment = true;
      if (this.isNumeric(query) || query == "2A" || query == "2B") {
        if (query.length >= 2) {
          this.searchVilleByCP({ query: query }).then((res) => {
            if (this.Location.length > 0) {
              this.LocationProjet = this.Location;
            }
          });
        }
      } else {
        if (query.length > 2) {
          this.searchVilleByName({ query: query }).then((res) => {
            if (this.Location.length > 0) {
              this.LocationProjet = this.Location;
            }
          });
        }
      }
    },
    removeFilter(filter) {
      switch (filter) {
        case "projet":
          this.Project = "";
          this.Habiter = true;
          this.Investir = false;
          this.Pinel = false;
          this.Lmnp = false;
          this.LmnpAmort = false;
          this.LmnpCensi = false;
          break;

        case "budget":
          this.minBudgetPT = 0;
          this.maxBudgetPT = 0;
          this.minBudgetPM = 0;
          this.maxBudgetPM = 0;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "localisation":
          this.locationProjet = null;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "typeBien":
          this.valueType = { text: "Tous", value: 0 };
          this.valueTypologie = null;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "surface":
          this.minSurfaceHab = null;
          this.maxSurfaceHab = null;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "promoteur":
          this.promoteur = null;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "programme":
          this.programme = null;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "etage":
          this.etage = 0;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "exposition":
          this.exposition = null;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "livraison":
          this.Livraison = 0;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "zonefiscale":
          this.zFiscale = 0;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "disponibilite":
          this.valueDisponibiliteLots = 0;
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;

        case "project_id":
          this.project_id = -1;
          localStorage.setItem("project_id", -1);
          localStorage.removeItem("clientFullname");
          localStorage.removeItem("EmpEmail");
          localStorage.removeItem("EmpPhone");
          // localStorage.removeItem("EmpToken");
          if (this.Ancien) {
            this.anciensPage = 1;
            this.rechAncienWithCritere();
          } else {
            this.page = 1;
            this.rechBienWithCritere();
          }
          break;
      }
    },
    camalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    setLocalStorage(project) {
      localStorage.setItem("Habiter", project.habiter);
      localStorage.setItem("Investir", project.investir);
      localStorage.setItem("Pinel", project.pinel);
      localStorage.setItem("Lmnp", project.lmnp);
      localStorage.setItem("LmnpAmort", project.lmnpAmort);
      localStorage.setItem("LmnpCensi", project.lmnpCensi);
      localStorage.setItem("minBudgetPT", JSON.stringify(project.minBudgetPT));
      localStorage.setItem("maxBudgetPT", JSON.stringify(project.maxBudgetPT));
      localStorage.setItem("minBudgetPM", JSON.stringify(project.minBudgetPM));
      localStorage.setItem("maxBudgetPM", JSON.stringify(project.maxBudgetPM));
      localStorage.setItem(
        "minSurfaceHab",
        JSON.stringify(project.minSurfaceHab)
      );
      localStorage.setItem(
        "maxSurfaceHab",
        JSON.stringify(project.maxSurfaceHab)
      );
      localStorage.setItem("locationProjet", project.locationProjet);
      localStorage.setItem("promoteur", project.promoteur);
      localStorage.setItem("programme", project.programme);
      localStorage.setItem("valueType", project.valueType);
      localStorage.setItem("valueType", JSON.stringify(project.valueTypologie));
      localStorage.setItem("etage", JSON.stringify(project.etage));
      localStorage.setItem("exposition", project.exposition);
      localStorage.setItem(
        "valueCommodite",
        JSON.stringify(project.valueCommodite)
      );
      localStorage.setItem("Livraison", JSON.stringify(project.livraison));
      localStorage.setItem("commission", JSON.stringify(project.commission));
      localStorage.setItem("zFiscale", JSON.stringify(project.zFiscale));
      localStorage.setItem(
        "valueDisponibiliteLots",
        JSON.stringify(project.valueDisponibiliteLots)
      );
    },
    awayProjet() {
      this.ModelInvestir = false;
    },
    awayLocation() {
      this.ModelLocation = false;
    },
    awayBudget() {
      this.ModelBudget = false;
    },
    awayType() {
      this.ModelType = false;
    },
    awaySurface() {
      this.ModelSurface = false;
    },
    awayCritere() {
      this.ModelCritere = false;
    },
    getProject({ selectedProj, residence, typeResidence }) {
      this.Project = selectedProj;
      // console.log("Here is Selected Project: ", selectedProj)
      switch (selectedProj) {
        case "Neuf":
          this.Ancien = false;
          this.Habiter = true;
          this.Project = "Habiter";
          this.Investir = false;
          this.Pinel = false;
          this.Lmnp = false;
          this.LmnpAmort = false;
          this.LmnpCensi = false;
          this.residence = residence;
          this.typeResidence = typeResidence;
          this.page = 1;
          this.rechBienWithCritere();
          break;
        case "Ancien":
          this.Ancien = true;
          this.Habiter = false;
          this.Project = "Ancien";
          this.Investir = false;
          this.Pinel = false;
          this.Lmnp = false;
          this.LmnpAmort = false;
          this.LmnpCensi = false;
          this.residence = residence;
          this.typeResidence = typeResidence;
          this.page = 1;
          this.rechAncienWithCritere();
          break;
        case "Habiter":
          this.Ancien = false;
          this.Habiter = true;
          this.Project = "Habiter";
          this.Investir = false;
          this.Pinel = false;
          this.Lmnp = false;
          this.LmnpAmort = false;
          this.LmnpCensi = false;
          this.residence = residence;
          this.typeResidence = typeResidence;
          this.page = 1;
          this.rechBienWithCritere();
          break;

        case "Investir":
          this.Ancien = false;
          this.Investir = true;
          this.Pinel = true;
          this.Project = "Pinel";
          this.Habiter = false;
          this.Lmnp = false;
          this.LmnpAmort = false;
          this.LmnpCensi = false;
          this.residence = residence;
          this.typeResidence = typeResidence;
          this.page = 1;
          this.rechBienWithCritere();
          break;

        case "Pinel":
          this.Ancien = false;
          this.Investir = true;
          this.Pinel = true;
          this.Project = "Pinel";
          this.Habiter = false;
          this.Lmnp = false;
          this.LmnpAmort = false;
          this.LmnpCensi = false;
          this.residence = residence;
          this.typeResidence = typeResidence;
          this.page = 1;
          this.rechBienWithCritere();
          break;

        case "LMNP / LMP":
          this.Ancien = false;
          this.Investir = true;
          this.Lmnp = true;
          this.Project = "LMNP / LMP";
          this.LmnpAmort = true;
          this.LmnpCensi = false;
          this.Pinel = false;
          this.Habiter = false;
          this.page = 1;
          this.rechBienWithCritere();
          break;

        case "LMNP Amortissement":
          this.Ancien = false;
          this.Investir = true;
          this.LmnpAmort = true;
          this.Lmnp = true;
          this.Project = "LMNP Amortissement";
          this.LmnpCensi = false;
          this.Pinel = false;
          this.Habiter = false;
          this.page = 1;
          this.rechBienWithCritere();
          break;

        case "LMNP Censi-Bouvard":
          this.Ancien = false;
          this.Investir = true;
          this.LmnpCensi = true;
          this.Lmnp = true;
          this.Project = "LMNP Censi-Bouvard";
          this.LmnpAmort = false;
          this.Pinel = false;
          this.Habiter = false;
          this.page = 1;
          this.rechBienWithCritere();
          break;

        default:
          break;
      }
    },
    getLocation(value) {
      if (value == null || value.length == 0) {
        this.Location = "Localisation";
      } else {
        this.Location = "";
        for (var i = 0; i < value.length; i++) {
          this.Location += value[i].text + "  ";
        }
      }

      this.ModelLocation = false;
      this.locationProjet = value;
      if (this.Ancien == true) {
        this.anciensPage = 1;
        this.rechAncienWithCritere();
      } else {
        this.page = 1;
        this.rechBienWithCritere();
      }
    },
    removeLocation(value) {
      this.Location = "Localisation";
      this.ModelLocation = false;
      this.locationProjet = value;
      if (this.Ancien == true) {
        this.anciensPage = 1;
        this.rechAncienWithCritere();
      } else {
        this.page = 1;
        this.rechBienWithCritere();
      }
    },
    displayBudgets({ minBudgetPT, maxBudgetPT, minBudgetPM, maxBudgetPM }) {
      this.minBudgetPT = minBudgetPT;
      this.maxBudgetPT = maxBudgetPT;
      this.minBudgetPM = minBudgetPM;
      this.maxBudgetPM = maxBudgetPM;

      if (
        (this.minBudgetPT == null || this.minBudgetPT == "") &&
        (this.maxBudgetPT == null || this.maxBudgetPT == "") &&
        (this.minBudgetPM == null || this.minBudgetPM == "") &&
        (this.maxBudgetPM == null || this.maxBudgetPM == "")
      ) {
        this.Budget = "Budget";
        this.minBudgetPT = 0;
        this.maxBudgetPT = 0;
        this.minBudgetPM = 0;
        this.maxBudgetPM = 0;
      } else {
        this.Budget =
          this.minBudgetPT != null && this.minBudgetPT != ""
            ? this.minBudgetPT + " min"
            : "";
        this.Budget +=
          this.maxBudgetPT != null && this.maxBudgetPT != ""
            ? this.minBudgetPT
              ? "-" + this.maxBudgetPT + " max"
              : this.maxBudgetPT + " max"
            : "";
        this.Budget +=
          this.minBudgetPM != null && this.minBudgetPM != ""
            ? this.minBudgetPT || this.maxBudgetPT
              ? " | " + this.minBudgetPM + "/m² min"
              : this.minBudgetPM + "/m² min"
            : "";
        this.Budget +=
          this.maxBudgetPM != null && this.maxBudgetPM != ""
            ? this.minBudgetPM
              ? "-" + this.maxBudgetPM + "/m² max"
              : this.maxBudgetPM + "/m² max"
            : "";
      }
    },
    getBudget({ minBudgetPT, maxBudgetPT, minBudgetPM, maxBudgetPM }) {
      this.ModelBudget = false;
      if (this.Ancien == true) {
        this.anciensPage = 1;
        this.rechAncienWithCritere();
      } else {
        this.page = 1;
        this.rechBienWithCritere();
      }
    },
    displayTypes({ type, typologie }) {
      if (type != null) {
        this.TypeText = this.camalize(type);
        if (typologie != null) {
          this.TypeText += "/" + this.camalize(typologie);
        }
      }
    },
    getType({ type, typologie }) {
      console.log(type, typologie);
      switch (type) {
        case "Tous":
          this.valueType = { text: "Tous", value: 0 };
          break;
        case "Maison":
          this.valueType = { text: "Maison", value: 2 };
          break;
        case "Appartement":
          this.valueType = { text: "Appartement", value: 1 };
          break;
        default:
          this.valueType = null;
          break;
      }

      switch (typologie) {
        case 0:
          this.valueTypologie = [{ text: "T1", value: 0 }];
          break;
        case 1:
          this.valueTypologie = [{ text: "T2", value: 1 }];
          break;
        case 2:
          this.valueTypologie = [{ text: "T3", value: 2 }];
          break;
        case 3:
          this.valueTypologie = [{ text: "T4", value: 3 }];
          break;
        case 4:
          this.valueTypologie = [{ text: "T5", value: 4 }];
          break;
        default:
          this.valueTypologie = null;
          break;
      }

      this.ModelType = false;
      if (this.Ancien == true) {
        this.anciensPage = 1;
        this.rechAncienWithCritere();
      } else {
        this.page = 1;
        this.rechBienWithCritere();
      }
    },
    getSurfaces({ minSurface, maxSurface }) {
      this.minSurfaceHab = parseFloat(minSurface);
      this.maxSurfaceHab = parseFloat(maxSurface);
      console.log(this.minSurfaceHab, this.maxSurfaceHab);

      if (
        (this.minSurfaceHab == null || this.minSurfaceHab == "") &&
        (this.maxSurfaceHab == null || this.maxSurfaceHab == "")
      ) {
        this.Surface = "Surface";
      } else {
        this.Surface =
          this.minSurfaceHab != null &&
            this.minSurfaceHab != "" &&
            !isNaN(this.minSurfaceHab)
            ? this.minSurfaceHab + "/m² min"
            : "";
        this.Surface +=
          this.maxSurfaceHab != null &&
            this.maxSurfaceHab != "" &&
            !isNaN(this.maxSurfaceHab)
            ? this.minSurfaceHab
              ? "-" + this.maxSurfaceHab + "/m² max"
              : this.maxSurfaceHab + "/m² max"
            : "";
      }
    },
    outsideI() {
      this.ModelInvestir = false;
    },
    outsideL() {
      this.ModelLocation = false;
    },
    outsideB() {
      this.ModelBudget = false;
    },
    outsideT() {
      this.ModelType = false;
    },
    outsideS() {
      this.ModelSurface = false;
    },
    searchBySurface({ minSurface, maxSurface }) {
      this.minSurfaceHab = minSurface;
      this.maxSurfaceHab = maxSurface;
      this.ModelSurface = false;
      if (this.Ancien == true) {
        this.anciensPage = 1;
        this.rechAncienWithCritere();
      } else {
        this.page = 1;
        this.rechBienWithCritere();
      }
    },
    outsideSt() {
      this.ModelStar = false;
    },
    searchCriteres({
      etage,
      date,
      zoneFiscale,
      exposition,
      commission,
      disponibiliteLot,
      Type,
      promoteur,
      programmes,
    }) {
      this.etage = etage;
      this.Livraison = date;
      this.zFiscale = zoneFiscale;
      this.exposition = exposition;
      this.commission = commission;
      this.valueDisponibiliteLots = disponibiliteLot;
      this.valueCommodite = Type.length == 0 ? null : Type;
      this.promoteur = promoteur;
      this.programme = programmes;

      this.ModelCritere = false;
      if (this.Ancien == true) {
        this.anciensPage = 1;
        this.rechAncienWithCritere();
      } else {
        this.page = 1;
        this.rechBienWithCritere();
      }
      // console.log(etage, date,zoneFiscale,exposition,commission,disponibiliteLot,Type,promoteur,programmes)
    },
    outsideA() {
      this.ModelAlert = false;
    },
    TRI(value) {
      console.log("slect", value);
    },
    comparateur() { },
    VideComparateur() { },
    myFunction() {
      var x = document.getElementById("filter_content");
      if (x.className == "filter_content") {
        x.className = "responsive";
      } else if (x.className == "responsive") {
        x.className = "filter_content";
      }
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    hasNumbers(t) {
      var regex = /\d/g;
      return regex.test(t);
    },

    rechBienWithCritere() {
      this.$loading(true);
      window.scrollTo(0, 0);

      if (this.project_id != null) {
        this.setFiltersToProject(this.project_id);
      }

      this.searchQuery = {
        habiter: this.Habiter,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        residence: this.residence,
        typeResidence: this.typeResidence,
        location: this.locationProjet,
        cp: this.departementProjet,
        minBudgetPT: this.minBudgetPT,
        maxBudgetPT: this.maxBudgetPT,
        minBudgetPM: this.minBudgetPM,
        maxBudgetPM: this.maxBudgetPM,
        type: this.valueType,
        typologie: this.valueTypologie,
        minSurfaceHab: this.minSurfaceHab,
        maxSurfaceHab: this.maxSurfaceHab,
        critere1: this.critere1,
        critere2: this.critere2,
        critere3: this.critere3,
        critere4: this.critere4,
        critere5: this.critere5,
        etage: this.etage,
        exposition: this.exposition,
        valueCommodite: this.valueCommodite,
        Livraison: this.Livraison,
        commission: this.commission,
        zFiscale: this.zFiscale,
        valueDisponibiliteLots: this.valueDisponibiliteLots,
        promoteur: this.promoteur,
        programme: this.programme,
      };

      this.rechBienNeufWithFilter({
        habiter: this.Habiter,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        residence: this.residence,
        typeResidence: this.typeResidence,
        location: this.locationProjet,
        cp: this.departementProjet,
        minBudgetPT: this.minBudgetPT,
        maxBudgetPT: this.maxBudgetPT,
        minBudgetPM: this.minBudgetPM,
        maxBudgetPM: this.maxBudgetPM,
        type: this.valueType,
        typologie: this.valueTypologie,
        minSurfaceHab: this.minSurfaceHab,
        maxSurfaceHab: this.maxSurfaceHab,
        critere1: this.critere1,
        critere2: this.critere2,
        critere3: this.critere3,
        critere4: this.critere4,
        critere5: this.critere5,
        etage: this.etage,
        exposition: this.exposition,
        valueCommodite: this.valueCommodite,
        Livraison: this.Livraison,
        commission: this.commission,
        zFiscale: this.zFiscale,
        valueDisponibiliteLots: this.valueDisponibiliteLots,
        promoteur: this.promoteur,
        programme: this.programme,
        perPage: this.perPage,
        page: this.page,
        limit: this.limit,
      }).then((res) => {
        this.totalRows = this.totalRowRechBienNeuf;

        this.$loading(false);
      });
    },
    rechAncienWithCritere() {
      this.$loading(true);
      window.scrollTo(0, 0);

      if (this.project_id != null) {
        this.setFiltersToProject(this.project_id);
      }
      this.searchQuery = {
        habiter: this.Habiter,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        residence: this.residence,
        typeResidence: this.typeResidence,
        location: this.locationProjet,
        cp: this.departementProjet,
        minBudgetPT: this.minBudgetPT,
        maxBudgetPT: this.maxBudgetPT,
        minBudgetPM: this.minBudgetPM,
        maxBudgetPM: this.maxBudgetPM,
        type: this.valueType,
        typologie: this.valueTypologie,
        minSurfaceHab: this.minSurfaceHab,
        maxSurfaceHab: this.maxSurfaceHab,
        critere1: this.critere1,
        critere2: this.critere2,
        critere3: this.critere3,
        critere4: this.critere4,
        critere5: this.critere5,
        etage: this.etage,
        exposition: this.exposition,
        valueCommodite: this.valueCommodite,
        Livraison: this.Livraison,
        commission: this.commission,
        zFiscale: this.zFiscale,
        valueDisponibiliteLots: this.valueDisponibiliteLots,
        promoteur: this.promoteur,
        programme: this.programme,
      };

      this.rechBienAncienWithFilter({
        habiter: this.Habiter,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        residence: this.residence,
        typeResidence: this.typeResidence,
        location: this.locationProjet,
        cp: this.departementProjet,
        minBudgetPT: this.minBudgetPT,
        maxBudgetPT: this.maxBudgetPT,
        minBudgetPM: this.minBudgetPM,
        maxBudgetPM: this.maxBudgetPM,
        type: this.valueType,
        typologie: this.valueTypologie,
        minSurfaceHab: this.minSurfaceHab,
        maxSurfaceHab: this.maxSurfaceHab,
        critere1: this.critere1,
        critere2: this.critere2,
        critere3: this.critere3,
        critere4: this.critere4,
        critere5: this.critere5,
        etage: this.etage,
        exposition: this.exposition,
        valueCommodite: this.valueCommodite,
        Livraison: this.Livraison,
        commission: this.commission,
        zFiscale: this.zFiscale,
        valueDisponibiliteLots: this.valueDisponibiliteLots,
        promoteur: this.promoteur,
        programme: this.programme,
        perPage: this.perPage,
        page: this.anciensPage,
        limit: this.limit,
      }).then((res) => {
        this.totalRows = this.totalRowRechBienNeuf;

        this.$loading(false);
      });
    },

    setFiltersToProject(id) {
      this.setProjectFilters({
        project_id: id,
        habiter: this.Habiter,
        ancien: this.Ancien,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        typeResidence: this.typeResidence,
        minBudgetPT: this.minBudgetPT,
        maxBudgetPT: this.maxBudgetPT,
        minBudgetPM: this.minBudgetPM,
        maxBudgetPM: this.maxBudgetPM,
        minSurfaceHab: this.minSurfaceHab,
        maxSurfaceHab: this.maxSurfaceHab,
        locationProjet: JSON.stringify(this.locationProjet),
        promoteur: JSON.stringify(this.promoteur),
        programme: JSON.stringify(this.programme),
        valueType: JSON.stringify(this.valueType),
        valueTypologie: JSON.stringify(this.valueTypologie),
        etage: this.etage,
        exposition: JSON.stringify(this.exposition),
        valueCommodite: JSON.stringify(this.valueCommodite),
        Livraison: JSON.stringify(this.Livraison),
        commission: this.commission,
        zFiscale: this.zFiscale,
        valueDisponibiliteLots: this.valueDisponibiliteLots,
      }).then((res) => { });
    },
    showPropositions(price, uniqueId) {
      console.log("show propositions");

      let collapseId = "collapse-propositions-" + uniqueId;

      // Step 1: Identify all collapse elements
      let allCollapseElements = document.querySelectorAll('[id^="collapse-propositions-"]');
      console.log(allCollapseElements);

      // Step 3: Show the specific collapse element
      let specificCollapseElement = document.getElementById(collapseId);
      specificCollapseElement.classList.remove('hiddenCollapse');

      // Step 2: Close all collapse elements
      allCollapseElements.forEach(element => {
        if (element.id !== collapseId) {
          element.classList.add('hiddenCollapse');
        }
      });

      // Generate propositions
      this.genererPropositions(price);
    },
    getValue(loadingbank) {
      let pasTopush = 100 / this.bankIdents[0].length;
      for (var i = 0; i < this.bankIdents[0].length; i++) {
        let identifiant = loadingbank;
        if (identifiant.includes(this.bankIdents[0][i].ident)) {
          return (i + 1) * pasTopush;
        }
      }
      this.propositionisLoading = false;
    },
    hideModal(refname) {
      this.$refs[refname].hide();
    },
    afficheCoutprojet() {
      this.$refs["cout_projet"].show();
    },
  },
  directives: {
    ClickOutside,
  },
  watch: {
    page: function () {
      this.searchByFilter();
    },
    anciensPage: function () {
      this.rechAncienWithCritere();
    },
    RolesCurrentUser(value) {
      this.UserRole = value;
    },
  },
};
</script>
<style>
.container-negociation {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: transparent;
  background: linear-gradient(to right, #f6f6f670 0%, #dbdbdb70 25%, #f6f6f670 50%);
  background-size: 1000px 640px;
  /* justify-content: center; */
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}

.container-background-non-valide {
  position: absolute;
  /* background-color: #ff00004d; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: transparent;
  background: linear-gradient(to right, #f6f6f670 0%, #dbdbdb70 25%, #f6f6f670 50%);
  background-size: 1000px 640px;
}

.container-background {
  position: absolute;
  /* background-color: #ff00004d; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: transparent;
  background: linear-gradient(to right, #f6f6f670 0%, #dbdbdb70 25%, #f6f6f670 50%);
  background-size: 1000px 640px;
}




.con-vs-card {
  height: min-content !important;
}

.vs-card--content {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.blue-btn {
  height: max-content !important;
  background-color: #1e8a9e !important;
  color: white !important;
  margin-bottom: 15px;
  border-color: transparent;
  width: 150px !important;
}

.blue-btn .fas {
  color: white;
}

.vs-switch {
  width: 30px !important;
}

.lab {
    z-index: initial !important;
    margin-top: 3px;
}

.switchCtrl.rounded .toggle {
  border-radius: 10px;
  margin-top: -10px;
}

.switchCtrl .toggle {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 25px;
    overflow: hidden;
    vertical-align: top;
}

.switchCtrl input {
    display: none;
}

.switchCtrl input:checked + .toggle::before {
    background-color: #1e8a9e !important;
}

.switchCtrl.rounded .toggle::before {
    border-radius: 10px;
}

.switchCtrl input:checked + .toggle::after {
    background-color: #1e8a9e !important;
}

.switchCtrl input:checked + .toggle::after {
    transform: translateX(26px);
}

.switchCtrl.rounded .toggle::after {
    border-radius: 50%;
}

.switchCtrl .toggle::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background-color: #c0c0c0;
    display: inline-block;
    -webkit-transition: 0.3s;
    transition: 0.3s;
}

.switchCtrl .toggle::after {
    content: "";
    position: absolute;
    width: 18px;
    top: 4px;
    left: 3px;
    bottom: 4px;
    display: inline-block;
    -webkit-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
    box-sizing: border-box;
    border: 3px solid white;
    background-color: #c0c0c0;
}

.badge {
    padding: 0.55em 0.75em 0.6em 0.75em;
    font-size: 75%;
}

.badge-info {
    color: #fff;
}

.badge {
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 90%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    margin: 2px;
}

.requiredInput {
  border: 1px solid red;
}

.mens {
  top: 1.3em !important;
  left: 4.75rem !important;
}

.def .form-control {
  border-radius: 13px !important;
  height: 34px !important;
  margin-top: 4px;
}

.ftd {
  background: #22abc5;
  color: #fff;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 7px !important;
  padding-left: 20px !important;
  width: 42%;
}

.std {
  background: #7fc0cc;
  color: white;
  border-top-right-radius: 10px;
  padding: 7px !important;
  padding-left: 20px !important;
  border-bottom-right-radius: 10px;
}

.ftr {
  font-weight: 600;
  font-size: 17px;
  display: inline-table;
  margin: 4px;
  width: 100%;
}

#formulaire_details_cout2 .modal-dialog {
  max-width: 800px !important;
  margin-top: 86px;
}

.modal .modal-body,
.modal .modal-footer {
  padding-bottom: initial !important;
  padding-top: 10px !important;
}

#formulaire_montant_projet .modal-dialog {
  max-width: 800px !important;
  margin-top: 86px;
}

#formulaire_frais_garanti .modal-dialog {
  max-width: 800px !important;
  margin-top: 86px;
}

#formulaire_montant_emprunte .modal-dialog {
  max-width: 800px !important;
  margin-top: 86px;
}

.head {
  background-color: var(--color);
  /*#22ABC5;*/
  color: white;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom: solid 1px;
}

.head1 {
  background-color: var(--color);
  /*#22ABC5;*/
  color: white;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border-left: solid 1px;
  border-bottom: solid 1px;
}

.options-td {
  background-color: #7fc0cc;
  color: white;
  border-left: solid 1px;
  border-bottom: solid 1px;
}

.CustomFusionner {
  margin-right: 9% !important;
}

.logo_with_etoie {
  float: left;
}




.lock {
  width: 24px;
  height: 21px;
  border: 3px solid #dc3545;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.lock:after {
  content: "";
  display: block;
  background: #dc3545;
  width: 3px;
  height: 7px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -3.5px 0 0 -2px;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

.lock:before {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  bottom: 100%;
  position: absolute;
  left: 50%;
  margin-left: -5px;
  border: 3px solid #dc3545;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  border-bottom: 0;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

/* Locked Hover */
.lock:hover:before {
  height: 12px;
}

/* Unlocked */
.unlocked {
  transform: rotate(10deg);
}

.unlocked:before {
  bottom: 130%;
  left: 31%;
  margin-left: -11.5px;
  transform: rotate(-45deg);
}

.unlocked,
.unlocked:before {
  border-color: #ff5153;
}

.unlocked:after {
  background: #ff5153;
}

/* Unlocked Hover */
.unlocked:hover {
  transform: rotate(3deg);
}

.unlocked:hover:before {
  height: 10px;
  left: 40%;
  bottom: 124%;
  transform: rotate(-30deg);
}
</style>
<style lang="scss">
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin: 0 auto;
  overflow: hidden;

}

table {
  border-collapse: collapse;
  font-size: 12px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 1rem;
  color: #212529;
  border: 0;
  border: 1px solid #dfe1e2;
  margin-top: -8px;

  thead {
    background: #22ABC5;
    color: white;

    th {
      border-right: solid 0.1px #fff;
      text-align: left !important;
      border-bottom: 1px solid #dee2e6 !important;
      font-size: 0.8rem !important;

      div {
        margin-left: 3px;
      }
    }
  }

  tbody {

    .font-div,
    .font-p {
      font-size: 13px;
      margin-top: 0;
      margin-bottom: 0;
      color: #686868;
      padding-left: 15px;

      &.font-div {
        text-transform: capitalize;
      }
    }

    /* Style for even rows */
    tr:nth-child(even) {
      background-color: #f2f2f2;
      /* Change this to your desired background color */
    }

    /* Style for odd rows (optional) */
    tr:nth-child(odd) {
      background-color: #ffffff;
      /* Change this to your desired background color */
    }
  }
}

.nav-pills {
  display: flex;
  list-style: none;
  padding: 0;

  li[role="presentation"] {
    a {
      text-decoration: none;
    }
  }

  .nav-link.active,
  .nav-pills .show>.nav-link {
    color: white !important;
    background-color: #ff8c00 !important;
  }
}

.nav-pills .nav-link {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin: 5px;
  padding: 10px;
  color: white !important;
  background-color: #33b4cd;
}

#collapse1 {
  .row {
    display: flex;
    flex-wrap: nowrap;
    margin-top: 2%;

    .has-float-label {
      display: block !important;
      position: relative !important;
      text-align: -webkit-center !important;

      span {
        color: #1e8a9e !important;
        margin-left: 60px !important;
        position: absolute;
        cursor: text;
        font-size: 70%;
        opacity: 1;
        top: -0.4em;
        left: 0.75rem;
        z-index: 3;
        line-height: 1;
        padding: 0 1px;
        background-color: #e9ecef !important;

        ::after {
          content: " ";
          display: block;
          position: absolute;
          height: 5px;
          top: 3px;
          left: -0.2em;
          right: -0.2em;
          z-index: -1;
        }
      }

      .cursor-pointer {
        cursor: pointer;
        text-decoration: underline;
        width: 100%;
      }

      .form-control {
        box-shadow: initial !important;
        font-size: 0.8rem;
        padding: 0.7rem 0.75rem 0.65rem 0.75rem;
        line-height: 1.5;
        border: 1px solid #22abc5;
        border-radius: 4px;
        height: 15px !important;
        text-align: center;
        text-transform: none;
      }
    }

    .CustomFusionner {
      margin-bottom: 10px;
      padding: 0.375rem 0.75rem !important;
      border-radius: 8px;
      float: right;
      border-color: transparent;
      color: #ffffff !important;
      margin-right: 4% !important;
      background-color: darkorange;
      cursor: pointer;

      :hover {
        color: #1e8a9e;
      }
    }

  }
}

.tabs {
  box-shadow: 0 0 2px #676262 !important;
  overflow: hidden;
}
</style>
<style scoped lang="scss">
.page-content {
  display: inline;
  width: 100%;

  .navigation-bar {
    nav {
      background-color: #22abc5;

      .text-dark {
        text-decoration: none;
      }

      a {
        text-decoration: none;
        color: #ffffff;
      }

      .dropdown {
        .btn-secondary {
          background-color: #22abc5;
          border-color: #22abc5;

          .color {
            color: #ff8c00;
          }
        }

        .btn-secondary:active {
          box-shadow: none;
          background-color: #ff8c00;

          .color {
            color: #ffffff !important;
          }
        }

        .btn-secondary:focus {
          box-shadow: none;
          background-color: #ff8c00;

          .color {
            color: #ffffff !important;
          }
        }
      }
    }
  }

  .filters-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0px;
    height: auto;
    background-color: #f2fdff;
    align-items: center;
    padding-left: 2%;
    padding-right: 2%;
    margin-top: -20px;

    .filter {
      background: #eeeeee;
      padding: 0px;
      padding-left: 15px;
      padding-right: 0px;
      border-radius: 50px;
      margin: 10px;

      span {
        color: #4e4e4e;
        font-size: 13px;
        font-weight: 600;

        svg {
          vertical-align: middle;
          margin-left: 5px;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  .filter_content {
    display: flex;
    margin-bottom: 20px;
    height: 100px;
    background-color: #22abc5;
    align-items: center;
    padding-left: 5%;
    padding-right: 5%;

    .icon {
      display: none;
    }

    .div_btn_load {
      width: 7%;
      margin-right: 2px;

      .btn_load {
        background-color: #ececec;
        border-radius: 1px;
        border: none;
        outline: 0;
        color: #068596ba;
        padding: 6px;

        &:focus {
          .color {
            color: #ff8c00;
          }

          background-color: #dcecec;
        }

        .label {
          cursor: pointer;
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
        }
      }
    }

    .active {
      width: 19%;
      margin-right: 10px;

      .btn {
        width: 100%;
        background-color: #ff8c00;
        border: none;
        outline: 0;
        color: #ffffff;
        padding: 10px 5px 10px 5px;
        font-size: 17px;
        font-family: Metropolis;
        border-radius: 5px;

        svg {
          path {
            fill: #ffffff;
          }
        }

        .label {
          cursor: pointer;
          color: #ffffff;
          margin-left: 2px;
          padding-left: 20px;
          padding-right: 12px;
          font-size: 15px;
        }

        .color {
          color: #ffffff !important;
          margin-right: 15px;
        }
      }

      .btn_star {
        width: 150%;
        position: relative;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;

        .label {
          display: inline;
        }
      }

      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;

        .label {
          color: #ececec;
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }

    .div_btn {
      width: 19%;
      margin-right: 10px;

      &:focus {
        .btn {
          color: #ff8c00;

          svg {
            path {
              fill: #ffffff;
            }
          }
        }
      }

      .btn {
        width: 100%;
        background-color: #22abc5;
        border: none;
        outline: 0;
        color: #ffffff;
        padding: 10px 5px 10px 5px;
        font-family: Metropolis;
        font-size: 17px;
        border-radius: 5px;

        &:focus {
          .color {
            color: #ff8c00;
          }

          background-color: #ff8c00;
        }

        :hover {
          cursor: pointer;
        }

        .label {
          margin-left: 2px;
          padding-left: 20px;
          padding-right: 12px;
          font-size: 15px;
        }

        .color {
          color: #ff8c00 !important;
          margin-right: 15px;
        }
      }

      .btn_star {
        width: 50%;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;

        .label {
          display: none;
        }

        &:focus {
          width: 100%;

          .label {
            display: inline;
          }
        }
      }

      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ececec;
        padding: 6px;

        &:focus {
          .color {
            color: #ff8c00;
          }
        }

        .label {
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }
  }

  .responsive {
    width: 100%;
    display: flex;
    //margin-top: 10px;
    margin-bottom: 20px;

    .icon {
      display: none;
    }

    .div_btn_load {
      width: 7%;
      margin-right: 2px;

      .btn_load {
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #068596ba;
        padding: 6px;

        &:focus {
          .color {
            color: #ff8c00;
          }

          background-color: #dcecec;
        }

        .label {
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
          font-size: 12px;
        }
      }
    }

    .active {
      width: 19%;
      margin-right: 1px;

      .btn {
        width: 100%;
        background-color: #dcecec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;

        .label {
          color: #068596ba;
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
          font-size: 12px;
        }
      }

      .btn_star {
        width: 150%;
        position: relative;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;

        .label {
          display: inline;
        }
      }

      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;

        .label {
          color: #ececec;
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }

    .div_btn {
      width: 19%;
      margin-right: 1px;

      &:focus {
        .btn {
          color: #ff8c00;
          font-family: Metropolis;
        }
      }

      .btn {
        width: 100%;
        background-color: #ececec;
        border: none;
        outline: 0;
        color: #068596ba;
        padding: 10px 5px 10px 5px;
        font-family: Metropolis;
        font-size: 18px;
        border-radius: 5px;

        &:focus {
          .color {
            color: #ff8c00;
          }

          background-color: #dcecec;
        }

        .label {
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
        }
      }

      .btn_star {
        width: 50%;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;

        .label {
          display: none;
        }

        &:focus {
          width: 100%;

          .label {
            display: inline;
          }
        }
      }

      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ececec;
        padding: 6px;

        &:focus {
          .color {
            color: #ff8c00;
          }
        }

        .label {
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }
  }

  .container {
    margin: 2%;

    .content {
      width: 100%;
      display: flex;
      //margin-top: 10px;
      margin-bottom: 20px;

      .icon {
        display: none;
      }

      .Card_content {
        width: 100%;
        display: inline;
        padding: 20px;
        background: #f2fdff;

        .card {
          //position: relative;
          display: inline;
          width: 100%;
          flex-direction: row;

          .row {
            margin: 5px;
            background: #ffffff;
            display: flex;
          }

          .card-blocSlide {
            //position: relative;
            display: block;
            width: 30%;
            color: #aba3a3;
            text-align: right;
            margin: 5px;

            .contentblue {
              background-color: #068596ba;

              .buttonComparateur {
                background-color: #068596ba;
                color: white;
                padding: 5px;
                border: none;
                outline: 0;
                width: 100%;

                &:hover {
                  color: #ff8c00;
                }
              }
            }
          }

          .card-blocTitle {
            //position: relative;
            display: block;
            width: 40%;
            color: #aba3a3;
            text-align: left;
            margin: 15px 0px 15px 15px;

            span {
              color: #22abc5;
              font-family: "Seoge UI-bold";
            }

            svg {
              color: #22abc5;
              margin-right: 3px;
            }

            .cotent_star {
              //position: absolute;
              right: 0;
              text-align: left;
              margin-top: 7px;
              font-family: "Seoge UI";
            }

            .ligne {
              margin-top: 5px;
              margin-bottom: 20px;
              width: 100%;
            }

            .bluecolor {
              color: #22abc5;
              font-size: 18px;
              font-family: "Seoge UI-bold";
              margin-top: -6px;
            }

            div {
              min-width: 250px;
            }
          }

          .card-blocData {
            //position: relative;
            display: block;
            width: 33%;
            color: #aba3a3;
            text-align: right;
            margin: 15px 15px 15px 0px;
            text-align: right;
            color: #aba3a3;

            .titlecolor {
              color: #6f6767;
            }

            .price {
              color: #ff8c00;
              font-weight: bold;
              font-size: 24px;
              font-family: "Seoge UI-Bold";
            }

            .program {
              color: #22abc5;
              text-transform: uppercase;
              font-family: "Seoge UI-bold";
              font-size: 20px;
            }

            .promoteur {
              color: #22abc5;
              font-family: "Seoge UI-bold";
              font-size: 20px;
              margin-top: 0px;
            }

            .alert {
              background-color: #ff8c00;
              border-radius: 5px;
              border: none;
              outline: 0;
              color: white;
              padding: 6px;
              padding-top: 10px;
              padding-bottom: 10px;
              cursor: pointer;
              padding-right: 20px;
              padding-left: 20px;
              font-family: Metropolis;
            }

            .comparateur {
              background-color: #22abc5;
              border-radius: 4px;
              border: none;
              outline: 0;
              color: white;
              padding: 6px;
              padding-top: 10px;
              padding-bottom: 10px;
              cursor: pointer;
              margin-right: 5px;
              padding-right: 15px;
              padding-left: 15px;
              font-family: Metropolis;
            }

            div {
              margin-top: 10px;
              font-weight: bold;
              color: #888888;
              font-family: "Seoge UI-bold";
            }
          }
        }
      }

      .text-result {
        font-size: 17px;
        color: #888888;
        font-family: "Seoge UI-400";
      }

      .text-blue {
        color: #068596ba;
        margin: 0px;
      }

      .col2 {
        width: 50%;

        .Alert {
          text-align: end;

          .alert {
            background-color: #fb4444;
            border-radius: 5px;
            border: none;
            outline: 0;
            color: white;
            padding: 10px;
            width: 190px;
            font-family: Metropolis;
            font-size: 16px;
          }
        }

        .row3 {
          text-align: end;
          display: flex;

          .btn {
            width: 95%;
            background-color: #e4e3e3;
            border-radius: 5px;
            border: 1px solid #e4e3e3;
            outline: 0;
            color: #857a7a;
            padding: 5px;
            padding-top: 10px;
            padding-bottom: 10px;
          }

          .select {
            width: 100%;
            color: red;
          }

          .blue {
            background-color: #22abc5;
            color: white;
            width: 79%;
          }

          .pink {
            background-color: #22abc5;
            color: white;
            font-size: 20px;
            font-family: "Seoge UI";
          }

          .span {
            margin-top: 5%;
            width: 20%;
            color: #888888;
            font-size: 20px;
            font-family: "Seoge UI";
          }
        }
      }

      .width1 {
        width: 18%;
      }

      .width2 {
        width: 30%;
      }

      .width3 {
        width: 42%;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .page-content {
    .filter_content {
      display: none;
    }

    .responsive {
      width: 50%;
      top: 32px;
      left: 2px;
      padding-left: 30px;
      padding-top: 10px;
      padding-bottom: 10px;
      background-color: #ced9da;
      overflow: hidden;
      box-shadow: 5px 5px 10px grey;
      position: absolute;
      z-index: 11;
      transition: all 0.25s;
      -webkit-transition: all 0.25s;
      font-weight: 400;
      text-align: left;
      font-size: 12px;
      margin: 0px;
      display: inline;

      .div_btn_load {
        width: 7%;
        margin-right: 2px;

        .btn_load {
          background-color: #ececec;
          border-radius: 15px;
          border: none;
          outline: 0;
          color: #068596ba;
          padding: 6px;

          &:focus {
            .color {
              color: #ff8c00;
            }

            background-color: #dcecec;
          }

          .label {
            margin-left: 2px;
            padding-left: 3px;
            padding-right: 3px;
          }
        }
      }

      .active {
        width: 50%;
        margin-right: 1px;

        .btn {
          width: 100%;
          background-color: #dcecec;
          border-radius: 15px;
          border: none;
          outline: 0;
          color: #ff8c00;
          padding: 6px;

          .label {
            color: #068596ba;
            margin-left: 2px;
            padding-left: 3px;
            padding-right: 3px;
          }
        }

        .btn_star {
          width: 150%;
          position: relative;
          background-color: #ececec;
          border-radius: 15px;
          border: none;
          outline: 0;
          color: #ff8c00;
          padding: 6px;

          .label {
            display: inline;
          }
        }

        .btn_add {
          background-color: #068596ba;
          border-radius: 15px;
          border: none;
          outline: 0;
          color: #ff8c00;
          padding: 6px;

          .label {
            color: #ececec;
            margin-left: 2px;
            padding-left: 3px;
          }
        }
      }

      .div_btn {
        width: 50%;
        //margin-right: 1px;
        margin: 2px;

        &:focus {
          .btn {
            color: #ff8c00;
          }
        }

        .btn {
          width: 100%;
          background-color: #ececec;
          border-radius: 15px;
          border: none;
          outline: 0;
          color: #068596ba;
          padding: 6px;

          &:focus {
            .color {
              color: #ff8c00;
            }

            background-color: #dcecec;
          }

          .label {
            margin-left: 2px;
            padding-left: 3px;
            padding-right: 3px;
          }
        }

        .btn_star {
          width: 50%;
          background-color: #ececec;
          border-radius: 15px;
          border: none;
          outline: 0;
          color: #ff8c00;
          padding: 6px;

          .label {
            display: none;
          }

          &:focus {
            width: 100%;

            .label {
              display: inline;
            }
          }
        }

        .btn_add {
          background-color: #068596ba;
          border-radius: 15px;
          border: none;
          outline: 0;
          color: #ececec;
          padding: 6px;

          &:focus {
            .color {
              color: #ff8c00;
            }
          }

          .label {
            margin-left: 2px;
            padding-left: 3px;
          }
        }
      }
    }

    .content {
      .icon {
        float: left;
        display: block;
        border: 1px solid white;
        height: 25px;
        width: 30px;
        color: #068596ba;
        border-radius: 5px;
        outline: 0;
      }

      .div_btn {
        .btn {
          font-size: 11px;
          height: 40px;
        }

        .btn_star {
          font-size: 12px;
          height: 40px;
        }

        .btn_add {
          font-size: 11px;
          height: 40px;
        }
      }

      .div_btn_load {
        .btn_load {
          font-size: 12px;
          height: 40px;
        }
      }

      .Card_content {
        .card {
          .row {
            display: flex;
          }

          flex-direction: column;

          .card-blocSlide {
            width: 80%;
          }

          .card-blocTitle {
            width: 80%;
            text-align: left;

            .cotent_star {
              text-align: left;
            }
          }

          .card-blocData {
            width: 80%;
            text-align: left;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 425px) {
  .page-content {
    .responsive {
      width: 80%;

      .div_btn {
        width: 65%;
      }

      .active {
        width: 65%;
      }
    }

    .container {
      .content {
        display: inline-block;

        .col2 {
          width: 100%;

          .row3 {
            .select {
              width: 100%;

              .row {
                margin: 0;

                select {
                  .selectBlue {
                    width: 100% !important;
                    font-size: 20px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .content {
      display: inline-block;
      width: 100%;
      text-align: center;
      margin-bottom: 10px;

      .Card_content {
        .card {
          .row {
            display: inline-block !important;
          }

          .card-blocSlide {
            width: 90% !important;
          }

          .card-blocTitle {
            div {
              min-width: 150px;
            }

            width: 100%;
            font-size: 12px;
          }

          .card-blocData {
            width: 80% !important;
          }
        }
      }

      .div_btn {
        width: 50%;
        margin-left: 20%;
        margin-right: 20%;
      }

      .col2 {
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 0;

        .row3 {
          display: inline;

          .select {
            width: 95%;
          }
        }
      }

      .width2 {
        width: 100%;
      }

      .width3 {
        width: 100%;
        margin: 0px;
      }
    }
  }
}

.modal-backdrop {
  z-index: 999;
  position: absolute;

  .modal {
    width: 200px;
    background-color: #fff;
    border-radius: 3px;
    padding: 15px;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);

    .btn {
      width: 50px;
      border-radius: 5px;
      border: none;
      color: white;
      background-color: #068596ba;
      padding: 10px;
      margin-left: 70%;
      outline: 0;

      &:focus {
        border: none;
        background-color: #ff8c00;
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .modal-backdrop {
    position: initial;

    .modal {
      width: 150px;
    }
  }
}

.titre_content {
  text-align: center;
  font-size: 23px;
  color: #068596ba;
  margin: 14px;
}

.Detailscontent {
  display: inline;
  width: 100%;
  color: #6f6767;
}

.Detailscontent .title {
  display: flex;
  width: 100%;
  margin-bottom: 13px;
  font-weight: 900;
  color: #072025;
  font-size: 15px !important;
}

.gras {
  font-weight: bold;
  font-size: 18px;
}

.colorBl {
  color: #068596;
}

.colorB {
  color: black;
}

.blackcolor {
  color: rgb(48, 46, 46);
  font-size: 19px;
}

.colorIcon {
  color: #068596ba;
  font-size: 18px;
  list-style-type: circle;
}

details {
  display: block;
  width: 100%;
  margin: 10px 0;
}

summary {
  display: block;
  color: white;
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
  font-weight: lighter;
}

summary:focus {
  outline: transparent;
}

summary::-webkit-details-marker {
  color: #ff0000;
  background: #ffffff;
}

details[open] summary::-webkit-details-marker {
  color: #0000ff;
  background: #00ffff;
}

summary::-webkit-details-marker {
  display: none;
}

summary:after {
  content: "+";
  color: white;
  float: left;
  font-size: 1.5em;
  font-weight: lighter;
  margin: -5px 5px 0 0;
  padding: 0;
  text-align: center;
  width: 20px;
}

details[open] summary:after {
  content: "-";
  color: #ffffff;
}

.details {
  margin: 0 auto;
  padding-right: 15px;
  padding-left: 15px;
}

.details h2 {
  font-size: 34px;
  width: 100%;
  padding: 20px 0 0;
  text-align: center;
  font-size: 26px;
  color: #005cac;
}

.property-childs-list {
  padding: 0;
  margin-bottom: 0;
}

.property-childs-list .property-child:nth-child(odd) {
  background-color: rgba(6, 43, 78, 0.05);
}

.property-childs-list .property-child {
  padding: 10px;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
}

.property-childs-list .property-child .btn-detail-sibling {
  padding-right: 55px;
  transition: all 0.3s;
}

.property-childs-list .property-child-title {
  font-size: 16px;
}

.property-childs-list .property-child-price {
  font-weight: 700;
  font-size: 20px;
  text-align: right;
  color: #f28e22;
}

.property-childs-list .property-child-rate strong {
  color: #005cac;
}

.property-childs-list .property-child-rate .value {
  color: #762986;
  font-weight: 700;
}

.property-childs-list .property-child:hover .property-child-price,
.property-childs-list .property-child:hover .property-child-pricem2 {
  /* transform: translateX(-80px); */
  transition: all 0.3s;
}

.property-childs-list .property-child-pricem2 {
  font-size: 13px;
  text-align: right;
}

.property-childs-list .property-child .btn-detail {
  display: inline-block !important;
  position: relative;
  right: 15px;
  top: 50%;
  bottom: 0;
  height: 30px;
  margin: 0 !important;
  width: auto !important;
  padding: 7px 5px !important;
  vertical-align: middle;
  transform: translateY(-50%);
  cursor: pointer;
}

.property-childs-list .property-child .btn-detail span {
  line-height: 38px;
  opacity: 0;
  width: 1px;
  display: inline-block;
  padding-left: 5px;
}

.property-childs-list .property-child .btn-detail i {
  display: inline-block;
  vertical-align: top;
  line-height: 31px;
  margin-left: 0px;
  padding-left: 0px;
  margin-right: 5px;
}

.fa-angle-right:before {
  content: "\f105";
  font-size: 20px;
}

.btn-secondary,
.prospace .container .btn[type="submit"]:not(.btn-danger) {
  background-color: #f28e22;
  border-color: #f28e22;
}

.btn-secondary:hover,
.prospace .container .btn:hover[type="submit"]:not(.btn-danger) {
  background-color: #22abc5;
  color: #fff;
  border-color: #22abc5;
}
</style>
<style>
.img_logo_banque {
  width: 100px;
  height: 41px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
}

/* 23.Navs */
.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: white;
  background-color: #33b4cd;
}

.nav-pills .nav-link {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin: 5px;
  padding: 10px;
  color: white !important;
}

.nav-pills .nav-link .folderIcon {
  color: #1e8a9e !important;
}

.nav-link {
  padding: 0.5rem 1rem;
}

@media (max-width: 767px) {
  .nav-link {
    padding: 0.5rem 0.5rem;
  }
}

.nav-link.active {
  color: #33b4cd;
}

.page-item {
  padding: 5px;
}

@media (max-width: 767px) {
  .page-item {
    padding: 3px;
  }
}

.page-item .page-link {
  outline: initial !important;
  box-shadow: initial !important;
  line-height: 1.7;
  text-align: center;
  border-radius: 5px;
  width: 30px;
  height: 30px;
  font-size: 16px;
  font-family: Metropolis;
}

@media (max-width: 575px) {
  .page-item .page-link {
    min-width: 30px;
    height: 30px;
    line-height: 0.9;
    font-size: 0.76rem;
  }
}

.page-item .page-link.next {
  background: #33b4cd;
  color: white;
  border: 1px solid #33b4cd;
}

.page-item .page-link.prev,
.page-item .page-link.prev {
  background: #33b4cd;
  border: 1px solid #33b4cd;
  color: white;
}

.page-item .page-link:first,
.page-item .page-link.last {
  background: transparent;
  color: #33b4cd;
  border: 1px solid #33b4cd;
  border-radius: 30px;
}

.page-item .page-link:first:hover,
.page-item .page-link.last:hover {
  background: #33b4cd;
  color: white;
  border: 1px solid #33b4cd;
}

.page-item .page-link:hover {
  cursor: pointer;
  background-color: #ff8c00;
  color: #ffffff;
}

.page-item.active .page-link {
  background: #ff8c00;
  color: white;
  border-radius: 5px;
  width: 30px;
  height: 30px;
  font-size: 16px;
  font-family: Metropolis;
}

.page-item.disabled .page-link {
  /*border-color: $separator-color;*/
  border: initial;
  color: #d7d7d7;
  background: transparent;
}

.page-item[role="separator"] .page-link {
  color: #212121;
}

.page-link {
  background-color: #22abc5;
  border-color: transparent;
  color: #ffffff;
}

.btn-sm.page-link {
  padding: 0.5rem 0.5rem;
}

.pagination-lg .page-item {
  padding: 15px;
}

@media (max-width: 767px) {
  .pagination-lg .page-item {
    padding: 3px;
  }
}

.pagination-lg .page-item .page-link {
  min-width: 50px;
  height: 50px;
}

@media (max-width: 767px) {
  .pagination-lg .page-item .page-link {
    min-width: 38px;
    height: 38px;
    padding: 0.55rem 0;
    line-height: 1.5;
    font-size: 0.8rem;
  }
}

@media (max-width: 575px) {
  .pagination-lg .page-item .page-link {
    min-width: 30px;
    height: 30px;
    line-height: 0.9;
    font-size: 0.76rem;
  }
}

.pagination-sm .page-item {
  padding: 6px;
}

@media (max-width: 767px) {
  .pagination-sm .page-item {
    padding: 3px;
  }
}

.pagination-sm .page-item .page-link {
  min-width: 30px;
  height: 30px;
  line-height: 0.9;
  font-size: 0.76rem;
}

.pagination {
  display: -webkit-box !important;
  -webkit-box-pack: center;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-item .page-link {
  outline: initial !important;
  box-shadow: initial !important;
  line-height: 1.7;
  text-align: center;
}

.vueperslides__arrow,
.vueperslides__arrow svg {
  font-size: 5px;
  background: #22abc5;
}

.vueperslides__parallax-wrapper {
  padding-bottom: 50% !important;
}

/* common */
.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid #2980b9;
}

.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 15px 0;
  background-color: #3498db;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font: 700 18px/1 "Lato", sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

/* bottom right*/
.ribbon-bottom-right {
  bottom: -10px;
  right: -10px;
}

.ribbon-bottom-right::before,
.ribbon-bottom-right::after {
  border-bottom-color: transparent;
  border-right-color: transparent;
}

.ribbon-bottom-right::before {
  bottom: 0;
  left: 0;
}

.ribbon-bottom-right::after {
  top: 0;
  right: 0;
}

.ribbon-bottom-right span {
  left: -25px;
  bottom: 30px;
  transform: rotate(-45deg);
}

/* common */

.multiselect {
  margin-bottom: 15px;
}

.multiselect__tags {
  min-height: 43px;
  display: block;
  border-radius: 5px;
  border: 1px solid #22abc5;
  background: #fff;
  font-size: 13px;
  padding: 7px;
}

.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 15px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #22abc5;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

.multiselect__option--highlight {
  background: #22abc5;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-family: Metropolis;
}

.multiselect__element {
  font-size: 12px;
}

.multiselect__tag-icon:after {
  content: "\D7";
  color: #ff8c00;
  font-size: 14px;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #ff8c00;
}

.multiselect__option--highlight:after {
  content: attr(data-select);
  background: #ff8c00;
  color: #fff;
}

.multiselect__placeholder {
  color: #adadad;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
  font-family: Metropolis;
}

.multiselect__option {
  display: block;
  padding: 12px;
  min-height: 40px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  font-family: Metropolis;
  font-size: 12px;
}

.multiselect__select {
  position: absolute;
  width: 40px;
  height: 38px;
  right: -10px;
  top: 1px;
  padding: 4px 8px;
  text-align: center;
  transition: transform 0.2s ease;
}

.multiselect__select:before {
  position: relative;
  right: 0;
  top: 65%;
  color: #22abc5;
  margin-top: 4px;
  border-color: #22abc5 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 0;
  content: "";
}

.content-card-details {
  background-color: white;
  display: flex;
  justify-content: flex-start;

  padding-left: 1%;
  border-radius: 13px;

  margin-right: 1%;

  padding-top: 25px;
  padding-bottom: 25px;
}

.btn_details {
  background-color: #ff8c00;
  border-radius: 5px;
  border: none;
  outline: 0;
  color: #fff;
  padding: 6px;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
  padding-right: 20px;
  padding-left: 20px;
  font-family: Metropolis;
}

.content-type {
  background-color: #70707029;
  padding: 8px;
  border-radius: 5px;
  color: #2da9c5;
  font-family: "Poppins";
  margin-bottom: 10px;
  font-size: 15px;
  margin: 0;
}
</style>
<style scoped lang="scss">
.row {
  width: 100%;
  margin: 8px;

  .select_title {
    margin-bottom: 10px;
    color: #22abc5;
    font-size: 15px;
    font-family: Metropolis;
  }

  div {
    margin-left: 0%;
    width: 94%;

    .input {
      color: #22abc5;
      background-color: white;
      padding: 12px;
      border-radius: 5px;
      width: 94%;
      border: 1px solid #22abc500;
      margin-top: 0px;
      font-family: Metropolis;

      &:focus {
        outline: 0;
      }

      &::placeholder {
        color: #b5bcbd;
      }
    }
  }
}

.masque {
  display: none;
}

@media screen and (max-width: 1400px) {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .col2 {
      width: 100% !important;

      .row3 {
        width: 100% !important;
      }

      .multiselect {}

      button {
        margin-bottom: 20px;
      }

      input {
        margin-bottom: 10px;
      }
    }
  }
}

.FiltersNavbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  background-color: #21ABC5;
  min-height: 100px;
  padding: 0px 10px;
  z-index: 100;

  .DropDownContainer {
    margin: 10px 10px;
    position: relative;

    .header {
      display: flex;
      align-items: flex-start;
      cursor: pointer;
      padding: 10px 20px;
      border-radius: 10px;

      .Icon {
        color: #FF8C00;
        font-size: 15px;
        margin-right: 5px;
      }

      h2 {
        color: white;
        font-size: 15px;
        font-weight: 600;
        margin: 0;
        margin-right: 10px;
      }

      .ChevIcon {
        color: white;
        font-size: 15px;
      }
    }

    .selected {
      display: flex;
      align-items: flex-start;
      cursor: pointer;
      background-color: #FF8C00;

      .Icon {
        color: white;
        font-size: 15px;
        margin-right: 5px;
      }

      h2 {
        color: white;
        font-size: 15px;
        font-weight: 600;
        margin: 0;
        margin-right: 10px;
      }

      .ChevIcon {
        color: white;
        font-size: 15px;
      }
    }

    .body {
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      display: none;
      position: absolute;
      z-index: 100;
      top: 120%;
      left: 0;
      background-color: #F2FDFF;
      color: black;
      width: 220px;
      padding: 10px 20px;
      border-radius: 10px;

      .ValideBtn {
        background-color: #21ABC5;
        border-radius: 5px;
        border: none;
        outline: 0;
        color: white;
        cursor: pointer;
        font-family: Metropolis;
        margin-top: 10px;
        margin-bottom: 10px;
        width: 100%;
        height: 40px;
      }

      label {
        color: #21ABC5;
        font-size: 13px;
        margin-bottom: 5px;
      }

      .input {
        margin-bottom: 10px;
        border: 1px solid white;
        outline: none;

        &:focus {
          border: 1px solid #21ABC5;
        }
      }

      select {
        width: 100%;
        height: 35px;
        margin-bottom: 10px;
        border: 1px solid #21ABC5;
        outline: none;
      }
    }

    .body.show {
      z-index: 100;
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 120%;
      left: 0;
      width: 100%;
      transform: translateY(-1px);
      /* This value may need adjustment based on your layout */
      background-color: #ffffff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      padding: 10px;
      box-sizing: border-box;
    }
  }
}

.PlusCritere {
  z-index: 1;
  width: 100%;
  flex-direction: column;
  align-items: center;
  overflow: visible;
  margin-top: 20px;

  .filtersList {
    width: 95%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    .FilterBox {
      margin: 10px;
      display: flex;
      flex-direction: column;

      label {
        color: #21ABC5;
        font-size: 13px;
        margin-bottom: 5px;
      }

      .input {
        margin-bottom: 10px;
        border: 1px solid white;
        outline: none;

        &:focus {
          border: 1px solid #21ABC5;
        }
      }

      select {
        width: 150px;
        height: 35px;
        margin-bottom: 10px;
        border: 1px solid #21ABC5;
        outline: none;
      }

      .keywordsOperator {
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        label {
          margin: 0;
          margin-right: 20px;
        }

        input {
          margin: 5px;
        }
      }
    }
  }

  .ValideBtn {
    background-color: #21ABC5;
    border-radius: 5px;
    border: none;
    outline: 0;
    color: white;
    cursor: pointer;
    font-family: Metropolis;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 40px;
    width: 95%;
  }
}

.PlusCritere.show {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  animation: slideDown 0.3s ease-out;
  /* Updated timing function */
  opacity: 1;
}

.PlusCritere.hide {
  margin-top: 20px;
  display: none;
  animation: slideUp 0.3s ease-out;
  /* Updated timing function */
  opacity: 0;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(-20px);
  }
}


// New Responsive Cards
.Container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f2fdff;
  padding: 0px 20px;

  .Card {
    width: 100%;
    padding: 15px;
    margin: 10px 0;
    display: flex;
    background-color: white;

    .left {
      width: 90%;

      .Top {
        display: flex;
        margin-bottom: 30px;

        .ImageCarousel {
          position: relative;
          margin-right: 15px;
          width: 30%;
          margin-top: 10px;

          .nbJours {
            z-index: 1;
            position: absolute;
            top: 0;
            left: 0;
            width: 50px;
            height: 40px;
            background-color: rgb(255, 140, 0);
            border-bottom-right-radius: 10px;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .nbImages {
            z-index: 1;
            position: absolute;
            top: 0;
            right: 0;
            width: 50px;
            height: 40px;
            background-color: rgb(255, 140, 0);
            border-bottom-left-radius: 10px;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;

            .icon {
              margin-left: 5px;
            }
          }

          .Slider {
            z-index: 0;
            overflow: hidden;
          }
        }

        .Infos {
          width: 70%;

          .Title {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 10px;
            margin-top: 10px;
            background-color: #fbfbfb;
            padding: 5px 10px;

            .homeIcon {
              margin-right: 10px;
              font-size: 18px;
              color: rgb(34, 171, 197);
            }

            h2 {
              font-size: 20px;
              font-weight: 600;
              margin: 0;
              margin-right: 10px;
              color: rgb(34, 171, 197);
            }

            p {
              margin: 0;
              font-size: 13px;
              font-weight: 600;
              color: rgb(34, 171, 197);
            }
          }

          .TypePublish {
            display: flex;
            align-items: center;
            justify-content:space-between;
            flex-wrap:wrap;
            background-color: #e8e8e8;
            max-width: 100%;
            height: auto;
            padding: 5px 10px;
            font-family: "Seoge";
            border-radius: 7px;
            margin-bottom: 10px;
            

            .publisherInfoBox {
                display:flex;
                align-items: center;
                justify-content: center;
                
                p {
                  font-size: 15px;
                  margin-left: 10px;
                }
              }

              .YesNoBox {
                input {
                  width: 15px;
                  height: 15px;
                }

                p {
                  margin: 0;
                  margin-right: 10px;
                  font-size: 18px;
                }
              }
          }

          .TypePublishRed {
            background-color: red;
            color:white;
          }

          .TypePublishGreen {
            background-color: green;
            color:white;
          }
          .DescContainer {
            margin-bottom: 10px;

            p {
              margin: 0;
              font-size: 15px;
              height: 110px;
              width: 98%;
              overflow: hidden;
              text-align: justify;
              font-family: "Seoge";
            }
          }

          .BadgesList {
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            .badge {
              display: flex;
              align-items: center;
              background-color: #e8e8e8;
              padding: 0px 10px;
              margin-right: 10px;
              margin-bottom: 10px;
              height: 30px;

              p {
                font-size: 14px;
                margin-left: 5px;
              }
            }
          }
        }
      }

      .Bottom {
        display: flex;
        justify-content: space-evenly;
        // .Row {
        //   .BoxContainer {
        //     display: flex;
        //     width: 100%;
        //     justify-content: space-between;

        //     .Box {
        //       display: flex;
        //       align-items: center;
        //       justify-content: flex-start;
        //       flex-direction: column;
        //       width: 30%;
        //       border-radius: 5px;
        //       padding: 10px;
        //       margin: 0 10px;
        //       text-align: center;

        //       .icon {
        //         font-size: 22px;
        //         margin-bottom: 10px;
        //         height: 50px;
        //         color:rgb(255, 140, 0);
        //       }

        //       h2 {
        //         font-size: 20px;
        //         font-weight: bold;
        //         margin-bottom: 5px;
        //         color:rgb(34, 171, 197);
        //       }

        //       p {
        //         font-size: 15px;
        //         font-weight: bold;
        //         margin-bottom: 5px;
        //         color:rgb(34, 171, 197);
        //       }

        //       button {
        //         background-color: rgb(255, 140, 0);
        //         color: white;
        //         border: none;
        //         border-radius: 5px;
        //         font-size: 15px;
        //         font-weight: bold;
        //         cursor: pointer;
        //         padding: 5px 10px;
        //         margin-top: 10px;
        //       }

        //       .OldPrice {
        //         text-decoration: line-through;
        //       }

        //       .NewPrice {
        //         span {
        //             color: rgb(0, 180, 0);
        //         }
        //       }

        //       .LogoIcons {
        //         display: flex;
        //         flex-wrap: wrap;
        //       }
        //     }
        //   }
        // }

        .Bottom-left {
          width: 30%;

          .LogoIcons {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            gap: 5px;
          }
        }

        .Bottom-right {
          width: 70%;

          .BoxContainer {
            display: flex;
            justify-content: space-evenly;

            .Box {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex-direction: column;
              border-radius: 5px;
              padding: 10px;
              margin: 0 10px;
              text-align: center;

              .icon {
                font-size: 20px;
                height: 20px;
                color: rgb(255, 140, 0);
                margin-bottom: 10px;
              }

              h2 {
                font-size: 15px;
                font-weight: bold;
                color: rgb(34, 171, 197);
                margin: 0;
              }

              p {
                font-size: 15px;
                font-weight: bold;
                color: rgb(34, 171, 197);
                margin: 0;
              }

              button {
                background-color: rgb(255, 140, 0);
                color: white;
                border: none;
                border-radius: 5px;
                font-size: 14px;
                cursor: pointer;
                padding: 7px 12px;
                margin-top: 10px;
              }

              .btn-propositions {
                background-color: #22abc5 !important;
              }

              .OldPrice {
                text-decoration: line-through;
              }

              .NewPrice {
                span {
                  color: rgb(0, 180, 0);
                }
              }

              .LogoIcons {
                display: flex;
                flex-wrap: wrap;
              }
            }
          }


        }
      }

      .PropositionsContainer {
        height: 400px;
        max-width: 100%;
        box-shadow: 0 0 5px #c9c9c9 !important;
      }
    }

    .right {
      width: 10%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: right;

      h2 {
        color: rgb(255, 140, 0);
        font-weight: bold;
        font-size: 22px;
        font-family: "Seoge UI-bold";
        background-color: #fbfbfb;
        width: 100%;
        padding: 5px 0 5px 0;
        margin: 0;
        margin-top: 10px;
        margin-bottom: 10px;
      }

      p {
        font-size: 14px;
        font-weight: bold;
        margin: 0;
        color: grey;
        font-family: "Seoge UI-bold";
        margin-bottom: 10px;
      }

      .PlusInfo {
        background-color: rgb(255, 140, 0);
        color: white;
        border: none;
        border-radius: 5px;
        font-size: 15px;
        cursor: pointer;
        padding: 5px 10px;
        margin-top: 10px;
      }

      .CheckboxContainer {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;

        .Checkbox {
          width: 12px;
          height: 12px;

          input {
            margin: 0;
            margin-right: 10px;
          }
        }

        label {
          font-size: 14px;
          padding: 0;
          margin: 0;
          margin: 0;
        }
      }
    }
  }
}


.ShowMoreLessBtn {
  width: 60px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgb(227, 227, 227);
  border: none;
  margin: 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: rgb(201, 200, 200);
  }
}

.LogoShop {
  position: relative;

  .LogoPrice {
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: red;
    width: 60px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      font-size: 10px;
      color: white;
      margin: 0;
      font-weight: bold;
    }
  }
}

.autocomplete {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  z-index: 1;
}

.autocomplete div {
  padding: 5px;
  cursor: pointer;
}

.autocomplete div:hover {
  background-color: #f2f2f2;
}

.keyword-box {
  display: flex;
  align-items: center;
  background-color: #c4f5ff;
  border-radius: 5px;
  padding: 5px 10px;
  margin: 5px 0px;

  span {
    color: #1692ab;
  }

  button {
    color: #1692ab;
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
}


.description {
  display: flex;
}

.InfoBtn {
  background-color: black;
  color: white;
  font-size: 8px;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 5px;
  position: relative;

  /* The actual popup */
  .popuptext {
    visibility: hidden;
    width: 160px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -80px;
    font-size: 12px;
  }

  /* Popup arrow */
  .popuptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  /* Toggle this class - hide and show the popup */
  .show {
    visibility: visible;
    -webkit-animation: fadeIn 0.5s;
    animation: fadeIn 0.5s;
  }

  /* Add animation (fade in the popup) */
  @-webkit-keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
}


.Modal {
  z-index: 250;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 95vh;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;

  .ModalHeader {
    width: 95%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #DDDDDD;
    padding: 0px 20px;
    border-bottom: 1px solid #DADADA;

    .ModalTitle {
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        font-size: 18px;
        margin-right: 10px;
      }

      h2 {
        font-size: 18px;
      }
    }

    .ExitBtn {
      background-color: #A4A4A4;
      color: #DDDDDD;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      p {
        margin: 0;
        font-weight: bold;
      }
    }
  }

  .ModalBody {
    width: 99%;
    height: 80%;
    overflow-y: scroll;
    padding-left: 5px;
  }

  .ModalFooter {
    width: 95%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #DDDDDD;
    padding: 0px 20px;
    border-top: 1px solid #DADADA;

    button {
      width: 150px;
      height: 40px;
      background-color: white;
      color: black;
      border-radius: 5px;
      border: 1px solid black;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 625px) {
  .Modal {
    z-index: 250;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    height: 95vh;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    visibility: hidden;

    .ModalHeader {
      width: 95%;
      height: 10%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #DDDDDD;
      padding: 0px 20px;
      border-bottom: 1px solid #DADADA;

      .ModalTitle {
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
          font-size: 18px;
          margin-right: 10px;
        }

        h2 {
          font-size: 18px;
        }
      }

      .ExitBtn {
        background-color: #A4A4A4;
        color: #DDDDDD;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        p {
          margin: 0;
          font-weight: bold;
        }
      }
    }

    .ModalBody {
      width: 99%;
      height: 80%;
      overflow-y: scroll;
      padding-left: 5px;
    }

    .ModalFooter {
      width: 95%;
      height: 10%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #DDDDDD;
      padding: 0px 20px;
      border-top: 1px solid #DADADA;

      button {
        width: 150px;
        height: 40px;
        background-color: white;
        color: black;
        border-radius: 5px;
        border: 1px solid black;
        cursor: pointer;
      }
    }
  }

}

.overlay {
  z-index: 200;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.441);
  width: 100vw;
  height: 100vh;
  visibility: hidden;
}




.TabHeader {
  display: flex;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 40px;
  width: 100%;

  .inputBox {
    position: relative;
    margin-left: 15px;
    margin-right: 15px;

    .inputField {
      height: 40px;
      border: 1px solid #22ABC5;
      border-radius: 5px;
      width: 200px;
      text-align: center;
      outline: none;

      &:focus {
        outline: none;
      }
    }

    span {
      position: absolute;
      top: -5px;
      left: 10px;
      background-color: white;
      font-size: 12px;
      color: #1E8A9E;

    }

    .clickable {
      text-decoration: underline;
      cursor: pointer;
    }


    label {
      position: absolute;
      top: 50%;
      left: 0%;
      transform: translate(-50%, -50%);
      background-color: white;
      font-size: 12px;
    }

    .toggleLabel {
      left : 0%;
    }


    button {
      background-color: #1E8A9E;
      color: white;
      height: 40px;
      padding-left: 10px;
      padding-right: 10px;
      cursor: pointer;
      border: none;
      border-radius: 5px;
      font-weight: bold;
    }

  }
}

.TableContainer {
  .Tab1Table {
    width: 100%;
    border-collapse: separate;
    margin-bottom: 20px;

    thead {
      th {
        background-color: #1E8A9E;
        color: white;
        padding: 10px;
        border: 1px solid #1E8A9E;
      }
    }

    tbody {
      .Empty {
        background-color: #F2FDFF;
        border-bottom: 1px solid grey;
        text-align: left;
        height: 30px;
      }

      .FirstChild {
        input {
          width: 30px;
          height: 30px;
        }
      }

      .TogglingPrime {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .BarsIcon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          cursor: pointer;
          background-color: #1E8A9E;
          color: white;
          border: none;
          font-size: 20px;
          border-radius: 5px;
        }

        input {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}

@media screen and(max-width: 768px) {
  .TableContainer {

  .Tab1Table {
    width: 100%;
    border-collapse: separate;
    margin-bottom: 20px;
    overflow-x: scroll;

    thead {
      th {
        background-color: #1E8A9E;
        color: white;
        padding: 10px;
        border: 1px solid #1E8A9E;
      }
    }

    tbody {
      .Empty {
        background-color: #F2FDFF;
        border-bottom: 1px solid grey;
        text-align: left;
        height: 30px;
      }

      .FirstChild {
        input {
          width: 30px;
          height: 30px;
        }
      }

      .TogglingPrime {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .BarsIcon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          cursor: pointer;
          background-color: #1E8A9E;
          color: white;
          border: none;
          font-size: 20px;
          border-radius: 5px;
        }

        input {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
}

.Loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 150px;

  img {
    width: 120px;
    height: 120px;
    object-fit: contain;
    margin-bottom: 10px;
  }

  .progressBar {
    width: 90%;
    height: 10px;
    background-color: rgb(207, 207, 207);
    border-radius: 30px;
    position: relative;


    .progressBarValue {
      background-color: #1E8A9E;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      border-radius: 30px;
      transition: width 0.3s ease-in-out;
    }
  }
}

.PropsModal {
  z-index: 250;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60vw;
  height: auto;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;

  .ModalHeader {
    width: 60vw;
    height: 30%;
    display: flex;
    align-items: center;
    background-color: #1E8A9E;
    padding: 0;

    .ModalTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10px;

      h2 {
        color: white;
        font-size: 18px;
        font-weight: 300;
      }
    }

    .ExitBtn {
      padding-right: 10px;
      background-color: transparent;
      color: #80d4e2;
      cursor: pointer;
      margin-left: auto;

      p {
        margin: 0;
        font-weight: bold;
        font-size: 20px;
      }

      &:hover {
        color: white;
      }
    }
  }

  .ModalBody {
    width: 60vw;
    height: 70%;
    padding-left: 5px;
    overflow-y: hidden;

    .FormContainer {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .DataFields {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .DataRow {
          width: 80%;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          margin-top: 10px;

          .FieldName {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 30%;
            height: 50px;
            font-weight: bold;
            background-color: #22ABC5;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
            padding-left: 15px;

            h4 {
              margin: 0;
              color: white;
            }
          }

          .FieldValue {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60%;
            height: 50px;
            font-weight: bold;
            background-color: #7FC0CC;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            padding-left: 5px;

            p {
              margin: 0;
              color: white;
            }
          }
        }
      }
    }
  }

}


.TauxFixeModal {
  z-index: 250;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60vw;
  height: auto;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;

  .ModalHeader {
    width: 60vw;
    height: 30%;
    display: flex;
    align-items: center;
    background-color: #1E8A9E;
    padding: 0;

    .ModalTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10px;

      h2 {
        color: white;
        font-size: 18px;
        font-weight: 300;
      }
    }

    .ExitBtn {
      padding-right: 10px;
      background-color: transparent;
      color: #80d4e2;
      cursor: pointer;
      margin-left: auto;

      p {
        margin: 0;
        font-weight: bold;
        font-size: 20px;
      }

      &:hover {
        color: white;
      }
    }
  }

  .ModalBody {
    width: 60vw;
    height: 70%;
    padding-left: 5px;
    overflow-y: hidden;

    .FormContainer {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;


      .InputBox {
        width: 80%;
        height: 50px;
        position: relative;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #1E8A9E;
        border-radius: 5px;

        label {
          position: absolute;
          top: -8px;
          left: 30px;
          background-color: white;
          color: #1E8A9E;
          font-size: 14px;
          padding: 0 5px;
        }

        input {
          width: 100%;
          height: 50px;
          border: none;
          outline: none;
          font-size: 16px;
          background-color: transparent;
          text-align: center;
        }
      }

      .ActionBar {
        margin-bottom: 20px;
        width: 80%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        .Btn {
          width: 40%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #1E8A9E;
          color: white;
          font-weight: bold;
          border-radius: 5px;
          border: none;
          cursor: pointer;
          transition: background-color 0.3s ease-in-out;

          &:hover {
            background-color: #24a6bd;
          }
        }
      }
    }
  }

}

.TauxAssuranceModal {
  z-index: 250;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60vw;
  height: auto;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;

  .ModalHeader {
    width: 60vw;
    height: 30%;
    display: flex;
    align-items: center;
    background-color: #1E8A9E;
    padding: 0;

    .ModalTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10px;

      h2 {
        color: white;
        font-size: 18px;
        font-weight: 300;
      }
    }

    .ExitBtn {
      padding-right: 10px;
      background-color: transparent;
      color: #80d4e2;
      cursor: pointer;
      margin-left: auto;

      p {
        margin: 0;
        font-weight: bold;
        font-size: 20px;
      }

      &:hover {
        color: white;
      }
    }
  }

  .ModalBody {
    width: 60vw;
    height: 70%;
    padding-left: 5px;
    overflow-y: hidden;

    .FormContainer {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;


      .InputBox {
        width: 80%;
        height: 50px;
        position: relative;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #1E8A9E;
        border-radius: 5px;

        label {
          position: absolute;
          top: -8px;
          left: 30px;
          background-color: white;
          color: #1E8A9E;
          font-size: 14px;
          padding: 0 5px;
        }

        input {
          width: 100%;
          height: 50px;
          border: none;
          outline: none;
          font-size: 16px;
          background-color: transparent;
          text-align: center;
        }
      }

      .ActionBar {
        margin-bottom: 20px;
        width: 80%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        .Btn {
          width: 40%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #1E8A9E;
          color: white;
          font-weight: bold;
          border-radius: 5px;
          border: none;
          cursor: pointer;
          transition: background-color 0.3s ease-in-out;

          &:hover {
            background-color: #24a6bd;
          }
        }
      }
    }
  }

}

.CoutTotalModal {
  z-index: 250;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60vw;
  height: auto;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;

  .ModalHeader {
    width: 60vw;
    height: 30%;
    display: flex;
    align-items: center;
    background-color: #1E8A9E;
    padding: 0;

    .ModalTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10px;

      h2 {
        color: white;
        font-size: 18px;
        font-weight: 300;
      }
    }

    .ExitBtn {
      padding-right: 10px;
      background-color: transparent;
      color: #80d4e2;
      cursor: pointer;
      margin-left: auto;

      p {
        margin: 0;
        font-weight: bold;
        font-size: 20px;
      }

      &:hover {
        color: white;
      }
    }
  }

  .ModalBody {
    width: 60vw;
    height: 70%;
    padding-left: 5px;
    overflow-y: hidden;

    .FormContainer {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .DataRow {
        width: 80%;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-top: 10px;

        .FieldName {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 30%;
          height: 50px;
          font-weight: bold;
          background-color: #22ABC5;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          padding-left: 15px;

          h4 {
            margin: 0;
            color: white;
          }
        }

        .FieldValue {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60%;
          height: 50px;
          font-weight: bold;
          background-color: #7FC0CC;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
          padding-left: 5px;

          p {
            margin: 0;
            color: white;
          }
        }
      }


      .DataFields {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .DataRow {
          width: 80%;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          margin-top: 10px;

          .FieldName {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 30%;
            height: 50px;
            font-weight: bold;
            background-color: #22ABC5;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
            padding-left: 15px;

            h4 {
              margin: 0;
              color: white;
            }
          }

          .FieldValue {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60%;
            height: 50px;
            font-weight: bold;
            background-color: #7FC0CC;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            padding-left: 5px;

            p {
              margin: 0;
              color: white;
            }
          }
        }


        .Somme {
          margin-top: 40px;

          .FieldValue {
            background-color: #707070;
          }
        }
      }
    }
  }

}


.PrimeAssuranceModal {
  z-index: 250;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60vw;
  height: auto;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;

  .ModalHeader {
    width: 60vw;
    height: 30%;
    display: flex;
    align-items: center;
    background-color: #1E8A9E;
    padding: 0;

    .ModalTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10px;

      h2 {
        color: white;
        font-size: 18px;
        font-weight: 300;
      }
    }

    .ExitBtn {
      padding-right: 10px;
      background-color: transparent;
      color: #80d4e2;
      cursor: pointer;
      margin-left: auto;

      p {
        margin: 0;
        font-weight: bold;
        font-size: 20px;
      }

      &:hover {
        color: white;
      }
    }
  }

  .ModalBody {
    width: 60vw;
    height: 70%;
    padding-left: 5px;
    overflow-y: hidden;

    .FormContainer {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;



      .InputBox {
        width: 80%;
        height: 50px;
        position: relative;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #1E8A9E;
        border-radius: 5px;

        label {
          position: absolute;
          top: -8px;
          left: 30px;
          background-color: white;
          color: #1E8A9E;
          font-size: 14px;
          padding: 0 5px;
        }

        select {
          width: 100%;
          height: 50px;
          border: none;
          outline: none;
          font-size: 16px;
          background-color: transparent;
          text-align: center;
        }
      }

      .ActionBar {
        margin-bottom: 20px;
        width: 80%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        .Btn {
          width: 40%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #1E8A9E;
          color: white;
          font-weight: bold;
          border-radius: 5px;
          border: none;
          cursor: pointer;
          transition: background-color 0.3s ease-in-out;

          &:hover {
            background-color: #24a6bd;
          }
        }
      }
    }
  }

}

.CoutProjetModal {
  z-index: 250;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60vw;
  height: auto;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;

  .ModalHeader {
    width: 60vw;
    height: 30%;
    display: flex;
    align-items: center;
    background-color: #1E8A9E;
    padding: 0;

    .ModalTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10px;

      h2 {
        color: white;
        font-size: 18px;
        font-weight: 300;
      }
    }

    .ExitBtn {
      padding-right: 10px;
      background-color: transparent;
      color: #80d4e2;
      cursor: pointer;
      margin-left: auto;

      p {
        margin: 0;
        font-weight: bold;
        font-size: 20px;
      }

      &:hover {
        color: white;
      }
    }
  }

  .ModalBody {
    width: 60vw;
    height: 70%;
    padding-left: 5px;
    overflow-y: hidden;

    .FormContainer {
      padding-left: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      .FormCol-6 {
        width: 50%;
        .InputBox {
          width: 80%;
          height: 50px;
          position: relative;
          margin-bottom: 20px;
          margin-top: 20px;
          border: 1px solid #1E8A9E;
          border-radius: 5px;
  
          label {
            position: absolute;
            top: -8px;
            left: 30px;
            background-color: white;
            color: #1E8A9E;
            font-size: 14px;
            padding: 0 5px;
          }
  
          input {
            width: 100%;
            height: 50px;
            border: none;
            outline: none;
            font-size: 16px;
            background-color: transparent;
            text-align: center;
          }

          input:disabled {
            background-color: #e9ecef !important;
            opacity: 1;
          }
        }
        .reload {
          position: relative;
          top: -15px;
          .reloadSingle {
            height: 2em;
            padding: .25em;
            width: 2em;
            position: absolute;
            right: 43px;
            cursor: pointer;
            z-index: 10;
            top: -50px;
            &:before, &:after {
              content: '';
              display: block;
            }
            &:before {
              border-color: transparent #4dbed3 #4dbed3 #4dbed3;
              border-radius: 50%;
              border-style: solid;
              border-width: .125em;
              height: 0.8em;
              width: 0.8em;
              -webkit-transform: rotate(45deg);
              transform: rotate(45deg);
            }
            &:after {
              border-color: transparent transparent transparent #4dbed3;
              border-style: solid;
              border-width: .3125em 0 .3125em .5em;
              height: 0;
              position: absolute;
              top: 0;
              left: 30%;
              width: 0;
            }
          }
          .simple-icon-reload {
            color: rgb(51, 180, 205);
            position: absolute;
            right: 20px;
            z-index: 10;
            top: -60px;
          }
        }
      }

    }
  }

  .ModalFooter {
    border-top: none !important;
    background-color: white !important;
    .ActionBar {
        margin-bottom: 20px;
        width: 80%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        .Btn {
          width: 40%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #1E8A9E;
          color: white;
          font-weight: bold;
          border-radius: 5px;
          border: none;
          cursor: pointer;
          transition: background-color 0.3s ease-in-out;

          &:hover {
            background-color: #24a6bd;
          }
        }
      }
  }

}


.FaisabiliteModal {
  z-index: 250;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60vw;
  height: auto;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;

  .ModalHeader {
    width: 60vw;
    height: 30%;
    display: flex;
    align-items: center;
    background-color: #1E8A9E;
    padding: 0;

    .ModalTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10px;

      h2 {
        color: white;
        font-size: 18px;
        font-weight: 300;
      }
    }

    .ExitBtn {
      padding-right: 10px;
      background-color: transparent;
      color: #80d4e2;
      cursor: pointer;
      margin-left: auto;

      p {
        margin: 0;
        font-weight: bold;
        font-size: 20px;
      }

      &:hover {
        color: white;
      }
    }
  }

  .ModalBody {
    width: 60vw;
    height: 70%;
    padding-left: 5px;
    overflow-y: hidden;

    .FormContainer {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      table {
        width: 80%;
        margin-top: 20px;
        margin-bottom: 20px;
        border: none;
        background-color: white;
        overflow: hidden;

        th {
          background-color: #1E8A9E;
          color: white;
          font-weight: bold;
          font-size: 14px;
          padding: 5px;
          text-align: center;
          height: 40px;
          border: none;
          border-top-left-radius: 15px;
          border-top-right-radius: 15px;
          text-align: center !important;
        }

        .vide {
          background-color: white;
          color: white;
          border: none;
        }

        td {
          border: 2px solid white;
          padding: 5px;
          text-align: center;
          height: 40px;
          background-color: #7FC0CC;
          color: white;
        }

        .FirstField {
          background-color: #1E8A9E;
          color: white;
          border-top-left-radius: 15px;
          border-bottom-left-radius: 15px;
        }
      }
    }
  }

}


.AssuranceDelegueeModal {
  z-index: 250;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60vw;
  height: auto;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;
  overflow-y: scroll;
  max-height: 80vh;

  .ModalHeader {
    width: 60vw;
    height: 30%;
    display: flex;
    align-items: center;
    background-color: #1E8A9E;
    padding: 0;

    .ModalTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10px;

      h2 {
        color: white;
        font-size: 18px;
        font-weight: 300;
      }
    }

    .ExitBtn {
      padding-right: 10px;
      background-color: transparent;
      color: #80d4e2;
      cursor: pointer;
      margin-left: auto;
      margin-right: 20px;

      p {
        margin: 0;
        font-weight: bold;
        font-size: 20px;
      }

      &:hover {
        color: white;
      }
    }
  }

  .ModalBody {
    width: 60vw;
    height: 70%;
    padding-left: 5px;
    overflow-y: hidden;

    .FormContainer {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 95%;

      .ToggleBtn {
        width: 100%;
        height: 50px;
        background-color: transparent;
        color: #1E8A9E;
        cursor: pointer;
        border: none;
        text-align: left;

        font-size: 18px;
      }

      #collapse-2 {
        width: 100%;
      }

      #collapse-1 {
        width: 100%;
      }

      .CollapseCard {
        width: 100%;

        .inputBox {
          position: relative;
          width: 100%;
          height: 50px;
          border: 1px solid #1E8A9E;

          select {
            border: none;
            outline: none;
            background: transparent;
            width: 100%;
            height: 100%;
            text-align: left;
          }

          label {
            position: absolute;
            background-color: white;
            top: -5px;
            left: 20px;
            font-size: 12px;
            color: #1E8A9E;
            padding: 0 5px;
          }
        }
      }

      .FormSelection {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .checkboxContainer {
          margin-bottom: 10px;

          input {
            width: 20px;
            height: 20px;
          }
        }

        .InputsGrid {
          margin-top: 20px;
          width: 100%;

          .Row {
            display: flex;
            align-items: center;
            gap: 20px;
            width: 100%;


            .inputBox {
              position: relative;
              width: 50%;
              height: 50px;
              border: 1px solid #1E8A9E;
              margin-bottom: 20px;

              select {
                border: none;
                outline: none;
                background: transparent;
                width: 100%;
                height: 100%;
                text-align: left;
              }

              label {
                position: absolute;
                background-color: white;
                top: -5px;
                left: 20px;
                font-size: 12px;
                color: #1E8A9E;
                padding: 0 5px;
              }
            }
          }
        }
      }

      .updateBtn {
        margin-left: auto;
        background-color: #1E8A9E;
        color: white;
        border: none;
        border-radius: 5px;
        padding: 10px 20px;
        cursor: pointer;
      }

      table {
        width: 80%;
        margin-top: 20px;
        margin-bottom: 20px;
        background-color: white;
        overflow: hidden;
        border-collapse: collapse;

        th {
          background-color: #1E8A9E;
          color: white;
          font-weight: bold;
          font-size: 14px;
          padding: 5px;
          text-align: center;
          height: 40px;
          text-align: center !important;
        }



        td {
          padding: 5px;
          text-align: center;
          height: 40px;
          background-color: transparent;
        }


        tbody tr {
          border-bottom: 1px solid #DEE2E6;
          background-color: white;
        }

        tbody tr:nth-child(even) {
          background-color: #EEFCFF;
        }
      }
    }
  }

}


@media screen and(max-width:768px) {
    
  .PropsModal {
    z-index: 250;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    height: auto;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    visibility: hidden;

    .ModalHeader {
      width: 100%;
      height: 30%;
      display: flex;
      align-items: center;
      background-color: #1E8A9E;
      padding: 0;

      .ModalTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 10px;

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 300;
        }
      }

      .ExitBtn {
        padding-right: 10px;
        background-color: transparent;
        color: #80d4e2;
        cursor: pointer;
        margin-left: auto;

        p {
          margin: 0;
          font-weight: bold;
          font-size: 20px;
        }

        &:hover {
          color: white;
        }
      }
    }

    .ModalBody {
      width: 100%;
      height: 70%;
      padding-left: 5px;
      overflow-y: hidden;

      .FormContainer {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .DataFields {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .DataRow {
            width: 80%;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            margin-top: 10px;

            .FieldName {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              width: 30%;
              height: 50px;
              font-weight: bold;
              background-color: #22ABC5;
              border-top-left-radius: 10px;
              border-bottom-left-radius: 10px;
              padding-left: 15px;

              h4 {
                margin: 0;
                color: white;
              }
            }

            .FieldValue {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 60%;
              height: 50px;
              font-weight: bold;
              background-color: #7FC0CC;
              border-top-right-radius: 10px;
              border-bottom-right-radius: 10px;
              padding-left: 5px;

              p {
                margin: 0;
                color: white;
              }
            }
          }
        }
      }
    }

  }

  .TauxFixeModal {
    z-index: 250;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: auto;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    visibility: hidden;

    .ModalHeader {
      width: 100%;
      height: 30%;
      display: flex;
      align-items: center;
      background-color: #1E8A9E;
      padding: 0;

      .ModalTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 10px;

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 300;
        }
      }

      .ExitBtn {
        padding-right: 10px;
        background-color: transparent;
        color: #80d4e2;
        cursor: pointer;
        margin-left: auto;

        p {
          margin: 0;
          font-weight: bold;
          font-size: 20px;
        }

        &:hover {
          color: white;
        }
      }
    }

    .ModalBody {
      width: 100%;
      height: 70%;
      padding-left: 5px;
      overflow-y: hidden;

      .FormContainer {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;


        .InputBox {
          width: 80%;
          height: 50px;
          position: relative;
          margin-bottom: 20px;
          margin-top: 20px;
          border: 1px solid #1E8A9E;
          border-radius: 5px;

          label {
            position: absolute;
            top: -8px;
            left: 30px;
            background-color: white;
            color: #1E8A9E;
            font-size: 14px;
            padding: 0 5px;
          }

          input {
            width: 100%;
            height: 50px;
            border: none;
            outline: none;
            font-size: 16px;
            background-color: transparent;
            text-align: center;
          }
        }

        .ActionBar {
          margin-bottom: 20px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;

          .Btn {
            width: 40%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #1E8A9E;
            color: white;
            font-weight: bold;
            border-radius: 5px;
            border: none;
            cursor: pointer;
            transition: background-color 0.3s ease-in-out;

            &:hover {
              background-color: #24a6bd;
            }
          }
        }
      }
    }

  }

  .TauxAssuranceModal {
    z-index: 250;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: auto;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    visibility: hidden;

    .ModalHeader {
      width: 100%;
      height: 30%;
      display: flex;
      align-items: center;
      background-color: #1E8A9E;
      padding: 0;

      .ModalTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 10px;

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 300;
        }
      }

      .ExitBtn {
        padding-right: 10px;
        background-color: transparent;
        color: #80d4e2;
        cursor: pointer;
        margin-left: auto;

        p {
          margin: 0;
          font-weight: bold;
          font-size: 20px;
        }

        &:hover {
          color: white;
        }
      }
    }

    .ModalBody {
      width: 100%;
      height: 70%;
      padding-left: 5px;
      overflow-y: hidden;

      .FormContainer {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;


        .InputBox {
          width: 80%;
          height: 50px;
          position: relative;
          margin-bottom: 20px;
          margin-top: 20px;
          border: 1px solid #1E8A9E;
          border-radius: 5px;

          label {
            position: absolute;
            top: -8px;
            left: 30px;
            background-color: white;
            color: #1E8A9E;
            font-size: 14px;
            padding: 0 5px;
          }

          input {
            width: 100%;
            height: 50px;
            border: none;
            outline: none;
            font-size: 16px;
            background-color: transparent;
            text-align: center;
          }
        }

        .ActionBar {
          margin-bottom: 20px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;

          .Btn {
            width: 40%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #1E8A9E;
            color: white;
            font-weight: bold;
            border-radius: 5px;
            border: none;
            cursor: pointer;
            transition: background-color 0.3s ease-in-out;

            &:hover {
              background-color: #24a6bd;
            }
          }
        }
      }
    }

  }

  .CoutTotalModal {
    z-index: 250;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: auto;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    visibility: hidden;

    .ModalHeader {
      width: 100%;
      height: 30%;
      display: flex;
      align-items: center;
      background-color: #1E8A9E;
      padding: 0;

      .ModalTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 10px;

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 300;
        }
      }

      .ExitBtn {
        padding-right: 10px;
        background-color: transparent;
        color: #80d4e2;
        cursor: pointer;
        margin-left: auto;

        p {
          margin: 0;
          font-weight: bold;
          font-size: 20px;
        }

        &:hover {
          color: white;
        }
      }
    }

    .ModalBody {
      width: 100%;
      height: 70%;
      padding-left: 5px;
      overflow-y: hidden;

      .FormContainer {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .DataRow {
          width: 80%;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          margin-top: 10px;

          .FieldName {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 30%;
            height: 50px;
            font-weight: bold;
            background-color: #22ABC5;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
            padding-left: 15px;

            h4 {
              margin: 0;
              color: white;
            }
          }

          .FieldValue {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60%;
            height: 50px;
            font-weight: bold;
            background-color: #7FC0CC;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            padding-left: 5px;

            p {
              margin: 0;
              color: white;
            }
          }
        }


        .DataFields {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .DataRow {
            width: 80%;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            margin-top: 10px;

            .FieldName {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              width: 30%;
              height: 50px;
              font-weight: bold;
              background-color: #22ABC5;
              border-top-left-radius: 10px;
              border-bottom-left-radius: 10px;
              padding-left: 15px;

              h4 {
                margin: 0;
                color: white;
              }
            }

            .FieldValue {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 60%;
              height: 50px;
              font-weight: bold;
              background-color: #7FC0CC;
              border-top-right-radius: 10px;
              border-bottom-right-radius: 10px;
              padding-left: 5px;

              p {
                margin: 0;
                color: white;
              }
            }
          }


          .Somme {
            margin-top: 40px;

            .FieldValue {
              background-color: #707070;
            }
          }
        }
      }
    }

  }

  .PrimeAssuranceModal {
    z-index: 250;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: auto;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    visibility: hidden;

    .ModalHeader {
      width: 100%;
      height: 30%;
      display: flex;
      align-items: center;
      background-color: #1E8A9E;
      padding: 0;

      .ModalTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 10px;

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 300;
        }
      }

      .ExitBtn {
        padding-right: 10px;
        background-color: transparent;
        color: #80d4e2;
        cursor: pointer;
        margin-left: auto;

        p {
          margin: 0;
          font-weight: bold;
          font-size: 20px;
        }

        &:hover {
          color: white;
        }
      }
    }

    .ModalBody {
      width: 100%;
      height: 70%;
      padding-left: 5px;
      overflow-y: hidden;

      .FormContainer {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;



        .InputBox {
          width: 80%;
          height: 50px;
          position: relative;
          margin-bottom: 20px;
          margin-top: 20px;
          border: 1px solid #1E8A9E;
          border-radius: 5px;

          label {
            position: absolute;
            top: -8px;
            left: 30px;
            background-color: white;
            color: #1E8A9E;
            font-size: 14px;
            padding: 0 5px;
          }

          select {
            width: 100%;
            height: 50px;
            border: none;
            outline: none;
            font-size: 16px;
            background-color: transparent;
            text-align: center;
          }
        }

        .ActionBar {
          margin-bottom: 20px;
          width: 80%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;

          .Btn {
            width: 40%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #1E8A9E;
            color: white;
            font-weight: bold;
            border-radius: 5px;
            border: none;
            cursor: pointer;
            transition: background-color 0.3s ease-in-out;

            &:hover {
              background-color: #24a6bd;
            }
          }
        }
      }
    }

  }

  .FaisabiliteModal {
    z-index: 250;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: auto;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    visibility: hidden;

    .ModalHeader {
      width: 100%;
      height: 30%;
      display: flex;
      align-items: center;
      background-color: #1E8A9E;
      padding: 0;

      .ModalTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 10px;

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 300;
        }
      }

      .ExitBtn {
        padding-right: 10px;
        background-color: transparent;
        color: #80d4e2;
        cursor: pointer;
        margin-left: auto;

        p {
          margin: 0;
          font-weight: bold;
          font-size: 20px;
        }

        &:hover {
          color: white;
        }
      }
    }

    .ModalBody {
      width: 100%;
      height: 70%;
      padding-left: 5px;
      overflow-y: hidden;

      .FormContainer {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        table {
          width: 80%;
          margin-top: 20px;
          margin-bottom: 20px;
          border: none;
          background-color: white;
          overflow: hidden;

          th {
            background-color: #1E8A9E;
            color: white;
            font-weight: bold;
            font-size: 14px;
            padding: 5px;
            text-align: center;
            height: 40px;
            border: none;
            border-top-left-radius: 15px;
            border-top-right-radius: 15px;
            text-align: center !important;
          }

          .vide {
            background-color: white;
            color: white;
            border: none;
          }

          td {
            border: 2px solid white;
            padding: 5px;
            text-align: center;
            height: 40px;
            background-color: #7FC0CC;
            color: white;
          }

          .FirstField {
            background-color: #1E8A9E;
            color: white;
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
          }
        }
      }
    }

  }
  .AssuranceDelegueeModal {
    z-index: 250;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: auto;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    visibility: hidden;
    overflow-y: scroll;
    max-height: 80vh;

    .ModalHeader {
      width: 100%;
      height: 30%;
      display: flex;
      align-items: center;
      background-color: #1E8A9E;
      padding: 0;

      .ModalTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 10px;

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 300;
        }
      }

      .ExitBtn {
        padding-right: 10px;
        background-color: transparent;
        color: #80d4e2;
        cursor: pointer;
        margin-left: auto;
        margin-right: 20px;

        p {
          margin: 0;
          font-weight: bold;
          font-size: 20px;
        }

        &:hover {
          color: white;
        }
      }
    }

    .ModalBody {
      width: 100%;
      height: 70%;
      padding-left: 5px;
      overflow-y: hidden;

      .FormContainer {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 95%;

        .ToggleBtn {
          width: 100%;
          height: 50px;
          background-color: transparent;
          color: #1E8A9E;
          cursor: pointer;
          border: none;
          text-align: left;

          font-size: 18px;
        }

        #collapse-2 {
          width: 100%;
        }

        #collapse-1 {
          width: 100%;
        }

        .CollapseCard {
          width: 100%;

          .inputBox {
            position: relative;
            width: 100%;
            height: 50px;
            border: 1px solid #1E8A9E;

            select {
              border: none;
              outline: none;
              background: transparent;
              width: 100%;
              height: 100%;
              text-align: left;
            }

            label {
              position: absolute;
              background-color: white;
              top: -5px;
              left: 20px;
              font-size: 12px;
              color: #1E8A9E;
              padding: 0 5px;
            }
          }
        }

        .FormSelection {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          .checkboxContainer {
            margin-bottom: 10px;

            input {
              width: 20px;
              height: 20px;
            }
          }

          .InputsGrid {
            margin-top: 20px;
            width: 100%;

            .Row {
              display: flex;
              align-items: center;
              gap: 20px;
              width: 100%;


              .inputBox {
                position: relative;
                width: 50%;
                height: 50px;
                border: 1px solid #1E8A9E;
                margin-bottom: 20px;

                select {
                  border: none;
                  outline: none;
                  background: transparent;
                  width: 100%;
                  height: 100%;
                  text-align: left;
                }

                label {
                  position: absolute;
                  background-color: white;
                  top: -5px;
                  left: 20px;
                  font-size: 12px;
                  color: #1E8A9E;
                  padding: 0 5px;
                }
              }
            }
          }
        }

        .updateBtn {
          margin-left: auto;
          background-color: #1E8A9E;
          color: white;
          border: none;
          border-radius: 5px;
          padding: 10px 20px;
          cursor: pointer;
        }

        table {
          width: 80%;
          margin-top: 20px;
          margin-bottom: 20px;
          background-color: white;
          overflow: hidden;
          border-collapse: collapse;

          th {
            background-color: #1E8A9E;
            color: white;
            font-weight: bold;
            font-size: 14px;
            padding: 5px;
            text-align: center;
            height: 40px;
            text-align: center !important;
          }



          td {
            padding: 5px;
            text-align: center;
            height: 40px;
            background-color: transparent;
          }


          tbody tr {
            border-bottom: 1px solid #DEE2E6;
            background-color: white;
          }

          tbody tr:nth-child(even) {
            background-color: #EEFCFF;
          }
        }
      }
    }

  }

}



.clickable {
  text-decoration: underline;
  cursor: pointer;
}


.show {
  visibility: visible;
}

.hiddenCollapse {
  display: none;
}


.Spinner {
  border-top: 1px solid #1E8A9E;
  border-left: 1px solid #1E8A9E;
  border-right: 1px solid #1E8A9E;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg)
  }
}


.options-td {
  padding: 5px 10px;
  font-weight: bold;
}


@media screen and (max-width: 768px) {
  .Container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .Card {
      width: 90%;
      padding: 15px;
      margin: 10px 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      .left {
        width: 100%;

        .Top {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 30px;

          .ImageCarousel {
            position: relative;
            margin-right: 15px;
            width: 100%;
            margin-bottom: 20px;

            .nbJours {
              z-index: 1;
              position: absolute;
              top: 0;
              left: 0;
              width: 60px;
              height: 60px;
              background-color: rgb(255, 140, 0);
              border-bottom-right-radius: 10px;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 24px;
            }

            .nbImages {
              z-index: 1;
              position: absolute;
              top: 0;
              right: 0;
              width: 60px;
              height: 60px;
              background-color: rgb(255, 140, 0);
              border-bottom-left-radius: 10px;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 24px;

              .icon {
                margin-left: 5px;
              }
            }

            .Slider {
              z-index: 0;
              overflow: hidden;
            }
          }

          .Infos {
            width: 100%;

            .Title {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              margin-bottom: 10px;

              .homeIcon {
                margin-right: 10px;
                font-size: 24px;
                color: rgb(34, 171, 197);
              }

              h2 {
                font-size: 26px;
                font-weight: 600;
                margin-right: 10px;
                color: rgb(34, 171, 197);
              }

              p {
                font-size: 18px;
                font-weight: 600;
                color: rgb(34, 171, 197);
              }
            }

            .TypePublish {
              display: flex;
              flex-direction:column;
              align-items: center;
              justify-content:space-between;
              background-color: #e8e8e8;
              max-width: 100%;
              height: auto;
              padding: 5px 10px;
              font-family: "Seoge";
              border-radius: 7px;
              margin-bottom: 10px;

              .publisherInfoBox {
                display:flex;
                align-items: center;
                justify-content: center;

                p {
                  font-size: 15px;
                  margin-left: 10px;
                }
              }

              .YesNoBox {
                input {
                  width: 10px;
                  height: 10px;
                }

                p {
                  margin: 0;
                  margin-right: 10px;
                  font-size: 15px;
                }
              }
              
            }

            .DescContainer {
              margin-bottom: 20px;
              width: 100%;

              p {
                font-size: 16px;
                line-height: 25px;
                height: 150px;
                overflow: hidden;
                text-align: justify;
              }
            }

            .BadgesList {
              display: flex;
              flex-wrap: wrap;
              align-items: center;

              .badge {
                display: flex;
                align-items: center;
                background-color: #e8e8e8;
                padding: 0px 10px;
                margin-right: 10px;
                margin-bottom: 10px;
                height: 30px;

                p {
                  font-size: 14px;
                  margin-left: 5px;
                }
              }
            }
          }
        }

        .Bottom {
          // .Row {
          //   .BoxContainer {
          //     display: flex;
          //     flex-wrap: wrap;
          //     justify-content: center;
          //     margin-bottom: 20px;

          //     .Box {
          //       display: flex;
          //       align-items: center;
          //       justify-content: flex-start;
          //       flex-direction: column;
          //       width: 40%;
          //       border-radius: 5px;
          //       padding: 10px;
          //       margin: 0 10px;
          //       text-align: center;

          //       .icon {
          //         font-size: 20px;
          //         margin-bottom: 10px;
          //         height: 50px;
          //         color:rgb(255, 140, 0);
          //       }

          //       h2 {
          //         font-size: 18px;
          //         font-weight: bold;
          //         margin-bottom: 5px;
          //         color:rgb(34, 171, 197);
          //       }

          //       p {
          //         font-size: 15px;
          //         font-weight: bold;
          //         margin-bottom: 5px;
          //         color:rgb(34, 171, 197);
          //       }

          //       button {
          //         background-color: rgb(255, 140, 0);
          //         color: white;
          //         border: none;
          //         border-radius: 5px;
          //         font-size: 15px;
          //         font-weight: bold;
          //         cursor: pointer;
          //         padding: 5px 10px;
          //         margin-top: 10px;
          //       }

          //       .OldPrice {
          //         text-decoration: line-through;
          //       }

          //       .NewPrice {
          //         span {
          //             color: rgb(0, 180, 0);
          //         }
          //       }

          //       .LogoIcons {
          //         display: flex;
          //         flex-wrap: wrap;
          //       }
          //     }
          //   }
          // }

          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .Bottom-left {
            width: 100%;

            .LogoIcons {
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              justify-content: center;
              gap: 5px;
            }
          }

          .Bottom-right {
            width: 100%;

            .BoxContainer {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              align-items: center;
              gap: 10px;

              .Box {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-direction: column;
                border-radius: 5px;
                padding: 10px;
                margin: 0 10px;
                text-align: center;

                .icon {
                  font-size: 20px;
                  height: 20px;
                  color: rgb(255, 140, 0);
                  margin-bottom: 10px;
                }

                h2 {
                  font-size: 15px;
                  font-weight: bold;
                  color: rgb(34, 171, 197);
                  margin: 0;
                }

                p {
                  font-size: 15px;
                  font-weight: bold;
                  color: rgb(34, 171, 197);
                  margin: 0;
                }

                button {
                  background-color: rgb(255, 140, 0);
                  color: white;
                  border: none;
                  border-radius: 5px;
                  font-size: 14px;
                  cursor: pointer;
                  padding: 7px 12px;
                  margin-top: 10px;

                }

                .btn-propositions {
                  background-color: #22abc5 !important;
                }

                .OldPrice {
                  text-decoration: line-through;
                }

                .NewPrice {
                  span {
                    color: rgb(0, 180, 0);
                  }
                }

                .LogoIcons {
                  display: flex;
                  flex-wrap: wrap;
                }
              }
            }


          }
        }

        .PropositionsContainer {
          height: 400px;
          max-width: 100%;
          box-shadow: 0 0 5px #c9c9c9 !important;
        }
      }

      .right {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        h2 {
          color: rgb(255, 140, 0);
          font-weight: bold;
          font-size: 30px;
          margin-bottom: 20px;
        }

        p {
          font-size: 15px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        .PlusInfo {
          background-color: rgb(255, 140, 0);
          color: white;
          border: none;
          border-radius: 5px;
          font-size: 15px;
          font-weight: bold;
          cursor: pointer;
          padding: 5px 10px;
          margin-top: 10px;
        }

        .CheckboxContainer {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 20px;

          .Checkbox {
            margin-bottom: 10px;
            width: 15px;
            height: 15px;

            input {
              margin-right: 10px;
            }
          }

          label {
            font-size: 15px;
            font-weight: bold;
            padding: 0;
            margin: 0;
          }
        }
      }
    }
  }


  .PropisitionSection {
    width: 100vw;
    margin: auto;
    overflow-x: scroll;
  }

  .tabs {
    overflow-x: scroll !important;
  }
}

.GreenStyle {
  background-color: green !important;
  color: white;
}

.RedStyle {
  background-color: red !important;
  color: white;
}

</style>